var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/app/index.ts
import { z as z2 } from "zod";

// src/app/auth-exceptions.enum.ts
import { z } from "zod";
var AuthExceptionValues = [
  "TOKEN_EXPIRED",
  "INVALID_TOKEN",
  "UNAUTHORIZED"
];
var AuthExceptionEnumObj = z.enum(AuthExceptionValues);
var EAuthExceptionEnum = AuthExceptionEnumObj.enum;

// src/app/index.ts
var AppNameValues = [
  "FIT",
  "RYC",
  "ADDON",
  "MEMBERS",
  "SHOULDERS_MELT_MOBILIZE",
  "RYC_DOWNLOADABLE",
  "ROOTED_RECOVERY",
  "OPEN_CLINIC",
  "CHALLENGE_YOUR_CORE"
];
var AppNameEnumObj = z2.enum(AppNameValues);
var EAppNameEnum = AppNameEnumObj.enum;
var AppKeySchema = z2.string();
var sanitizeAppName = /* @__PURE__ */ __name((appName) => {
  return appName.replace(/<[^>]*>/g, "").replace(/[®™©]/g, "").replace(/[^a-zA-Z0-9\s]/g, " ").replace(/\s+/g, " ").trim().toUpperCase().replace(/\s+/g, "_");
}, "sanitizeAppName");
var AppSpaceNameValues = [
  "ADDON",
  "CHALLENGE_YOUR_CORE",
  "FIT",
  "HELP_CENTER",
  "MEMBERS",
  "NOTIFICATION",
  "OPEN_CLINIC",
  "ROOTED_RECOVERY",
  "RYC",
  "RYC_DOWNLOADABLE",
  "SHOULDERS_MELT_MOBILIZE"
];
var AppSpaceNameEnumObj = z2.enum(AppSpaceNameValues);
var EAppSpaceNameEnum = AppSpaceNameEnumObj.enum;

// src/auth/provider.ts
import { z as z3 } from "zod";
var AuthProviderEnumObj = z3.enum([
  "wordpress",
  "supabase"
]);
var AuthProviderEnum = AuthProviderEnumObj.enum;
var AUTH_PROVIDER_HEADER = "x-auth-provider";
var DEFAULT_AUTH_PROVIDER = "wordpress";
var FEATURE_FLAGS_STORAGE_KEY = "featureFlags";
var USE_SUPABASE_AUTH_FLAG_KEY = "USE_SUPABASE_AUTH";

// src/auth/sso-context.ts
var EAuthType = /* @__PURE__ */ function(EAuthType2) {
  EAuthType2["supabase"] = "supabase";
  EAuthType2["wordpress"] = "wordpress";
  return EAuthType2;
}({});
var SSO_CONTEXT_PARAM = "auth_type";
var LC_SSO_CONTEXT_VALUE = "supabase";
var LC_SSO_CONTEXT_QUERY = `${SSO_CONTEXT_PARAM}=${LC_SSO_CONTEXT_VALUE}`;

// src/auth/sb-database.types.ts
var Constants = {
  public: {
    Enums: {
      status_type_enum: [
        "active",
        "inactive"
      ]
    }
  }
};

// src/auth/ott.ts
import { z as z4 } from "zod";
var TargetAppEnum = z4.enum([
  EAppNameEnum.FIT,
  EAppNameEnum.RYC,
  EAppNameEnum.ADDON,
  EAppNameEnum.MEMBERS,
  "HELP_CENTER",
  "DASHBOARD"
]);
var ETargetApp = TargetAppEnum.enum;
var GenerateOttSchema = z4.object({
  email: z4.string().email(),
  targetApp: TargetAppEnum,
  redirectUrl: z4.string().url()
});
var GenerateOttUserSchema = z4.object({
  targetApp: TargetAppEnum,
  redirectUrl: z4.string().url()
});
var ValidateOttSchema = z4.object({
  token: z4.string().uuid()
});
var ConsumeOttSchema = z4.object({
  token: z4.string().uuid()
});

// src/auth/magic-link.ts
import { z as z5 } from "zod";
var MagicLinkEmailSchema = z5.object({
  email: z5.string().email("Enter a valid email")
});
var RequestMagicLinkSchema = z5.object({
  email: z5.string().email(),
  redirectUrl: z5.string().url(),
  returnUrl: z5.string().optional(),
  returnApp: z5.string().optional()
});

// src/auth/supabase-auth.ts
import { z as z6 } from "zod";
var SupabaseLoginSchema = z6.object({
  email: z6.string().email(),
  password: z6.string().min(1)
});
var RefreshTokenSchema = z6.object({
  refresh_token: z6.string().min(1)
});
var WpLoginSchema = z6.object({
  email: z6.string().email(),
  password: z6.string().min(1)
});
var MembersLoginSchema = z6.object({
  identifier: z6.string().min(1).transform((v) => v.toLowerCase().trim()),
  password: z6.string().min(1)
});

// src/badges/entity.ts
import { object, z as z8 } from "zod";

// src/badges/meta.ts
import { z as z7 } from "zod";
var BadgeMetaSchemaBE = z7.object({
  autoRedeemed: z7.boolean().default(true).describe("Whether the badge was auto redeemed")
});
var defaultBadgeMetaValuesBE = JSON.stringify({
  autoRedeemed: true
});

// src/badges/entity.ts
var BadgeTypeArray = [
  "CHALLENGE",
  "MILESTONE"
];
var BadgeTypeEnumObject = z8.enum(BadgeTypeArray);
var EBadgeType = BadgeTypeEnumObject.enum;
var ChallengeBadgeNameArray = [
  "CHALLENGE_VIDEO",
  "CHALLENGE_DAY"
];
var ChallengeBadgeNameEnumObject = z8.enum(ChallengeBadgeNameArray);
var EChallengeBadgeName = ChallengeBadgeNameEnumObject.enum;
var MilestoneBadgeNameArray = [
  "CHALLENGE_CHAMPION",
  "DAILY_DEDICATION",
  "LIVE_CLASS",
  "COMMENTS",
  "WORKOUTS"
];
var MilestoneBadgeNameEnumObject = z8.enum(MilestoneBadgeNameArray);
var EMilestoneBadgeName = MilestoneBadgeNameEnumObject.enum;
var BadgeWeightEnum = z8.enum([
  "10",
  "25",
  "50",
  "100",
  "250",
  "500",
  "1000",
  "2500"
]);
var BadgeNameEnum = z8.enum([
  ...ChallengeBadgeNameEnumObject.options,
  ...MilestoneBadgeNameEnumObject.options
]);
var BaseBadgeFields = {
  id: z8.coerce.number(),
  userId: z8.string(),
  createdAt: z8.string(),
  updatedAt: z8.string(),
  meta: BadgeMetaSchemaBE
};
var ChallengeBadgeSchema = z8.object(__spreadProps(__spreadValues({}, BaseBadgeFields), {
  type: z8.literal(EBadgeType.CHALLENGE),
  badgeName: ChallengeBadgeNameEnumObject,
  challengeContentId: z8.string().nullable(),
  challengeId: z8.string(),
  challengeDayIndex: z8.number().nullable()
}));
var MilestoneBadgeSchema = z8.object(__spreadProps(__spreadValues({}, BaseBadgeFields), {
  type: z8.literal(EBadgeType.MILESTONE),
  badgeName: MilestoneBadgeNameEnumObject,
  badgeWeight: BadgeWeightEnum.optional().nullable(),
  challengeContentId: z8.null(),
  challengeId: z8.null()
}));
var BadgeSchema = z8.discriminatedUnion("type", [
  ChallengeBadgeSchema,
  MilestoneBadgeSchema
]);
var BadgeTypeNameSchema = z8.discriminatedUnion("type", [
  object({
    type: z8.literal(EBadgeType.CHALLENGE),
    badgeName: ChallengeBadgeNameEnumObject
  }),
  object({
    type: z8.literal(EBadgeType.MILESTONE),
    badgeName: MilestoneBadgeNameEnumObject
  })
]);
var GetBadgesQuerySchema = z8.object({
  type: BadgeTypeEnumObject.optional()
});
var GetUserBadgesParamsSchema = z8.object({
  userId: z8.string().min(1, "User ID is required")
});
var CommonCreateBadgeSchema = z8.object({
  userId: z8.string().min(1, "User ID is required")
});
var CreateChallengeBadgeSchema = CommonCreateBadgeSchema.extend({
  type: z8.literal(EBadgeType.CHALLENGE),
  badgeName: ChallengeBadgeNameEnumObject,
  challengeContentId: z8.string().min(1, "Challenge content ID is required").nullable(),
  challengeId: z8.string().min(1, "Challenge ID is required"),
  challengeDayIndex: z8.number().nullable()
});
var CreateMilestoneBadgeSchema = CommonCreateBadgeSchema.extend({
  type: z8.literal(EBadgeType.MILESTONE),
  badgeName: MilestoneBadgeNameEnumObject,
  badgeWeight: BadgeWeightEnum.optional(),
  challengeId: z8.string().min(1, "Challenge ID is required").or(z8.null())
});
var CreateBadgeSchema = z8.discriminatedUnion("type", [
  CreateChallengeBadgeSchema,
  CreateMilestoneBadgeSchema
]);
var BadgesResponseSchema = z8.object({
  badges: z8.array(BadgeSchema),
  total: z8.number()
});

// src/common/cache-keys.enum.ts
var GlobalCacheKeyEnum = /* @__PURE__ */ function(GlobalCacheKeyEnum2) {
  GlobalCacheKeyEnum2["USER_PROFILES"] = "global-user-profiles";
  GlobalCacheKeyEnum2["MENTION_USER_PROFILES"] = "mention-user-profiles";
  return GlobalCacheKeyEnum2;
}({});

// src/common/pagination.schema.ts
import { number, object as object2, string } from "zod";
var MetaSchema = object2({
  totalPages: number().int().positive(),
  page: number().int().positive(),
  perPage: number().int().positive(),
  total: number().int().positive()
});
var ErrorSchema = object2({
  code: string(),
  message: string()
});

// src/common/request.schema.ts
import { object as object3, coerce } from "zod";

// src/coerce-boolean.ts
import { boolean, string as string2, union } from "zod";
var CoerceBoolean = union([
  boolean(),
  string2()
]).transform((value) => {
  if (value === "false") {
    return false;
  }
  if (value === "true") {
    return true;
  }
  return Boolean(value);
}).default(false);

// src/common/request.schema.ts
var RequestSchema = object3({
  perPage: coerce.number().optional(),
  page: coerce.number().optional(),
  isHidden: CoerceBoolean.optional()
});

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/errors.js
var _a;
var LuxonError = (_a = class extends Error {
}, __name(_a, "LuxonError"), _a);
var _InvalidDateTimeError = class _InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
};
__name(_InvalidDateTimeError, "InvalidDateTimeError");
var InvalidDateTimeError = _InvalidDateTimeError;
var _InvalidIntervalError = class _InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
};
__name(_InvalidIntervalError, "InvalidIntervalError");
var InvalidIntervalError = _InvalidIntervalError;
var _InvalidDurationError = class _InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
};
__name(_InvalidDurationError, "InvalidDurationError");
var InvalidDurationError = _InvalidDurationError;
var _ConflictingSpecificationError = class _ConflictingSpecificationError extends LuxonError {
};
__name(_ConflictingSpecificationError, "ConflictingSpecificationError");
var ConflictingSpecificationError = _ConflictingSpecificationError;
var _InvalidUnitError = class _InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
};
__name(_InvalidUnitError, "InvalidUnitError");
var InvalidUnitError = _InvalidUnitError;
var _InvalidArgumentError = class _InvalidArgumentError extends LuxonError {
};
__name(_InvalidArgumentError, "InvalidArgumentError");
var InvalidArgumentError = _InvalidArgumentError;
var _ZoneIsAbstractError = class _ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
};
__name(_ZoneIsAbstractError, "ZoneIsAbstractError");
var ZoneIsAbstractError = _ZoneIsAbstractError;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/formats.js
var n = "numeric";
var s = "short";
var l = "long";
var DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
var DATE_MED = {
  year: n,
  month: s,
  day: n
};
var DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
var DATE_FULL = {
  year: n,
  month: l,
  day: n
};
var DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
var TIME_SIMPLE = {
  hour: n,
  minute: n
};
var TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
var TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
var TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
var DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
var DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zone.js
var _Zone = class _Zone {
  /**
  * The type of zone
  * @abstract
  * @type {string}
  */
  get type() {
    throw new ZoneIsAbstractError();
  }
  /**
  * The name of this zone.
  * @abstract
  * @type {string}
  */
  get name() {
    throw new ZoneIsAbstractError();
  }
  /**
  * The IANA name of this zone.
  * Defaults to `name` if not overwritten by a subclass.
  * @abstract
  * @type {string}
  */
  get ianaName() {
    return this.name;
  }
  /**
  * Returns whether the offset is known to be fixed for the whole year.
  * @abstract
  * @type {boolean}
  */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  /**
  * Returns the offset's common name (such as EST) at the specified timestamp
  * @abstract
  * @param {number} ts - Epoch milliseconds for which to get the name
  * @param {Object} opts - Options to affect the format
  * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
  * @param {string} opts.locale - What locale to return the offset name in.
  * @return {string}
  */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Returns the offset's value as a string
  * @abstract
  * @param {number} ts - Epoch milliseconds for which to get the offset
  * @param {string} format - What style of offset to return.
  *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
  * @return {string}
  */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Return the offset in minutes for this zone at the specified timestamp.
  * @abstract
  * @param {number} ts - Epoch milliseconds for which to compute the offset
  * @return {number}
  */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Return whether this Zone is equal to another zone
  * @abstract
  * @param {Zone} otherZone - the zone to compare
  * @return {boolean}
  */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Return whether this Zone is valid.
  * @abstract
  * @type {boolean}
  */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
};
__name(_Zone, "Zone");
var Zone = _Zone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/systemZone.js
var singleton = null;
var _SystemZone = class _SystemZone extends Zone {
  /**
  * Get a singleton instance of the local zone
  * @return {SystemZone}
  */
  static get instance() {
    if (singleton === null) {
      singleton = new _SystemZone();
    }
    return singleton;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }
  /** @override **/
  get isValid() {
    return true;
  }
};
__name(_SystemZone, "SystemZone");
var SystemZone = _SystemZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/IANAZone.js
var dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
  }
  return dtfCache[zone];
}
__name(makeDTF, "makeDTF");
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date2) {
  const formatted = dtf.format(date2).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [
    fYear,
    fMonth,
    fDay,
    fadOrBc,
    fHour,
    fMinute,
    fSecond
  ];
}
__name(hackyOffset, "hackyOffset");
function partsOffset(dtf, date2) {
  const formatted = dtf.formatToParts(date2);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
__name(partsOffset, "partsOffset");
var ianaZoneCache = {};
var _IANAZone = class _IANAZone extends Zone {
  /**
  * @param {string} name - Zone name
  * @return {IANAZone}
  */
  static create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new _IANAZone(name);
    }
    return ianaZoneCache[name];
  }
  /**
  * Reset local caches. Should only be necessary in testing scenarios.
  * @return {void}
  */
  static resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }
  /**
  * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
  * @param {string} s - The string to check validity on
  * @example IANAZone.isValidSpecifier("America/New_York") //=> true
  * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
  * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
  * @return {boolean}
  */
  static isValidSpecifier(s2) {
    return this.isValidZone(s2);
  }
  /**
  * Returns whether the provided string identifies a real zone
  * @param {string} zone - The string to check
  * @example IANAZone.isValidZone("America/New_York") //=> true
  * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
  * @example IANAZone.isValidZone("Sport~~blorp") //=> false
  * @return {boolean}
  */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", {
        timeZone: zone
      }).format();
      return true;
    } catch (e) {
      return false;
    }
  }
  constructor(name) {
    super();
    this.zoneName = name;
    this.valid = _IANAZone.isValidZone(name);
  }
  /**
  * The type of zone. `iana` for all instances of `IANAZone`.
  * @override
  * @type {string}
  */
  get type() {
    return "iana";
  }
  /**
  * The name of this zone (i.e. the IANA zone name).
  * @override
  * @type {string}
  */
  get name() {
    return this.zoneName;
  }
  /**
  * Returns whether the offset is known to be fixed for the whole year:
  * Always returns false for all IANA zones.
  * @override
  * @type {boolean}
  */
  get isUniversal() {
    return false;
  }
  /**
  * Returns the offset's common name (such as EST) at the specified timestamp
  * @override
  * @param {number} ts - Epoch milliseconds for which to get the name
  * @param {Object} opts - Options to affect the format
  * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
  * @param {string} opts.locale - What locale to return the offset name in.
  * @return {string}
  */
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }
  /**
  * Returns the offset's value as a string
  * @override
  * @param {number} ts - Epoch milliseconds for which to get the offset
  * @param {string} format - What style of offset to return.
  *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
  * @return {string}
  */
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /**
  * Return the offset in minutes for this zone at the specified timestamp.
  * @override
  * @param {number} ts - Epoch milliseconds for which to compute the offset
  * @return {number}
  */
  offset(ts) {
    const date2 = new Date(ts);
    if (isNaN(date2)) return NaN;
    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date2) : hackyOffset(dtf, date2);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0
    });
    let asTS = +date2;
    const over = asTS % 1e3;
    asTS -= over >= 0 ? over : 1e3 + over;
    return (asUTC - asTS) / (60 * 1e3);
  }
  /**
  * Return whether this Zone is equal to another zone
  * @override
  * @param {Zone} otherZone - the zone to compare
  * @return {boolean}
  */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /**
  * Return whether this Zone is valid.
  * @override
  * @type {boolean}
  */
  get isValid() {
    return this.valid;
  }
};
__name(_IANAZone, "IANAZone");
var IANAZone = _IANAZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/locale.js
var intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([
    locString,
    opts
  ]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
__name(getCachedLF, "getCachedLF");
var intlDTCache = {};
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([
    locString,
    opts
  ]);
  let dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}
__name(getCachedDTF, "getCachedDTF");
var intlNumCache = {};
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([
    locString,
    opts
  ]);
  let inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}
__name(getCachedINF, "getCachedINF");
var intlRelCache = {};
function getCachedRTF(locString, opts = {}) {
  const _a5 = opts, { base } = _a5, cacheKeyOpts = __objRest(_a5, ["base"]);
  const key = JSON.stringify([
    locString,
    cacheKeyOpts
  ]);
  let inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}
__name(getCachedRTF, "getCachedRTF");
var sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
__name(systemLocale, "systemLocale");
var weekInfoCache = {};
function getCachedWeekInfo(locString) {
  let data = weekInfoCache[locString];
  if (!data) {
    const locale = new Intl.Locale(locString);
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    weekInfoCache[locString] = data;
  }
  return data;
}
__name(getCachedWeekInfo, "getCachedWeekInfo");
function parseLocaleString(localeStr) {
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [
      localeStr
    ];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const { numberingSystem, calendar } = options;
    return [
      selectedStr,
      numberingSystem,
      calendar
    ];
  }
}
__name(parseLocaleString, "parseLocaleString");
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
__name(intlConfigString, "intlConfigString");
function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}
__name(mapMonths, "mapMonths");
function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}
__name(mapWeekdays, "mapWeekdays");
function listStuff(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
__name(listStuff, "listStuff");
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}
__name(supportsFastNumbers, "supportsFastNumbers");
var _a2;
var PolyNumberFormatter = (_a2 = class {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const _a5 = opts, { padTo, floor } = _a5, otherOpts = __objRest(_a5, ["padTo", "floor"]);
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = __spreadValues({
        useGrouping: false
      }, opts);
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}, __name(_a2, "PolyNumberFormatter"), _a2);
var _a3;
var PolyDateFormatter = (_a3 = class {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = void 0;
    let z140 = void 0;
    if (this.opts.timeZone) {
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z140 = offsetZ;
        this.dt = dt;
      } else {
        z140 = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
          minutes: dt.offset
        });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z140 = dt.zone.name;
    } else {
      z140 = "UTC";
      this.dt = dt.setZone("UTC").plus({
        minutes: dt.offset
      });
      this.originalZone = dt.zone;
    }
    const intlOpts = __spreadValues({}, this.opts);
    intlOpts.timeZone = intlOpts.timeZone || z140;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    if (this.originalZone) {
      return this.formatToParts().map(({ value }) => value).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName
          });
          return __spreadProps(__spreadValues({}, part), {
            value: offsetName
          });
        } else {
          return part;
        }
      });
    }
    return parts;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}, __name(_a3, "PolyDateFormatter"), _a3);
var _a4;
var PolyRelFormatter = (_a4 = class {
  constructor(intl, isEnglish, opts) {
    this.opts = __spreadValues({
      style: "long"
    }, opts);
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}, __name(_a4, "PolyRelFormatter"), _a4);
var fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [
    6,
    7
  ]
};
var _Locale = class _Locale {
  static fromOpts(opts) {
    return _Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
  }
  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new _Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  }
  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return _Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }
  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = {
      format: {},
      standalone: {}
    };
    this.monthsCache = {
      format: {},
      standalone: {}
    };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return _Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone(__spreadProps(__spreadValues({}, alts), {
      defaultToEN: true
    }));
  }
  redefaultToSystem(alts = {}) {
    return this.clone(__spreadProps(__spreadValues({}, alts), {
      defaultToEN: false
    }));
  }
  months(length, format = false) {
    return listStuff(this, length, months, () => {
      const intl = format ? {
        month: length,
        day: "numeric"
      } : {
        month: length
      }, formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        this.monthsCache[formatStr][length] = mapMonths((dt) => this.extract(dt, intl, "month"));
      }
      return this.monthsCache[formatStr][length];
    });
  }
  weekdays(length, format = false) {
    return listStuff(this, length, weekdays, () => {
      const intl = format ? {
        weekday: length,
        year: "numeric",
        month: "long",
        day: "numeric"
      } : {
        weekday: length
      }, formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays((dt) => this.extract(dt, intl, "weekday"));
      }
      return this.weekdaysCache[formatStr][length];
    });
  }
  meridiems() {
    return listStuff(this, void 0, () => meridiems, () => {
      if (!this.meridiemCache) {
        const intl = {
          hour: "numeric",
          hourCycle: "h12"
        };
        this.meridiemCache = [
          DateTime.utc(2016, 11, 13, 9),
          DateTime.utc(2016, 11, 13, 19)
        ].map((dt) => this.extract(dt, intl, "dayperiod"));
      }
      return this.meridiemCache;
    });
  }
  eras(length) {
    return listStuff(this, length, eras, () => {
      const intl = {
        era: length
      };
      if (!this.eraCache[length]) {
        this.eraCache[length] = [
          DateTime.utc(-40, 1, 1),
          DateTime.utc(2017, 1, 1)
        ].map((dt) => this.extract(dt, intl, "era"));
      }
      return this.eraCache[length];
    });
  }
  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
};
__name(_Locale, "Locale");
var Locale = _Locale;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/fixedOffsetZone.js
var singleton2 = null;
var _FixedOffsetZone = class _FixedOffsetZone extends Zone {
  /**
  * Get a singleton instance of UTC
  * @return {FixedOffsetZone}
  */
  static get utcInstance() {
    if (singleton2 === null) {
      singleton2 = new _FixedOffsetZone(0);
    }
    return singleton2;
  }
  /**
  * Get an instance with a specified offset
  * @param {number} offset - The offset in minutes
  * @return {FixedOffsetZone}
  */
  static instance(offset2) {
    return offset2 === 0 ? _FixedOffsetZone.utcInstance : new _FixedOffsetZone(offset2);
  }
  /**
  * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
  * @param {string} s - The offset string to parse
  * @example FixedOffsetZone.parseSpecifier("UTC+6")
  * @example FixedOffsetZone.parseSpecifier("UTC+06")
  * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
  * @return {FixedOffsetZone}
  */
  static parseSpecifier(s2) {
    if (s2) {
      const r = s2.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new _FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  }
  constructor(offset2) {
    super();
    this.fixed = offset2;
  }
  /**
  * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
  * @override
  * @type {string}
  */
  get type() {
    return "fixed";
  }
  /**
  * The name of this zone.
  * All fixed zones' names always start with "UTC" (plus optional offset)
  * @override
  * @type {string}
  */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  /**
  * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
  *
  * @override
  * @type {string}
  */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }
  /**
  * Returns the offset's common name at the specified timestamp.
  *
  * For fixed offset zones this equals to the zone name.
  * @override
  */
  offsetName() {
    return this.name;
  }
  /**
  * Returns the offset's value as a string
  * @override
  * @param {number} ts - Epoch milliseconds for which to get the offset
  * @param {string} format - What style of offset to return.
  *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
  * @return {string}
  */
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }
  /**
  * Returns whether the offset is known to be fixed for the whole year:
  * Always returns true for all fixed offset zones.
  * @override
  * @type {boolean}
  */
  get isUniversal() {
    return true;
  }
  /**
  * Return the offset in minutes for this zone at the specified timestamp.
  *
  * For fixed offset zones, this is constant and does not depend on a timestamp.
  * @override
  * @return {number}
  */
  offset() {
    return this.fixed;
  }
  /**
  * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
  * @override
  * @param {Zone} otherZone - the zone to compare
  * @return {boolean}
  */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /**
  * Return whether this Zone is valid:
  * All fixed offset zones are valid.
  * @override
  * @type {boolean}
  */
  get isValid() {
    return true;
  }
};
__name(_FixedOffsetZone, "FixedOffsetZone");
var FixedOffsetZone = _FixedOffsetZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/invalidZone.js
var _InvalidZone = class _InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    this.zoneName = zoneName;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return false;
  }
  /** @override **/
  get isValid() {
    return false;
  }
};
__name(_InvalidZone, "InvalidZone");
var InvalidZone = _InvalidZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/zoneUtil.js
function normalizeZone(input, defaultZone2) {
  let offset2;
  if (isUndefined(input) || input === null) {
    return defaultZone2;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone2;
    else if (lowered === "local" || lowered === "system") return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
    else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    return input;
  } else {
    return new InvalidZone(input);
  }
}
__name(normalizeZone, "normalizeZone");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/digits.js
var numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};
var numberingSystemsUTF16 = {
  arab: [
    1632,
    1641
  ],
  arabext: [
    1776,
    1785
  ],
  bali: [
    6992,
    7001
  ],
  beng: [
    2534,
    2543
  ],
  deva: [
    2406,
    2415
  ],
  fullwide: [
    65296,
    65303
  ],
  gujr: [
    2790,
    2799
  ],
  khmr: [
    6112,
    6121
  ],
  knda: [
    3302,
    3311
  ],
  laoo: [
    3792,
    3801
  ],
  limb: [
    6470,
    6479
  ],
  mlym: [
    3430,
    3439
  ],
  mong: [
    6160,
    6169
  ],
  mymr: [
    4160,
    4169
  ],
  orya: [
    2918,
    2927
  ],
  tamldec: [
    3046,
    3055
  ],
  telu: [
    3174,
    3183
  ],
  thai: [
    3664,
    3673
  ],
  tibt: [
    3872,
    3881
  ]
};
var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
__name(parseDigits, "parseDigits");
var digitRegexCache = {};
function resetDigitRegexCache() {
  digitRegexCache = {};
}
__name(resetDigitRegexCache, "resetDigitRegexCache");
function digitRegex({ numberingSystem }, append = "") {
  const ns = numberingSystem || "latn";
  if (!digitRegexCache[ns]) {
    digitRegexCache[ns] = {};
  }
  if (!digitRegexCache[ns][append]) {
    digitRegexCache[ns][append] = new RegExp(`${numberingSystems[ns]}${append}`);
  }
  return digitRegexCache[ns][append];
}
__name(digitRegex, "digitRegex");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/settings.js
var now = /* @__PURE__ */ __name(() => Date.now(), "now");
var defaultZone = "system";
var defaultLocale = null;
var defaultNumberingSystem = null;
var defaultOutputCalendar = null;
var twoDigitCutoffYear = 60;
var throwOnInvalid;
var defaultWeekSettings = null;
var _Settings = class _Settings {
  /**
  * Get the callback for returning the current timestamp.
  * @type {function}
  */
  static get now() {
    return now;
  }
  /**
  * Set the callback for returning the current timestamp.
  * The function should return a number, which will be interpreted as an Epoch millisecond count
  * @type {function}
  * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
  * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
  */
  static set now(n2) {
    now = n2;
  }
  /**
  * Set the default time zone to create DateTimes in. Does not affect existing instances.
  * Use the value "system" to reset this value to the system's time zone.
  * @type {string}
  */
  static set defaultZone(zone) {
    defaultZone = zone;
  }
  /**
  * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
  * The default value is the system's time zone (the one set on the machine that runs this code).
  * @type {Zone}
  */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  /**
  * Get the default locale to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static get defaultLocale() {
    return defaultLocale;
  }
  /**
  * Set the default locale to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }
  /**
  * Get the default numbering system to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  /**
  * Set the default numbering system to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }
  /**
  * Get the default output calendar to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  /**
  * Set the default output calendar to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }
  /**
  * @typedef {Object} WeekSettings
  * @property {number} firstDay
  * @property {number} minimalDays
  * @property {number[]} weekend
  */
  /**
  * @return {WeekSettings|null}
  */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }
  /**
  * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
  * how many days are required in the first week of a year.
  * Does not affect existing instances.
  *
  * @param {WeekSettings|null} weekSettings
  */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }
  /**
  * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
  * @type {number}
  */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  /**
  * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
  * @type {number}
  * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
  * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
  * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
  * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
  * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
  */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }
  /**
  * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
  * @type {boolean}
  */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  /**
  * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
  * @type {boolean}
  */
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }
  /**
  * Reset Luxon's global caches. Should only be necessary in testing scenarios.
  * @return {void}
  */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
    DateTime.resetCache();
    resetDigitRegexCache();
  }
};
__name(_Settings, "Settings");
var Settings = _Settings;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/invalid.js
var _Invalid = class _Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
};
__name(_Invalid, "Invalid");
var Invalid = _Invalid;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/conversions.js
var nonLeapLadder = [
  0,
  31,
  59,
  90,
  120,
  151,
  181,
  212,
  243,
  273,
  304,
  334
];
var leapLadder = [
  0,
  31,
  60,
  91,
  121,
  152,
  182,
  213,
  244,
  274,
  305,
  335
];
function unitOutOfRange(unit, value) {
  return new Invalid("unit out of range", `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`);
}
__name(unitOutOfRange, "unitOutOfRange");
function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  const js = d.getUTCDay();
  return js === 0 ? 7 : js;
}
__name(dayOfWeek, "dayOfWeek");
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
__name(computeOrdinal, "computeOrdinal");
function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex((i) => i < ordinal), day = ordinal - table[month0];
  return {
    month: month0 + 1,
    day
  };
}
__name(uncomputeOrdinal, "uncomputeOrdinal");
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
__name(isoWeekdayToLocal, "isoWeekdayToLocal");
function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return __spreadValues({
    weekYear,
    weekNumber,
    weekday
  }, timeObject(gregObj));
}
__name(gregorianToWeek, "gregorianToWeek");
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return __spreadValues({
    year,
    month,
    day
  }, timeObject(weekData));
}
__name(weekToGregorian, "weekToGregorian");
function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return __spreadValues({
    year,
    ordinal
  }, timeObject(gregData));
}
__name(gregorianToOrdinal, "gregorianToOrdinal");
function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return __spreadValues({
    year,
    month,
    day
  }, timeObject(ordinalData));
}
__name(ordinalToGregorian, "ordinalToGregorian");
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
    }
    if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return {
      minDaysInFirstWeek: 4,
      startOfWeek: 1
    };
  }
}
__name(usesLocalWeekValues, "usesLocalWeekValues");
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger(obj.weekYear), validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
__name(hasInvalidWeekData, "hasInvalidWeekData");
function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
__name(hasInvalidOrdinalData, "hasInvalidOrdinalData");
function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
__name(hasInvalidGregorianData, "hasInvalidGregorianData");
function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}
__name(hasInvalidTimeData, "hasInvalidTimeData");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/util.js
function isUndefined(o) {
  return typeof o === "undefined";
}
__name(isUndefined, "isUndefined");
function isNumber(o) {
  return typeof o === "number";
}
__name(isNumber, "isNumber");
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
__name(isInteger, "isInteger");
function isString(o) {
  return typeof o === "string";
}
__name(isString, "isString");
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}
__name(isDate, "isDate");
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}
__name(hasRelative, "hasRelative");
function hasLocaleWeekInfo() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e) {
    return false;
  }
}
__name(hasLocaleWeekInfo, "hasLocaleWeekInfo");
function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [
    thing
  ];
}
__name(maybeArray, "maybeArray");
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return void 0;
  }
  return arr.reduce((best, next) => {
    const pair = [
      by(next),
      next
    ];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
__name(bestBy, "bestBy");
function pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}
__name(pick, "pick");
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
__name(hasOwnProperty, "hasOwnProperty");
function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v) => !integerBetween(v, 1, 7))) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}
__name(validateWeekSettings, "validateWeekSettings");
function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}
__name(integerBetween, "integerBetween");
function floorMod(x, n2) {
  return x - n2 * Math.floor(x / n2);
}
__name(floorMod, "floorMod");
function padStart(input, n2 = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n2, "0");
  } else {
    padded = ("" + input).padStart(n2, "0");
  }
  return padded;
}
__name(padStart, "padStart");
function parseInteger(string74) {
  if (isUndefined(string74) || string74 === null || string74 === "") {
    return void 0;
  } else {
    return parseInt(string74, 10);
  }
}
__name(parseInteger, "parseInteger");
function parseFloating(string74) {
  if (isUndefined(string74) || string74 === null || string74 === "") {
    return void 0;
  } else {
    return parseFloat(string74);
  }
}
__name(parseFloating, "parseFloating");
function parseMillis(fraction) {
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return void 0;
  } else {
    const f = parseFloat("0." + fraction) * 1e3;
    return Math.floor(f);
  }
}
__name(parseMillis, "parseMillis");
function roundTo(number29, digits, towardZero = false) {
  const factor = __pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number29 * factor) / factor;
}
__name(roundTo, "roundTo");
function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
__name(isLeapYear, "isLeapYear");
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
__name(daysInYear, "daysInYear");
function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [
      31,
      null,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31
    ][modMonth - 1];
  }
}
__name(daysInMonth, "daysInMonth");
function objToLocalTS(obj) {
  let d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}
__name(objToLocalTS, "objToLocalTS");
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
__name(firstWeekOffset, "firstWeekOffset");
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
__name(weeksInWeekYear, "weeksInWeekYear");
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2e3 + year;
}
__name(untruncateYear, "untruncateYear");
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date2 = new Date(ts), intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = __spreadValues({
    timeZoneName: offsetFormat
  }, intlOpts);
  const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date2).find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
__name(parseZoneInfo, "parseZoneInfo");
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
__name(signedOffset, "signedOffset");
function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
__name(asNumber, "asNumber");
function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === void 0 || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}
__name(normalizeObject, "normalizeObject");
function formatOffset(offset2, format) {
  const hours = Math.trunc(Math.abs(offset2 / 60)), minutes = Math.trunc(Math.abs(offset2 % 60)), sign = offset2 >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}
__name(formatOffset, "formatOffset");
function timeObject(obj) {
  return pick(obj, [
    "hour",
    "minute",
    "second",
    "millisecond"
  ]);
}
__name(timeObject, "timeObject");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/english.js
var monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
var monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
var monthsNarrow = [
  "J",
  "F",
  "M",
  "A",
  "M",
  "J",
  "J",
  "A",
  "S",
  "O",
  "N",
  "D"
];
function months(length) {
  switch (length) {
    case "narrow":
      return [
        ...monthsNarrow
      ];
    case "short":
      return [
        ...monthsShort
      ];
    case "long":
      return [
        ...monthsLong
      ];
    case "numeric":
      return [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
      ];
    case "2-digit":
      return [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
      ];
    default:
      return null;
  }
}
__name(months, "months");
var weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
var weekdaysShort = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun"
];
var weekdaysNarrow = [
  "M",
  "T",
  "W",
  "T",
  "F",
  "S",
  "S"
];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [
        ...weekdaysNarrow
      ];
    case "short":
      return [
        ...weekdaysShort
      ];
    case "long":
      return [
        ...weekdaysLong
      ];
    case "numeric":
      return [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7"
      ];
    default:
      return null;
  }
}
__name(weekdays, "weekdays");
var meridiems = [
  "AM",
  "PM"
];
var erasLong = [
  "Before Christ",
  "Anno Domini"
];
var erasShort = [
  "BC",
  "AD"
];
var erasNarrow = [
  "B",
  "A"
];
function eras(length) {
  switch (length) {
    case "narrow":
      return [
        ...erasNarrow
      ];
    case "short":
      return [
        ...erasShort
      ];
    case "long":
      return [
        ...erasLong
      ];
    default:
      return null;
  }
}
__name(eras, "eras");
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
__name(meridiemForDateTime, "meridiemForDateTime");
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
__name(weekdayForDateTime, "weekdayForDateTime");
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
__name(monthForDateTime, "monthForDateTime");
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
__name(eraForDateTime, "eraForDateTime");
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: [
      "year",
      "yr."
    ],
    quarters: [
      "quarter",
      "qtr."
    ],
    months: [
      "month",
      "mo."
    ],
    weeks: [
      "week",
      "wk."
    ],
    days: [
      "day",
      "day",
      "days"
    ],
    hours: [
      "hour",
      "hr."
    ],
    minutes: [
      "minute",
      "min."
    ],
    seconds: [
      "second",
      "sec."
    ]
  };
  const lastable = [
    "hours",
    "minutes",
    "seconds"
  ].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
      default:
    }
  }
  const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
__name(formatRelativeTime, "formatRelativeTime");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/formatter.js
function stringifyTokens(splits, tokenToString) {
  let s2 = "";
  for (const token of splits) {
    if (token.literal) {
      s2 += token.val;
    } else {
      s2 += tokenToString(token.val);
    }
  }
  return s2;
}
__name(stringifyTokens, "stringifyTokens");
var macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
var _Formatter = class _Formatter {
  static create(locale, opts = {}) {
    return new _Formatter(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null, currentFull = "", bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({
            literal: /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        currentFull = c;
        current = c;
      }
    }
    if (currentFull.length > 0) {
      splits.push({
        literal: bracketed || /^\s+$/.test(currentFull),
        val: currentFull
      });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, __spreadValues(__spreadValues({}, this.opts), opts));
    return df.format();
  }
  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, __spreadValues(__spreadValues({}, this.opts), opts));
  }
  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }
  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }
  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }
  num(n2, p = 0) {
    if (this.opts.forceSimple) {
      return padStart(n2, p);
    }
    const opts = __spreadValues({}, this.opts);
    if (p > 0) {
      opts.padTo = p;
    }
    return this.loc.numberFormatter(opts).format(n2);
  }
  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string74 = /* @__PURE__ */ __name((opts, extract) => this.loc.extract(dt, opts, extract), "string"), formatOffset2 = /* @__PURE__ */ __name((opts) => {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }
      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    }, "formatOffset"), meridiem = /* @__PURE__ */ __name(() => knownEnglish ? meridiemForDateTime(dt) : string74({
      hour: "numeric",
      hourCycle: "h12"
    }, "dayperiod"), "meridiem"), month = /* @__PURE__ */ __name((length, standalone) => knownEnglish ? monthForDateTime(dt, length) : string74(standalone ? {
      month: length
    } : {
      month: length,
      day: "numeric"
    }, "month"), "month"), weekday = /* @__PURE__ */ __name((length, standalone) => knownEnglish ? weekdayForDateTime(dt, length) : string74(standalone ? {
      weekday: length
    } : {
      weekday: length,
      month: "long",
      day: "numeric"
    }, "weekday"), "weekday"), maybeMacro = /* @__PURE__ */ __name((token) => {
      const formatOpts = _Formatter.macroTokenToFormatOpts(token);
      if (formatOpts) {
        return this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token;
      }
    }, "maybeMacro"), era = /* @__PURE__ */ __name((length) => knownEnglish ? eraForDateTime(dt, length) : string74({
      era: length
    }, "era"), "era"), tokenToString = /* @__PURE__ */ __name((token) => {
      switch (token) {
        // ms
        case "S":
          return this.num(dt.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(dt.millisecond, 3);
        // seconds
        case "s":
          return this.num(dt.second);
        case "ss":
          return this.num(dt.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(dt.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(dt.millisecond / 100));
        // minutes
        case "m":
          return this.num(dt.minute);
        case "mm":
          return this.num(dt.minute, 2);
        // hours
        case "h":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
        case "hh":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
        case "H":
          return this.num(dt.hour);
        case "HH":
          return this.num(dt.hour, 2);
        // offset
        case "Z":
          return formatOffset2({
            format: "narrow",
            allowZ: this.opts.allowZ
          });
        case "ZZ":
          return formatOffset2({
            format: "short",
            allowZ: this.opts.allowZ
          });
        case "ZZZ":
          return formatOffset2({
            format: "techie",
            allowZ: this.opts.allowZ
          });
        case "ZZZZ":
          return dt.zone.offsetName(dt.ts, {
            format: "short",
            locale: this.loc.locale
          });
        case "ZZZZZ":
          return dt.zone.offsetName(dt.ts, {
            format: "long",
            locale: this.loc.locale
          });
        // zone
        case "z":
          return dt.zoneName;
        // meridiems
        case "a":
          return meridiem();
        // dates
        case "d":
          return useDateTimeFormatter ? string74({
            day: "numeric"
          }, "day") : this.num(dt.day);
        case "dd":
          return useDateTimeFormatter ? string74({
            day: "2-digit"
          }, "day") : this.num(dt.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(dt.weekday);
        case "ccc":
          return weekday("short", true);
        case "cccc":
          return weekday("long", true);
        case "ccccc":
          return weekday("narrow", true);
        // weekdays - format
        case "E":
          return this.num(dt.weekday);
        case "EEE":
          return weekday("short", false);
        case "EEEE":
          return weekday("long", false);
        case "EEEEE":
          return weekday("narrow", false);
        // months - standalone
        case "L":
          return useDateTimeFormatter ? string74({
            month: "numeric",
            day: "numeric"
          }, "month") : this.num(dt.month);
        case "LL":
          return useDateTimeFormatter ? string74({
            month: "2-digit",
            day: "numeric"
          }, "month") : this.num(dt.month, 2);
        case "LLL":
          return month("short", true);
        case "LLLL":
          return month("long", true);
        case "LLLLL":
          return month("narrow", true);
        // months - format
        case "M":
          return useDateTimeFormatter ? string74({
            month: "numeric"
          }, "month") : this.num(dt.month);
        case "MM":
          return useDateTimeFormatter ? string74({
            month: "2-digit"
          }, "month") : this.num(dt.month, 2);
        case "MMM":
          return month("short", false);
        case "MMMM":
          return month("long", false);
        case "MMMMM":
          return month("narrow", false);
        // years
        case "y":
          return useDateTimeFormatter ? string74({
            year: "numeric"
          }, "year") : this.num(dt.year);
        case "yy":
          return useDateTimeFormatter ? string74({
            year: "2-digit"
          }, "year") : this.num(dt.year.toString().slice(-2), 2);
        case "yyyy":
          return useDateTimeFormatter ? string74({
            year: "numeric"
          }, "year") : this.num(dt.year, 4);
        case "yyyyyy":
          return useDateTimeFormatter ? string74({
            year: "numeric"
          }, "year") : this.num(dt.year, 6);
        // eras
        case "G":
          return era("short");
        case "GG":
          return era("long");
        case "GGGGG":
          return era("narrow");
        case "kk":
          return this.num(dt.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(dt.weekYear, 4);
        case "W":
          return this.num(dt.weekNumber);
        case "WW":
          return this.num(dt.weekNumber, 2);
        case "n":
          return this.num(dt.localWeekNumber);
        case "nn":
          return this.num(dt.localWeekNumber, 2);
        case "ii":
          return this.num(dt.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(dt.localWeekYear, 4);
        case "o":
          return this.num(dt.ordinal);
        case "ooo":
          return this.num(dt.ordinal, 3);
        case "q":
          return this.num(dt.quarter);
        case "qq":
          return this.num(dt.quarter, 2);
        case "X":
          return this.num(Math.floor(dt.ts / 1e3));
        case "x":
          return this.num(dt.ts);
        default:
          return maybeMacro(token);
      }
    }, "tokenToString");
    return stringifyTokens(_Formatter.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const tokenToField = /* @__PURE__ */ __name((token) => {
      switch (token[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, "tokenToField"), tokenToString = /* @__PURE__ */ __name((lildur) => (token) => {
      const mapped = tokenToField(token);
      if (mapped) {
        return this.num(lildur.get(mapped), token.length);
      } else {
        return token;
      }
    }, "tokenToString"), tokens = _Formatter.parseFormat(fmt), realTokens = tokens.reduce((found, { literal: literal2, val }) => literal2 ? found : found.concat(val), []), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t));
    return stringifyTokens(tokens, tokenToString(collapsed));
  }
};
__name(_Formatter, "Formatter");
var Formatter = _Formatter;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/regexParser.js
var ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}
__name(combineRegexes, "combineRegexes");
function combineExtractors(...extractors) {
  return (m) => extractors.reduce(([mergedVals, mergedZone, cursor], ex) => {
    const [val, zone, next] = ex(m, cursor);
    return [
      __spreadValues(__spreadValues({}, mergedVals), val),
      zone || mergedZone,
      next
    ];
  }, [
    {},
    null,
    1
  ]).slice(0, 2);
}
__name(combineExtractors, "combineExtractors");
function parse(s2, ...patterns) {
  if (s2 == null) {
    return [
      null,
      null
    ];
  }
  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s2);
    if (m) {
      return extractor(m);
    }
  }
  return [
    null,
    null
  ];
}
__name(parse, "parse");
function simpleParse(...keys) {
  return (match2, cursor) => {
    const ret = {};
    let i;
    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match2[cursor + i]);
    }
    return [
      ret,
      null,
      cursor + i
    ];
  };
}
__name(simpleParse, "simpleParse");
var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
var isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
var isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`);
var isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
var extractISOOrdinalData = simpleParse("year", "ordinal");
var sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/;
var sqlTimeRegex = RegExp(`${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`);
var sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match2, pos, fallback) {
  const m = match2[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}
__name(int, "int");
function extractISOYmd(match2, cursor) {
  const item = {
    year: int(match2, cursor),
    month: int(match2, cursor + 1, 1),
    day: int(match2, cursor + 2, 1)
  };
  return [
    item,
    null,
    cursor + 3
  ];
}
__name(extractISOYmd, "extractISOYmd");
function extractISOTime(match2, cursor) {
  const item = {
    hours: int(match2, cursor, 0),
    minutes: int(match2, cursor + 1, 0),
    seconds: int(match2, cursor + 2, 0),
    milliseconds: parseMillis(match2[cursor + 3])
  };
  return [
    item,
    null,
    cursor + 4
  ];
}
__name(extractISOTime, "extractISOTime");
function extractISOOffset(match2, cursor) {
  const local = !match2[cursor] && !match2[cursor + 1], fullOffset = signedOffset(match2[cursor + 1], match2[cursor + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [
    {},
    zone,
    cursor + 3
  ];
}
__name(extractISOOffset, "extractISOOffset");
function extractIANAZone(match2, cursor) {
  const zone = match2[cursor] ? IANAZone.create(match2[cursor]) : null;
  return [
    {},
    zone,
    cursor + 1
  ];
}
__name(extractIANAZone, "extractIANAZone");
var isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
var isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match2) {
  const [s2, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match2;
  const hasNegativePrefix = s2[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = /* @__PURE__ */ __name((num, force = false) => num !== void 0 && (force || num && hasNegativePrefix) ? -num : num, "maybeNegate");
  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
    }
  ];
}
__name(extractISODuration, "extractISODuration");
var obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}
__name(fromStrings, "fromStrings");
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr, obsOffset, milOffset, offHourStr, offMinuteStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset2;
  if (obsOffset) {
    offset2 = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset2 = 0;
  } else {
    offset2 = signedOffset(offHourStr, offMinuteStr);
  }
  return [
    result,
    new FixedOffsetZone(offset2)
  ];
}
__name(extractRFC2822, "extractRFC2822");
function preprocessRFC2822(s2) {
  return s2.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
__name(preprocessRFC2822, "preprocessRFC2822");
var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/;
var rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/;
var ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [
    result,
    FixedOffsetZone.utcInstance
  ];
}
__name(extractRFC1123Or850, "extractRFC1123Or850");
function extractASCII(match2) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [
    result,
    FixedOffsetZone.utcInstance
  ];
}
__name(extractASCII, "extractASCII");
var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseISODate(s2) {
  return parse(s2, [
    isoYmdWithTimeExtensionRegex,
    extractISOYmdTimeAndOffset
  ], [
    isoWeekWithTimeExtensionRegex,
    extractISOWeekTimeAndOffset
  ], [
    isoOrdinalWithTimeExtensionRegex,
    extractISOOrdinalDateAndTime
  ], [
    isoTimeCombinedRegex,
    extractISOTimeAndOffset
  ]);
}
__name(parseISODate, "parseISODate");
function parseRFC2822Date(s2) {
  return parse(preprocessRFC2822(s2), [
    rfc2822,
    extractRFC2822
  ]);
}
__name(parseRFC2822Date, "parseRFC2822Date");
function parseHTTPDate(s2) {
  return parse(s2, [
    rfc1123,
    extractRFC1123Or850
  ], [
    rfc850,
    extractRFC1123Or850
  ], [
    ascii,
    extractASCII
  ]);
}
__name(parseHTTPDate, "parseHTTPDate");
function parseISODuration(s2) {
  return parse(s2, [
    isoDuration,
    extractISODuration
  ]);
}
__name(parseISODuration, "parseISODuration");
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s2) {
  return parse(s2, [
    isoTimeOnly,
    extractISOTimeOnly
  ]);
}
__name(parseISOTimeOnly, "parseISOTimeOnly");
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s2) {
  return parse(s2, [
    sqlYmdWithTimeExtensionRegex,
    extractISOYmdTimeAndOffset
  ], [
    sqlTimeCombinedRegex,
    extractISOTimeOffsetAndIANAZone
  ]);
}
__name(parseSQL, "parseSQL");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/duration.js
var INVALID = "Invalid Duration";
var lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: {
    minutes: 60,
    seconds: 60 * 60,
    milliseconds: 60 * 60 * 1e3
  },
  minutes: {
    seconds: 60,
    milliseconds: 60 * 1e3
  },
  seconds: {
    milliseconds: 1e3
  }
};
var casualMatrix = __spreadValues({
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  }
}, lowOrderMatrix);
var daysInYearAccurate = 146097 / 400;
var daysInMonthAccurate = 146097 / 4800;
var accurateMatrix = __spreadValues({
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1e3
  }
}, lowOrderMatrix);
var orderedUnits = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
];
var reverseUnits = orderedUnits.slice(0).reverse();
function clone(dur, alts, clear = false) {
  const conf = {
    values: clear ? alts.values : __spreadValues(__spreadValues({}, dur.values), alts.values || {}),
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
__name(clone, "clone");
function durationToMillis(matrix, vals) {
  var _a5;
  let sum = (_a5 = vals.milliseconds) != null ? _a5 : 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}
__name(durationToMillis, "durationToMillis");
function normalizeValues(matrix, vals) {
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits.reduceRight((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);
  orderedUnits.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}
__name(normalizeValues, "normalizeValues");
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}
__name(removeZeroes, "removeZeroes");
var _Duration = class _Duration {
  /**
  * @private
  */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;
    if (config.matrix) {
      matrix = config.matrix;
    }
    this.values = config.values;
    this.loc = config.loc || Locale.create();
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    this.invalid = config.invalid || null;
    this.matrix = matrix;
    this.isLuxonDuration = true;
  }
  /**
  * Create Duration from a number of milliseconds.
  * @param {number} count of milliseconds
  * @param {Object} opts - options for parsing
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @return {Duration}
  */
  static fromMillis(count, opts) {
    return _Duration.fromObject({
      milliseconds: count
    }, opts);
  }
  /**
  * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
  * If this object is empty then a zero milliseconds duration is returned.
  * @param {Object} obj - the object to create the DateTime from
  * @param {number} obj.years
  * @param {number} obj.quarters
  * @param {number} obj.months
  * @param {number} obj.weeks
  * @param {number} obj.days
  * @param {number} obj.hours
  * @param {number} obj.minutes
  * @param {number} obj.seconds
  * @param {number} obj.milliseconds
  * @param {Object} [opts=[]] - options for creating this Duration
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
  * @param {string} [opts.matrix=Object] - the custom conversion system to use
  * @return {Duration}
  */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(`Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`);
    }
    return new _Duration({
      values: normalizeObject(obj, _Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }
  /**
  * Create a Duration from DurationLike.
  *
  * @param {Object | number | Duration} durationLike
  * One of:
  * - object with keys like 'years' and 'hours'.
  * - number representing milliseconds
  * - Duration instance
  * @return {Duration}
  */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return _Duration.fromMillis(durationLike);
    } else if (_Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return _Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(`Unknown duration argument ${durationLike} of type ${typeof durationLike}`);
    }
  }
  /**
  * Create a Duration from an ISO 8601 duration string.
  * @param {string} text - text to parse
  * @param {Object} opts - options for parsing
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
  * @param {string} [opts.matrix=Object] - the preset conversion system to use
  * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
  * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
  * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
  * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
  * @return {Duration}
  */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return _Duration.fromObject(parsed, opts);
    } else {
      return _Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
  * Create a Duration from an ISO 8601 time string.
  * @param {string} text - text to parse
  * @param {Object} opts - options for parsing
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
  * @param {string} [opts.matrix=Object] - the conversion system to use
  * @see https://en.wikipedia.org/wiki/ISO_8601#Times
  * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
  * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @return {Duration}
  */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return _Duration.fromObject(parsed, opts);
    } else {
      return _Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
  * Create an invalid Duration.
  * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
  * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
  * @return {Duration}
  */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new _Duration({
        invalid
      });
    }
  }
  /**
  * @private
  */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
  * Check if an object is a Duration. Works across context boundaries
  * @param {object} o
  * @return {boolean}
  */
  static isDuration(o) {
    return o && o.isLuxonDuration || false;
  }
  /**
  * Get  the locale of a Duration, such 'en-GB'
  * @type {string}
  */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
  * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
  *
  * @type {string}
  */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
  * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
  * * `S` for milliseconds
  * * `s` for seconds
  * * `m` for minutes
  * * `h` for hours
  * * `d` for days
  * * `w` for weeks
  * * `M` for months
  * * `y` for years
  * Notes:
  * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
  * * Tokens can be escaped by wrapping with single quotes.
  * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
  * @param {string} fmt - the format string
  * @param {Object} opts - options
  * @param {boolean} [opts.floor=true] - floor numerical values
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
  * @return {string}
  */
  toFormat(fmt, opts = {}) {
    const fmtOpts = __spreadProps(__spreadValues({}, opts), {
      floor: opts.round !== false && opts.floor !== false
    });
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID;
  }
  /**
  * Returns a string representation of a Duration with all units included.
  * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
  * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
  * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
  * @example
  * ```js
  * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
  * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
  * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
  * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
  * ```
  */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID;
    const l2 = orderedUnits.map((unit) => {
      const val = this.values[unit];
      if (isUndefined(val)) {
        return null;
      }
      return this.loc.numberFormatter(__spreadProps(__spreadValues({
        style: "unit",
        unitDisplay: "long"
      }, opts), {
        unit: unit.slice(0, -1)
      })).format(val);
    }).filter((n2) => n2);
    return this.loc.listFormatter(__spreadValues({
      type: "conjunction",
      style: opts.listStyle || "narrow"
    }, opts)).format(l2);
  }
  /**
  * Returns a JavaScript object with this Duration's values.
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
  * @return {Object}
  */
  toObject() {
    if (!this.isValid) return {};
    return __spreadValues({}, this.values);
  }
  /**
  * Returns an ISO 8601-compliant string representation of this Duration.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
  * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
  * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
  * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
  * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
  * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
  * @return {string}
  */
  toISO() {
    if (!this.isValid) return null;
    let s2 = "P";
    if (this.years !== 0) s2 += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s2 += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s2 += this.weeks + "W";
    if (this.days !== 0) s2 += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s2 += "T";
    if (this.hours !== 0) s2 += this.hours + "H";
    if (this.minutes !== 0) s2 += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      s2 += roundTo(this.seconds + this.milliseconds / 1e3, 3) + "S";
    if (s2 === "P") s2 += "T0S";
    return s2;
  }
  /**
  * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
  * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Times
  * @param {Object} opts - options
  * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
  * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
  * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
  * @return {string}
  */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 864e5) return null;
    opts = __spreadProps(__spreadValues({
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended"
    }, opts), {
      includeOffset: false
    });
    const dateTime = DateTime.fromMillis(millis, {
      zone: "UTC"
    });
    return dateTime.toISOTime(opts);
  }
  /**
  * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
  * @return {string}
  */
  toJSON() {
    return this.toISO();
  }
  /**
  * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
  * @return {string}
  */
  toString() {
    return this.toISO();
  }
  /**
  * Returns a string representation of this Duration appropriate for the REPL.
  * @return {string}
  */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
  * Returns an milliseconds value of this Duration.
  * @return {number}
  */
  toMillis() {
    if (!this.isValid) return NaN;
    return durationToMillis(this.matrix, this.values);
  }
  /**
  * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
  * @return {number}
  */
  valueOf() {
    return this.toMillis();
  }
  /**
  * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
  * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  * @return {Duration}
  */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = _Duration.fromDurationLike(duration), result = {};
    for (const k of orderedUnits) {
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }
    return clone(this, {
      values: result
    }, true);
  }
  /**
  * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
  * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  * @return {Duration}
  */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = _Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }
  /**
  * Scale this Duration by the specified amount. Return a newly-constructed Duration.
  * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
  * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
  * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
  * @return {Duration}
  */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone(this, {
      values: result
    }, true);
  }
  /**
  * Get the value of unit.
  * @param {string} unit - a unit such as 'minute' or 'day'
  * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
  * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
  * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
  * @return {number}
  */
  get(unit) {
    return this[_Duration.normalizeUnit(unit)];
  }
  /**
  * "Set" the values of specified units. Return a newly-constructed Duration.
  * @param {Object} values - a mapping of units to numbers
  * @example dur.set({ years: 2017 })
  * @example dur.set({ hours: 8, minutes: 30 })
  * @return {Duration}
  */
  set(values) {
    if (!this.isValid) return this;
    const mixed = __spreadValues(__spreadValues({}, this.values), normalizeObject(values, _Duration.normalizeUnit));
    return clone(this, {
      values: mixed
    });
  }
  /**
  * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
  * @example dur.reconfigure({ locale: 'en-GB' })
  * @return {Duration}
  */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({
      locale,
      numberingSystem
    });
    const opts = {
      loc,
      matrix,
      conversionAccuracy
    };
    return clone(this, opts);
  }
  /**
  * Return the length of the duration in the specified unit.
  * @param {string} unit - a unit such as 'minutes' or 'days'
  * @example Duration.fromObject({years: 1}).as('days') //=> 365
  * @example Duration.fromObject({years: 1}).as('months') //=> 12
  * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
  * @return {number}
  */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
  * Reduce this Duration to its canonical representation in its current units.
  * Assuming the overall value of the Duration is positive, this means:
  * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
  * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
  *   the overall value would be negative, see third example)
  * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
  *
  * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
  * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
  * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
  * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
  * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
  * @return {Duration}
  */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone(this, {
      values: vals
    }, true);
  }
  /**
  * Rescale units to its largest representation
  * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
  * @return {Duration}
  */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone(this, {
      values: vals
    }, true);
  }
  /**
  * Convert this Duration into its representation in a different set of units.
  * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
  * @return {Duration}
  */
  shiftTo(...units) {
    if (!this.isValid) return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map((u) => _Duration.normalizeUnit(u));
    const built = {}, accumulated = {}, vals = this.toObject();
    let lastUnit;
    for (const k of orderedUnits) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        let own = 0;
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }
        if (isNumber(vals[k])) {
          own += vals[k];
        }
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1e3 - i * 1e3) / 1e3;
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues(this.matrix, built);
    return clone(this, {
      values: built
    }, true);
  }
  /**
  * Shift this Duration to all available units.
  * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
  * @return {Duration}
  */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
  }
  /**
  * Return the negative of this Duration.
  * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
  * @return {Duration}
  */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone(this, {
      values: negated
    }, true);
  }
  /**
  * Get the years.
  * @type {number}
  */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
  * Get the quarters.
  * @type {number}
  */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
  * Get the months.
  * @type {number}
  */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
  * Get the weeks
  * @type {number}
  */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
  * Get the days.
  * @type {number}
  */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
  * Get the hours.
  * @type {number}
  */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
  * Get the minutes.
  * @type {number}
  */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
  * Get the seconds.
  * @return {number}
  */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
  * Get the milliseconds.
  * @return {number}
  */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
  * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
  * on invalid DateTimes or Intervals.
  * @return {boolean}
  */
  get isValid() {
    return this.invalid === null;
  }
  /**
  * Returns an error code if this Duration became invalid, or null if the Duration is valid
  * @return {string}
  */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
  * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
  * @type {string}
  */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
  * Equality check
  * Two Durations are equal iff they have the same units and the same values for each unit.
  * @param {Duration} other
  * @return {boolean}
  */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq(v1, v2) {
      if (v1 === void 0 || v1 === 0) return v2 === void 0 || v2 === 0;
      return v1 === v2;
    }
    __name(eq, "eq");
    for (const u of orderedUnits) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
};
__name(_Duration, "Duration");
var Duration = _Duration;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/interval.js
var INVALID2 = "Invalid Interval";
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid("end before start", `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`);
  } else {
    return null;
  }
}
__name(validateStartEnd, "validateStartEnd");
var _Interval = class _Interval {
  /**
  * @private
  */
  constructor(config) {
    this.s = config.start;
    this.e = config.end;
    this.invalid = config.invalid || null;
    this.isLuxonInterval = true;
  }
  /**
  * Create an invalid Interval.
  * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
  * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
  * @return {Interval}
  */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new _Interval({
        invalid
      });
    }
  }
  /**
  * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
  * @param {DateTime|Date|Object} start
  * @param {DateTime|Date|Object} end
  * @return {Interval}
  */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
    const validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new _Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
  * Create an Interval from a start DateTime and a Duration to extend to.
  * @param {DateTime|Date|Object} start
  * @param {Duration|Object|number} duration - the length of the Interval.
  * @return {Interval}
  */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
    return _Interval.fromDateTimes(dt, dt.plus(dur));
  }
  /**
  * Create an Interval from an end DateTime and a Duration to extend backwards to.
  * @param {DateTime|Date|Object} end
  * @param {Duration|Object|number} duration - the length of the Interval.
  * @return {Interval}
  */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
    return _Interval.fromDateTimes(dt.minus(dur), dt);
  }
  /**
  * Create an Interval from an ISO 8601 string.
  * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
  * @param {string} text - the ISO string to parse
  * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @return {Interval}
  */
  static fromISO(text, opts) {
    const [s2, e] = (text || "").split("/", 2);
    if (s2 && e) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s2, opts);
        startIsValid = start.isValid;
      } catch (e2) {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e2) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return _Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return _Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s2, opts);
        if (dur.isValid) {
          return _Interval.before(end, dur);
        }
      }
    }
    return _Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }
  /**
  * Check if an object is an Interval. Works across context boundaries
  * @param {object} o
  * @return {boolean}
  */
  static isInterval(o) {
    return o && o.isLuxonInterval || false;
  }
  /**
  * Returns the start of the Interval
  * @type {DateTime}
  */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
  * Returns the end of the Interval
  * @type {DateTime}
  */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
  * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
  * @type {boolean}
  */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
  * Returns an error code if this Interval is invalid, or null if the Interval is valid
  * @type {string}
  */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
  * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
  * @type {string}
  */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
  * Returns the length of the Interval in the specified unit.
  * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
  * @return {number}
  */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[
      unit
    ]).get(unit) : NaN;
  }
  /**
  * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
  * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
  * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
  * @param {string} [unit='milliseconds'] - the unit of time to count.
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
  * @return {number}
  */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts == null ? void 0 : opts.useLocaleWeeks) {
      end = this.end.reconfigure({
        locale: start.locale
      });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }
  /**
  * Returns whether this Interval's start and end are both in the same unit of time
  * @param {string} unit - the unit of time to check sameness on
  * @return {boolean}
  */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
  * Return whether this Interval has the same start and end DateTimes.
  * @return {boolean}
  */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
  * Return whether this Interval's start is after the specified DateTime.
  * @param {DateTime} dateTime
  * @return {boolean}
  */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }
  /**
  * Return whether this Interval's end is before the specified DateTime.
  * @param {DateTime} dateTime
  * @return {boolean}
  */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }
  /**
  * Return whether this Interval contains the specified DateTime.
  * @param {DateTime} dateTime
  * @return {boolean}
  */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
  * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
  * @param {Object} values - the values to set
  * @param {DateTime} values.start - the starting DateTime
  * @param {DateTime} values.end - the ending DateTime
  * @return {Interval}
  */
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return _Interval.fromDateTimes(start || this.s, end || this.e);
  }
  /**
  * Split this Interval at each of the specified DateTimes
  * @param {...DateTime} dateTimes - the unit of time to count.
  * @return {Array}
  */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes.map(friendlyDateTime).filter((d) => this.contains(d)).sort((a, b) => a.toMillis() - b.toMillis()), results = [];
    let { s: s2 } = this, i = 0;
    while (s2 < this.e) {
      const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
      results.push(_Interval.fromDateTimes(s2, next));
      s2 = next;
      i += 1;
    }
    return results;
  }
  /**
  * Split this Interval into smaller Intervals, each of the specified length.
  * Left over time is grouped into a smaller interval
  * @param {Duration|Object|number} duration - The length of each resulting interval.
  * @return {Array}
  */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let { s: s2 } = this, idx = 1, next;
    const results = [];
    while (s2 < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(_Interval.fromDateTimes(s2, next));
      s2 = next;
      idx += 1;
    }
    return results;
  }
  /**
  * Split this Interval into the specified number of smaller intervals.
  * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
  * @return {Array}
  */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
  * Return whether this Interval overlaps with the specified Interval
  * @param {Interval} other
  * @return {boolean}
  */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
  * Return whether this Interval's end is adjacent to the specified Interval's start.
  * @param {Interval} other
  * @return {boolean}
  */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }
  /**
  * Return whether this Interval's start is adjacent to the specified Interval's end.
  * @param {Interval} other
  * @return {boolean}
  */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }
  /**
  * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
  * @param {Interval} other
  * @return {boolean}
  */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
  * Return whether this Interval has the same start and end as the specified Interval.
  * @param {Interval} other
  * @return {boolean}
  */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
  * Return an Interval representing the intersection of this Interval and the specified Interval.
  * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
  * Returns null if the intersection is empty, meaning, the intervals don't intersect.
  * @param {Interval} other
  * @return {Interval}
  */
  intersection(other) {
    if (!this.isValid) return this;
    const s2 = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
    if (s2 >= e) {
      return null;
    } else {
      return _Interval.fromDateTimes(s2, e);
    }
  }
  /**
  * Return an Interval representing the union of this Interval and the specified Interval.
  * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
  * @param {Interval} other
  * @return {Interval}
  */
  union(other) {
    if (!this.isValid) return this;
    const s2 = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
    return _Interval.fromDateTimes(s2, e);
  }
  /**
  * Merge an array of Intervals into a equivalent minimal set of Intervals.
  * Combines overlapping and adjacent Intervals.
  * @param {Array} intervals
  * @return {Array}
  */
  static merge(intervals) {
    const [found, final] = intervals.sort((a, b) => a.s - b.s).reduce(([sofar, current], item) => {
      if (!current) {
        return [
          sofar,
          item
        ];
      } else if (current.overlaps(item) || current.abutsStart(item)) {
        return [
          sofar,
          current.union(item)
        ];
      } else {
        return [
          sofar.concat([
            current
          ]),
          item
        ];
      }
    }, [
      [],
      null
    ]);
    if (final) {
      found.push(final);
    }
    return found;
  }
  /**
  * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
  * @param {Array} intervals
  * @return {Array}
  */
  static xor(intervals) {
    let start = null, currentCount = 0;
    const results = [], ends = intervals.map((i) => [
      {
        time: i.s,
        type: "s"
      },
      {
        time: i.e,
        type: "e"
      }
    ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b) => a.time - b.time);
    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(_Interval.fromDateTimes(start, i.time));
        }
        start = null;
      }
    }
    return _Interval.merge(results);
  }
  /**
  * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
  * @param {...Interval} intervals
  * @return {Array}
  */
  difference(...intervals) {
    return _Interval.xor([
      this
    ].concat(intervals)).map((i) => this.intersection(i)).filter((i) => i && !i.isEmpty());
  }
  /**
  * Returns a string representation of this Interval appropriate for debugging.
  * @return {string}
  */
  toString() {
    if (!this.isValid) return INVALID2;
    return `[${this.s.toISO()} \u2013 ${this.e.toISO()})`;
  }
  /**
  * Returns a string representation of this Interval appropriate for the REPL.
  * @return {string}
  */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
  * Returns a localized string representing this Interval. Accepts the same options as the
  * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
  * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
  * is browser-specific, but in general it will return an appropriate representation of the
  * Interval in the assigned locale. Defaults to the system's locale if no locale has been
  * specified.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
  * Intl.DateTimeFormat constructor options.
  * @param {Object} opts - Options to override the configuration of the start DateTime.
  * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
  * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
  * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
  * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
  * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
  * @return {string}
  */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID2;
  }
  /**
  * Returns an ISO 8601-compliant string representation of this Interval.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @param {Object} opts - The same options as {@link DateTime#toISO}
  * @return {string}
  */
  toISO(opts) {
    if (!this.isValid) return INVALID2;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }
  /**
  * Returns an ISO 8601-compliant string representation of date of this Interval.
  * The time components are ignored.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @return {string}
  */
  toISODate() {
    if (!this.isValid) return INVALID2;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }
  /**
  * Returns an ISO 8601-compliant string representation of time of this Interval.
  * The date components are ignored.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @param {Object} opts - The same options as {@link DateTime#toISO}
  * @return {string}
  */
  toISOTime(opts) {
    if (!this.isValid) return INVALID2;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }
  /**
  * Returns a string representation of this Interval formatted according to the specified format
  * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
  * formatting tool.
  * @param {string} dateFormat - The format string. This string formats the start and end time.
  * See {@link DateTime#toFormat} for details.
  * @param {Object} opts - Options.
  * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
  * representations.
  * @return {string}
  */
  toFormat(dateFormat, { separator = " \u2013 " } = {}) {
    if (!this.isValid) return INVALID2;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }
  /**
  * Return a Duration representing the time spanned by this interval.
  * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
  * @param {Object} opts - options that affect the creation of the Duration
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
  * @return {Duration}
  */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }
  /**
  * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
  * @param {function} mapFn
  * @return {Interval}
  * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
  * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
  */
  mapEndpoints(mapFn) {
    return _Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
};
__name(_Interval, "Interval");
var Interval = _Interval;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/info.js
var _Info = class _Info {
  /**
  * Return whether the specified zone contains a DST.
  * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
  * @return {boolean}
  */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({
      month: 12
    });
    return !zone.isUniversal && proto.offset !== proto.set({
      month: 6
    }).offset;
  }
  /**
  * Return whether the specified zone is a valid IANA specifier.
  * @param {string} zone - Zone to check
  * @return {boolean}
  */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }
  /**
  * Converts the input into a {@link Zone} instance.
  *
  * * If `input` is already a Zone instance, it is returned unchanged.
  * * If `input` is a string containing a valid time zone name, a Zone instance
  *   with that name is returned.
  * * If `input` is a string that doesn't refer to a known time zone, a Zone
  *   instance with {@link Zone#isValid} == false is returned.
  * * If `input is a number, a Zone instance with the specified fixed offset
  *   in minutes is returned.
  * * If `input` is `null` or `undefined`, the default zone is returned.
  * @param {string|Zone|number} [input] - the value to be converted
  * @return {Zone}
  */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
  * Get the weekday on which the week starts according to the given locale.
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
  */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }
  /**
  * Get the minimum number of days necessary in a week before it is considered part of the next year according
  * to the given locale.
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @returns {number}
  */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }
  /**
  * Get the weekdays, which are considered the weekend according to the given locale
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
  */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }
  /**
  * Return an array of standalone month names.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @param {string} [opts.outputCalendar='gregory'] - the calendar
  * @example Info.months()[0] //=> 'January'
  * @example Info.months('short')[0] //=> 'Jan'
  * @example Info.months('numeric')[0] //=> '1'
  * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
  * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
  * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
  * @return {Array}
  */
  static months(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  /**
  * Return an array of format month names.
  * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
  * changes the string.
  * See {@link Info#months}
  * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @param {string} [opts.outputCalendar='gregory'] - the calendar
  * @return {Array}
  */
  static monthsFormat(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  /**
  * Return an array of standalone week names.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @example Info.weekdays()[0] //=> 'Monday'
  * @example Info.weekdays('short')[0] //=> 'Mon'
  * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
  * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
  * @return {Array}
  */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  /**
  * Return an array of format week names.
  * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
  * changes the string.
  * See {@link Info#weekdays}
  * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
  * @param {Object} opts - options
  * @param {string} [opts.locale=null] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @return {Array}
  */
  static weekdaysFormat(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  /**
  * Return an array of meridiems.
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @example Info.meridiems() //=> [ 'AM', 'PM' ]
  * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
  * @return {Array}
  */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }
  /**
  * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
  * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @example Info.eras() //=> [ 'BC', 'AD' ]
  * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
  * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
  * @return {Array}
  */
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }
  /**
  * Return the set of available features in this environment.
  * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
  * Keys:
  * * `relative`: whether this environment supports relative time formatting
  * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
  * @example Info.features() //=> { relative: false, localeWeek: true }
  * @return {Object}
  */
  static features() {
    return {
      relative: hasRelative(),
      localeWeek: hasLocaleWeekInfo()
    };
  }
};
__name(_Info, "Info");
var Info = _Info;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/diff.js
function dayDiff(earlier, later) {
  const utcDayStart = /* @__PURE__ */ __name((dt) => dt.toUTC(0, {
    keepLocalTime: true
  }).startOf("day").valueOf(), "utcDayStart"), ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
__name(dayDiff, "dayDiff");
function highOrderDiffs(cursor, later, units) {
  const differs = [
    [
      "years",
      (a, b) => b.year - a.year
    ],
    [
      "quarters",
      (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4
    ],
    [
      "months",
      (a, b) => b.month - a.month + (b.year - a.year) * 12
    ],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - days % 7) / 7;
      }
    ],
    [
      "days",
      dayDiff
    ]
  ];
  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        results[unit]--;
        cursor = earlier.plus(results);
        if (cursor > later) {
          highWater = cursor;
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }
  return [
    cursor,
    results,
    highWater,
    lowestOrder
  ];
}
__name(highOrderDiffs, "highOrderDiffs");
function diff_default(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor;
  const lowerOrderUnits = units.filter((u) => [
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ].indexOf(u) >= 0);
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({
        [lowestOrder]: 1
      });
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  const duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}
__name(diff_default, "default");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/tokenParser.js
var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = (i) => i) {
  return {
    regex,
    deser: /* @__PURE__ */ __name(([s2]) => post(parseDigits(s2)), "deser")
  };
}
__name(intUnit, "intUnit");
var NBSP = String.fromCharCode(160);
var spaceOrNBSP = `[ ${NBSP}]`;
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s2) {
  return s2.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
__name(fixListRegex, "fixListRegex");
function stripInsensitivities(s2) {
  return s2.replace(/\./g, "").replace(spaceOrNBSPRegExp, " ").toLowerCase();
}
__name(stripInsensitivities, "stripInsensitivities");
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: /* @__PURE__ */ __name(([s2]) => strings.findIndex((i) => stripInsensitivities(s2) === stripInsensitivities(i)) + startIndex, "deser")
    };
  }
}
__name(oneOf, "oneOf");
function offset(regex, groups) {
  return {
    regex,
    deser: /* @__PURE__ */ __name(([, h, m]) => signedOffset(h, m), "deser"),
    groups
  };
}
__name(offset, "offset");
function simple(regex) {
  return {
    regex,
    deser: /* @__PURE__ */ __name(([s2]) => s2, "deser")
  };
}
__name(simple, "simple");
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
__name(escapeToken, "escapeToken");
function unitForToken(token, loc) {
  const one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal2 = /* @__PURE__ */ __name((t) => ({
    regex: RegExp(escapeToken(t.val)),
    deser: /* @__PURE__ */ __name(([s2]) => s2, "deser"),
    literal: true
  }), "literal"), unitate = /* @__PURE__ */ __name((t) => {
    if (token.literal) {
      return literal2(t);
    }
    switch (t.val) {
      // era
      case "G":
        return oneOf(loc.eras("short"), 0);
      case "GG":
        return oneOf(loc.eras("long"), 0);
      // years
      case "y":
        return intUnit(oneToSix);
      case "yy":
        return intUnit(twoToFour, untruncateYear);
      case "yyyy":
        return intUnit(four);
      case "yyyyy":
        return intUnit(fourToSix);
      case "yyyyyy":
        return intUnit(six);
      // months
      case "M":
        return intUnit(oneOrTwo);
      case "MM":
        return intUnit(two);
      case "MMM":
        return oneOf(loc.months("short", true), 1);
      case "MMMM":
        return oneOf(loc.months("long", true), 1);
      case "L":
        return intUnit(oneOrTwo);
      case "LL":
        return intUnit(two);
      case "LLL":
        return oneOf(loc.months("short", false), 1);
      case "LLLL":
        return oneOf(loc.months("long", false), 1);
      // dates
      case "d":
        return intUnit(oneOrTwo);
      case "dd":
        return intUnit(two);
      // ordinals
      case "o":
        return intUnit(oneToThree);
      case "ooo":
        return intUnit(three);
      // time
      case "HH":
        return intUnit(two);
      case "H":
        return intUnit(oneOrTwo);
      case "hh":
        return intUnit(two);
      case "h":
        return intUnit(oneOrTwo);
      case "mm":
        return intUnit(two);
      case "m":
        return intUnit(oneOrTwo);
      case "q":
        return intUnit(oneOrTwo);
      case "qq":
        return intUnit(two);
      case "s":
        return intUnit(oneOrTwo);
      case "ss":
        return intUnit(two);
      case "S":
        return intUnit(oneToThree);
      case "SSS":
        return intUnit(three);
      case "u":
        return simple(oneToNine);
      case "uu":
        return simple(oneOrTwo);
      case "uuu":
        return intUnit(one);
      // meridiem
      case "a":
        return oneOf(loc.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return intUnit(four);
      case "kk":
        return intUnit(twoToFour, untruncateYear);
      // weekNumber (W)
      case "W":
        return intUnit(oneOrTwo);
      case "WW":
        return intUnit(two);
      // weekdays
      case "E":
      case "c":
        return intUnit(one);
      case "EEE":
        return oneOf(loc.weekdays("short", false), 1);
      case "EEEE":
        return oneOf(loc.weekdays("long", false), 1);
      case "ccc":
        return oneOf(loc.weekdays("short", true), 1);
      case "cccc":
        return oneOf(loc.weekdays("long", true), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
      case "ZZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return simple(/[^\S\n\r]/);
      default:
        return literal2(t);
    }
  }, "unitate");
  const unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}
__name(unitForToken, "unitForToken");
var partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type, value } = part;
  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  const style = formatOpts[type];
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val
    };
  }
  return void 0;
}
__name(tokenForPart, "tokenForPart");
function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r) => `${f}(${r.source})`, "");
  return [
    `^${re}$`,
    units
  ];
}
__name(buildRegex, "buildRegex");
function match(input, regex, handlers) {
  const matches = input.match(regex);
  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [
      matches,
      all
    ];
  } else {
    return [
      matches,
      {}
    ];
  }
}
__name(match, "match");
function dateTimeFromMatches(matches) {
  const toField = /* @__PURE__ */ __name((token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  }, "toField");
  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  const vals = Object.keys(matches).reduce((r, k) => {
    const f = toField(k);
    if (f) {
      r[f] = matches[k];
    }
    return r;
  }, {});
  return [
    vals,
    zone,
    specificOffset
  ];
}
__name(dateTimeFromMatches, "dateTimeFromMatches");
var dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
__name(getDummyDateTime, "getDummyDateTime");
function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }
  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(void 0)) {
    return token;
  }
  return tokens;
}
__name(maybeExpandMacroToken, "maybeExpandMacroToken");
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken(t, locale)));
}
__name(expandMacroTokens, "expandMacroTokens");
var _TokenParser = class _TokenParser {
  constructor(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
    this.units = this.tokens.map((t) => unitForToken(t, locale));
    this.disqualifyingUnit = this.units.find((t) => t.invalidReason);
    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }
  explainFromTokens(input) {
    if (!this.isValid) {
      return {
        input,
        tokens: this.tokens,
        invalidReason: this.invalidReason
      };
    } else {
      const [rawMatches, matches] = match(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [
        null,
        null,
        void 0
      ];
      if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
        throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches,
        result,
        zone,
        specificOffset
      };
    }
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
};
__name(_TokenParser, "TokenParser");
var TokenParser = _TokenParser;
function explainFromTokens(locale, input, format) {
  const parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}
__name(explainFromTokens, "explainFromTokens");
function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [
    result,
    zone,
    specificOffset,
    invalidReason
  ];
}
__name(parseFromTokens, "parseFromTokens");
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter = Formatter.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p) => tokenForPart(p, formatOpts, resolvedOpts));
}
__name(formatOptsToTokens, "formatOptsToTokens");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/datetime.js
var INVALID3 = "Invalid DateTime";
var MAX_DATE = 864e13;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
__name(unsupportedZone, "unsupportedZone");
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}
__name(possiblyCachedWeekData, "possiblyCachedWeekData");
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
  }
  return dt.localWeekData;
}
__name(possiblyCachedLocalWeekData, "possiblyCachedLocalWeekData");
function clone2(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime(__spreadProps(__spreadValues(__spreadValues({}, current), alts), {
    old: current
  }));
}
__name(clone2, "clone");
function fixOffset(localTS, o, tz) {
  let utcGuess = localTS - o * 60 * 1e3;
  const o2 = tz.offset(utcGuess);
  if (o === o2) {
    return [
      utcGuess,
      o
    ];
  }
  utcGuess -= (o2 - o) * 60 * 1e3;
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [
      utcGuess,
      o2
    ];
  }
  return [
    localTS - Math.min(o2, o3) * 60 * 1e3,
    Math.max(o2, o3)
  ];
}
__name(fixOffset, "fixOffset");
function tsToObj(ts, offset2) {
  ts += offset2 * 60 * 1e3;
  const d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
}
__name(tsToObj, "tsToObj");
function objToTS(obj, offset2, zone) {
  return fixOffset(objToLocalTS(obj), offset2, zone);
}
__name(objToTS, "objToTS");
function adjustTime(inst, dur) {
  const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = __spreadProps(__spreadValues({}, inst.c), {
    year,
    month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }), millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"), localTS = objToLocalTS(c);
  let [ts, o] = fixOffset(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    o = inst.zone.offset(ts);
  }
  return {
    ts,
    o
  };
}
__name(adjustTime, "adjustTime");
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    const interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, __spreadProps(__spreadValues({}, opts), {
      zone: interpretationZone,
      specificOffset
    }));
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`));
  }
}
__name(parseDataToDateTime, "parseDataToDateTime");
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
__name(toTechFormat, "toTechFormat");
function toISODate(o, extended) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);
  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    c += "-";
    c += padStart(o.c.day);
  } else {
    c += padStart(o.c.month);
    c += padStart(o.c.day);
  }
  return c;
}
__name(toISODate, "toISODate");
function toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
  let c = padStart(o.c.hour);
  if (extended) {
    c += ":";
    c += padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
      c += ":";
    }
  } else {
    c += padStart(o.c.minute);
  }
  if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
    c += padStart(o.c.second);
    if (o.c.millisecond !== 0 || !suppressMilliseconds) {
      c += ".";
      c += padStart(o.c.millisecond, 3);
    }
  }
  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }
  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}
__name(toISOTime, "toISOTime");
var defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var orderedUnits2 = [
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
var orderedWeekUnits = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
];
var orderedOrdinalUnits = [
  "year",
  "ordinal",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
}
__name(normalizeUnit, "normalizeUnit");
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}
__name(normalizeUnitWithLocalWeeks, "normalizeUnitWithLocalWeeks");
function guessOffsetForZone(zone) {
  if (!zoneOffsetGuessCache[zone]) {
    if (zoneOffsetTs === void 0) {
      zoneOffsetTs = Settings.now();
    }
    zoneOffsetGuessCache[zone] = zone.offset(zoneOffsetTs);
  }
  return zoneOffsetGuessCache[zone];
}
__name(guessOffsetForZone, "guessOffsetForZone");
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }
  const loc = Locale.fromObject(opts);
  let ts, o;
  if (!isUndefined(obj.year)) {
    for (const u of orderedUnits2) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const offsetProvis = guessOffsetForZone(zone);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = Settings.now();
  }
  return new DateTime({
    ts,
    zone,
    loc,
    o
  });
}
__name(quickDT, "quickDT");
function diffRelative(start, end, opts) {
  const round = isUndefined(opts.round) ? true : opts.round, format = /* @__PURE__ */ __name((c, unit) => {
    c = roundTo(c, round || opts.calendary ? 0 : 2, true);
    const formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c, unit);
  }, "format"), differ = /* @__PURE__ */ __name((unit) => {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  }, "differ");
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
__name(diffRelative, "diffRelative");
function lastOpts(argList) {
  let opts = {}, args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [
    opts,
    args
  ];
}
__name(lastOpts, "lastOpts");
var zoneOffsetTs;
var zoneOffsetGuessCache = {};
var _DateTime = class _DateTime {
  /**
  * @access private
  */
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;
    let invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    let c = null, o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) {
        [c, o] = [
          config.old.c,
          config.old.o
        ];
      } else {
        const ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }
    this._zone = zone;
    this.loc = config.loc || Locale.create();
    this.invalid = invalid;
    this.weekData = null;
    this.localWeekData = null;
    this.c = c;
    this.o = o;
    this.isLuxonDateTime = true;
  }
  // CONSTRUCT
  /**
  * Create a DateTime for the current instant, in the system's time zone.
  *
  * Use Settings to override these default values if needed.
  * @example DateTime.now().toISO() //~> now in the ISO format
  * @return {DateTime}
  */
  static now() {
    return new _DateTime({});
  }
  /**
  * Create a local DateTime
  * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
  * @param {number} [month=1] - The month, 1-indexed
  * @param {number} [day=1] - The day of the month, 1-indexed
  * @param {number} [hour=0] - The hour of the day, in 24-hour time
  * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
  * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
  * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
  * @example DateTime.local()                                  //~> now
  * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
  * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
  * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
  * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
  * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
  * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
  * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
  * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
  * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
  * @return {DateTime}
  */
  static local() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond
    }, opts);
  }
  /**
  * Create a DateTime in UTC
  * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
  * @param {number} [month=1] - The month, 1-indexed
  * @param {number} [day=1] - The day of the month
  * @param {number} [hour=0] - The hour of the day, in 24-hour time
  * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
  * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
  * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
  * @param {Object} options - configuration options for the DateTime
  * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
  * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
  * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
  * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
  * @example DateTime.utc()                                              //~> now
  * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
  * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
  * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
  * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
  * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
  * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
  * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
  * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
  * @return {DateTime}
  */
  static utc() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond
    }, opts);
  }
  /**
  * Create a DateTime from a JavaScript Date object. Uses the default zone.
  * @param {Date} date - a JavaScript Date object
  * @param {Object} options - configuration options for the DateTime
  * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
  * @return {DateTime}
  */
  static fromJSDate(date2, options = {}) {
    const ts = isDate(date2) ? date2.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return _DateTime.invalid("invalid input");
    }
    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return _DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new _DateTime({
      ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }
  /**
  * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
  * @param {number} milliseconds - a number of milliseconds since 1970 UTC
  * @param {Object} options - configuration options for the DateTime
  * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
  * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
  * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
  * @return {DateTime}
  */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(`fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`);
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      return _DateTime.invalid("Timestamp out of range");
    } else {
      return new _DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
  * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
  * @param {number} seconds - a number of seconds since 1970 UTC
  * @param {Object} options - configuration options for the DateTime
  * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
  * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
  * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
  * @return {DateTime}
  */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new _DateTime({
        ts: seconds * 1e3,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
  * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
  * @param {Object} obj - the object to create the DateTime from
  * @param {number} obj.year - a year, such as 1987
  * @param {number} obj.month - a month, 1-12
  * @param {number} obj.day - a day of the month, 1-31, depending on the month
  * @param {number} obj.ordinal - day of the year, 1-365 or 366
  * @param {number} obj.weekYear - an ISO week year
  * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
  * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
  * @param {number} obj.localWeekYear - a week year, according to the locale
  * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
  * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
  * @param {number} obj.hour - hour of the day, 0-23
  * @param {number} obj.minute - minute of the hour, 0-59
  * @param {number} obj.second - second of the minute, 0-59
  * @param {number} obj.millisecond - millisecond of the second, 0-999
  * @param {Object} opts - options for creating this DateTime
  * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
  * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
  * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
  * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
  * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
  * @return {DateTime}
  */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return _DateTime.invalid(unsupportedZone(zoneToUse));
    }
    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);
    const tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
    let units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits2;
      defaultValues = defaultUnitValues;
    }
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }
    const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return _DateTime.invalid(invalid);
    }
    const gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new _DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc
    });
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return _DateTime.invalid("mismatched weekday", `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`);
    }
    if (!inst.isValid) {
      return _DateTime.invalid(inst.invalid);
    }
    return inst;
  }
  /**
  * Create a DateTime from an ISO 8601 string
  * @param {string} text - the ISO string
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
  * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
  * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
  * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
  * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromISO('2016-05-25T09:08:34.123')
  * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
  * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
  * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
  * @example DateTime.fromISO('2016-W05-4')
  * @return {DateTime}
  */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
  * Create a DateTime from an RFC 2822 string
  * @param {string} text - the RFC 2822 string
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
  * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
  * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
  * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
  * @return {DateTime}
  */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
  * Create a DateTime from an HTTP header date
  * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
  * @param {string} text - the HTTP header date
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
  * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
  * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
  * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
  * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
  * @return {DateTime}
  */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
  * Create a DateTime from an input string and format string.
  * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
  * @param {string} text - the string to parse
  * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
  * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
  * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @return {DateTime}
  */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    }), [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return _DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }
  /**
  * @deprecated use fromFormat instead
  */
  static fromString(text, fmt, opts = {}) {
    return _DateTime.fromFormat(text, fmt, opts);
  }
  /**
  * Create a DateTime from a SQL date, time, or datetime
  * Defaults to en-US if no locale has been specified, regardless of the system's locale
  * @param {string} text - the string to parse
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
  * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
  * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @example DateTime.fromSQL('2017-05-15')
  * @example DateTime.fromSQL('2017-05-15 09:12:34')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
  * @example DateTime.fromSQL('09:12:34.342')
  * @return {DateTime}
  */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
  * Create an invalid DateTime.
  * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
  * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
  * @return {DateTime}
  */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new _DateTime({
        invalid
      });
    }
  }
  /**
  * Check if an object is an instance of DateTime. Works across context boundaries
  * @param {object} o
  * @return {boolean}
  */
  static isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  }
  /**
  * Produce the format string for a set of options
  * @param formatOpts
  * @param localeOpts
  * @returns {string}
  */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t) => t ? t.val : null).join("");
  }
  /**
  * Produce the the fully expanded format token for the locale
  * Does NOT quote characters, so quoted tokens will not round trip correctly
  * @param fmt
  * @param localeOpts
  * @returns {string}
  */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t) => t.val).join("");
  }
  static resetCache() {
    zoneOffsetTs = void 0;
    zoneOffsetGuessCache = {};
  }
  // INFO
  /**
  * Get the value of unit.
  * @param {string} unit - a unit such as 'minute' or 'day'
  * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
  * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
  * @return {number}
  */
  get(unit) {
    return this[unit];
  }
  /**
  * Returns whether the DateTime is valid. Invalid DateTimes occur when:
  * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
  * * The DateTime was created by an operation on another invalid date
  * @type {boolean}
  */
  get isValid() {
    return this.invalid === null;
  }
  /**
  * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
  * @type {string}
  */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
  * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
  * @type {string}
  */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
  * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
  *
  * @type {string}
  */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
  * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
  *
  * @type {string}
  */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
  * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
  *
  * @type {string}
  */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
  * Get the time zone associated with this DateTime.
  * @type {Zone}
  */
  get zone() {
    return this._zone;
  }
  /**
  * Get the name of the time zone.
  * @type {string}
  */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
  * Get the year
  * @example DateTime.local(2017, 5, 25).year //=> 2017
  * @type {number}
  */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
  * Get the quarter
  * @example DateTime.local(2017, 5, 25).quarter //=> 2
  * @type {number}
  */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
  * Get the month (1-12).
  * @example DateTime.local(2017, 5, 25).month //=> 5
  * @type {number}
  */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
  * Get the day of the month (1-30ish).
  * @example DateTime.local(2017, 5, 25).day //=> 25
  * @type {number}
  */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
  * Get the hour of the day (0-23).
  * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
  * @type {number}
  */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
  * Get the minute of the hour (0-59).
  * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
  * @type {number}
  */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
  * Get the second of the minute (0-59).
  * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
  * @type {number}
  */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
  * Get the millisecond of the second (0-999).
  * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
  * @type {number}
  */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
  * Get the week year
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
  * @type {number}
  */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  /**
  * Get the week number of the week year (1-52ish).
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
  * @type {number}
  */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  /**
  * Get the day of the week.
  * 1 is Monday and 7 is Sunday
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2014, 11, 31).weekday //=> 4
  * @type {number}
  */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  /**
  * Returns true if this date is on a weekend according to the locale, false otherwise
  * @returns {boolean}
  */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
  * Get the day of the week according to the locale.
  * 1 is the first day of the week and 7 is the last day of the week.
  * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
  * @returns {number}
  */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }
  /**
  * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
  * because the week can start on different days of the week (see localWeekday) and because a different number of days
  * is required for a week to count as the first week of a year.
  * @returns {number}
  */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }
  /**
  * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
  * differently, see localWeekNumber.
  * @returns {number}
  */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }
  /**
  * Get the ordinal (meaning the day of the year)
  * @example DateTime.local(2017, 5, 25).ordinal //=> 145
  * @type {number|DateTime}
  */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  /**
  * Get the human readable short month name, such as 'Oct'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
  * @type {string}
  */
  get monthShort() {
    return this.isValid ? Info.months("short", {
      locObj: this.loc
    })[this.month - 1] : null;
  }
  /**
  * Get the human readable long month name, such as 'October'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).monthLong //=> October
  * @type {string}
  */
  get monthLong() {
    return this.isValid ? Info.months("long", {
      locObj: this.loc
    })[this.month - 1] : null;
  }
  /**
  * Get the human readable short weekday, such as 'Mon'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
  * @type {string}
  */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", {
      locObj: this.loc
    })[this.weekday - 1] : null;
  }
  /**
  * Get the human readable long weekday, such as 'Monday'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
  * @type {string}
  */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", {
      locObj: this.loc
    })[this.weekday - 1] : null;
  }
  /**
  * Get the UTC offset of this DateTime in minutes
  * @example DateTime.now().offset //=> -240
  * @example DateTime.utc().offset //=> 0
  * @type {number}
  */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
  * Get the short human name for the zone's current offset, for example "EST" or "EDT".
  * Defaults to the system's locale if no locale has been specified
  * @type {string}
  */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
  * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
  * Defaults to the system's locale if no locale has been specified
  * @type {string}
  */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
  * Get whether this zone's offset ever changes, as in a DST.
  * @type {boolean}
  */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
  * Get whether the DateTime is in a DST.
  * @type {boolean}
  */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return this.offset > this.set({
        month: 1,
        day: 1
      }).offset || this.offset > this.set({
        month: 5
      }).offset;
    }
  }
  /**
  * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
  * in this DateTime's zone. During DST changes local time can be ambiguous, for example
  * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
  * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
  * @returns {DateTime[]}
  */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [
        this
      ];
    }
    const dayMs = 864e5;
    const minuteMs = 6e4;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);
    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [
        this
      ];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj(ts1, o1);
    const c2 = tsToObj(ts2, o2);
    if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) {
      return [
        clone2(this, {
          ts: ts1
        }),
        clone2(this, {
          ts: ts2
        })
      ];
    }
    return [
      this
    ];
  }
  /**
  * Returns true if this DateTime is in a leap year, false otherwise
  * @example DateTime.local(2016).isInLeapYear //=> true
  * @example DateTime.local(2013).isInLeapYear //=> false
  * @type {boolean}
  */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  /**
  * Returns the number of days in this DateTime's month
  * @example DateTime.local(2016, 2).daysInMonth //=> 29
  * @example DateTime.local(2016, 3).daysInMonth //=> 31
  * @type {number}
  */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  /**
  * Returns the number of days in this DateTime's year
  * @example DateTime.local(2016).daysInYear //=> 366
  * @example DateTime.local(2013).daysInYear //=> 365
  * @type {number}
  */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  /**
  * Returns the number of weeks in this DateTime's year
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2004).weeksInWeekYear //=> 53
  * @example DateTime.local(2013).weeksInWeekYear //=> 52
  * @type {number}
  */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  /**
  * Returns the number of weeks in this DateTime's local week year
  * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
  * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
  * @type {number}
  */
  get weeksInLocalWeekYear() {
    return this.isValid ? weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
  }
  /**
  * Returns the resolved Intl options for this DateTime.
  * This is useful in understanding the behavior of formatting methods
  * @param {Object} opts - the same options as toLocaleString
  * @return {Object}
  */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this);
    return {
      locale,
      numberingSystem,
      outputCalendar: calendar
    };
  }
  // TRANSFORM
  /**
  * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
  *
  * Equivalent to {@link DateTime#setZone}('utc')
  * @param {number} [offset=0] - optionally, an offset from UTC in minutes
  * @param {Object} [opts={}] - options to pass to `setZone()`
  * @return {DateTime}
  */
  toUTC(offset2 = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset2), opts);
  }
  /**
  * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
  *
  * Equivalent to `setZone('local')`
  * @return {DateTime}
  */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
  * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
  *
  * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
  * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
  * @param {Object} opts - options
  * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
  * @return {DateTime}
  */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return _DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone2(this, {
        ts: newTS,
        zone
      });
    }
  }
  /**
  * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
  * @param {Object} properties - the properties to set
  * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
  * @return {DateTime}
  */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({
      locale,
      numberingSystem,
      outputCalendar
    });
    return clone2(this, {
      loc
    });
  }
  /**
  * "Set" the locale. Returns a newly-constructed DateTime.
  * Just a convenient alias for reconfigure({ locale })
  * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
  * @return {DateTime}
  */
  setLocale(locale) {
    return this.reconfigure({
      locale
    });
  }
  /**
  * "Set" the values of specified units. Returns a newly-constructed DateTime.
  * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
  *
  * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
  * They cannot be mixed with ISO-week units like `weekday`.
  * @param {Object} values - a mapping of units to numbers
  * @example dt.set({ year: 2017 })
  * @example dt.set({ hour: 8, minute: 30 })
  * @example dt.set({ weekday: 5 })
  * @example dt.set({ year: 2005, ordinal: 234 })
  * @return {DateTime}
  */
  set(values) {
    if (!this.isValid) return this;
    const normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);
    const settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(__spreadValues(__spreadValues({}, gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek)), normalized), minDaysInFirstWeek, startOfWeek);
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian(__spreadValues(__spreadValues({}, gregorianToOrdinal(this.c)), normalized));
    } else {
      mixed = __spreadValues(__spreadValues({}, this.toObject()), normalized);
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return clone2(this, {
      ts,
      o
    });
  }
  /**
  * Add a period of time to this DateTime and return the resulting DateTime
  *
  * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
  * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  * @example DateTime.now().plus(123) //~> in 123 milliseconds
  * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
  * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
  * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
  * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
  * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
  * @return {DateTime}
  */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return clone2(this, adjustTime(this, dur));
  }
  /**
  * Subtract a period of time to this DateTime and return the resulting DateTime
  * See {@link DateTime#plus}
  * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  @return {DateTime}
  */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone2(this, adjustTime(this, dur));
  }
  /**
  * "Set" this DateTime to the beginning of a unit of time.
  * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
  * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
  * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
  * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
  * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
  * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
  * @return {DateTime}
  */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;
    const o = {}, normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
      case "milliseconds":
        break;
    }
    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }
    return this.set(o);
  }
  /**
  * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
  * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
  * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
  * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
  * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
  * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
  * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
  * @return {DateTime}
  */
  endOf(unit, opts) {
    return this.isValid ? this.plus({
      [unit]: 1
    }).startOf(unit, opts).minus(1) : this;
  }
  // OUTPUT
  /**
  * Returns a string representation of this DateTime formatted according to the specified format string.
  * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
  * Defaults to en-US if no locale has been specified, regardless of the system's locale.
  * @param {string} fmt - the format string
  * @param {Object} opts - opts to override the configuration options on this DateTime
  * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
  * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
  * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
  * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
  * @return {string}
  */
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID3;
  }
  /**
  * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
  * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
  * of the DateTime in the assigned locale.
  * Defaults to the system's locale if no locale has been specified
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
  * @param {Object} opts - opts to override the configuration options on this DateTime
  * @example DateTime.now().toLocaleString(); //=> 4/20/2017
  * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
  * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
  * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
  * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
  * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
  * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
  * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
  * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
  * @return {string}
  */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID3;
  }
  /**
  * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
  * Defaults to the system's locale if no locale has been specified
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
  * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
  * @example DateTime.now().toLocaleParts(); //=> [
  *                                   //=>   { type: 'day', value: '25' },
  *                                   //=>   { type: 'literal', value: '/' },
  *                                   //=>   { type: 'month', value: '05' },
  *                                   //=>   { type: 'literal', value: '/' },
  *                                   //=>   { type: 'year', value: '1982' }
  *                                   //=> ]
  */
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime
  * @param {Object} opts - options
  * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
  * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
  * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
  * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
  * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
  * @return {string}
  */
  toISO({ format = "extended", suppressSeconds = false, suppressMilliseconds = false, includeOffset = true, extendedZone = false } = {}) {
    if (!this.isValid) {
      return null;
    }
    const ext = format === "extended";
    let c = toISODate(this, ext);
    c += "T";
    c += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c;
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime's date component
  * @param {Object} opts - options
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
  * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
  * @return {string}
  */
  toISODate({ format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format === "extended");
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime's week date
  * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
  * @return {string}
  */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime's time component
  * @param {Object} opts - options
  * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
  * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
  * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
  * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
  * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
  * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
  * @return {string}
  */
  toISOTime({ suppressMilliseconds = false, suppressSeconds = false, includeOffset = true, includePrefix = false, extendedZone = false, format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }
    let c = includePrefix ? "T" : "";
    return c + toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
  }
  /**
  * Returns an RFC 2822-compatible string representation of this DateTime
  * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
  * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
  * @return {string}
  */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
  * Specifically, the string conforms to RFC 1123.
  * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
  * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
  * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
  * @return {string}
  */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in SQL Date
  * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
  * @return {string}
  */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in SQL Time
  * @param {Object} opts - options
  * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
  * @example DateTime.utc().toSQL() //=> '05:15:16.345'
  * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
  * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
  * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
  * @return {string}
  */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in SQL DateTime
  * @param {Object} opts - options
  * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
  * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
  * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
  * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
  * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
  * @return {string}
  */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }
  /**
  * Returns a string representation of this DateTime appropriate for debugging
  * @return {string}
  */
  toString() {
    return this.isValid ? this.toISO() : INVALID3;
  }
  /**
  * Returns a string representation of this DateTime appropriate for the REPL.
  * @return {string}
  */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
  * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
  * @return {number}
  */
  valueOf() {
    return this.toMillis();
  }
  /**
  * Returns the epoch milliseconds of this DateTime.
  * @return {number}
  */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
  * Returns the epoch seconds of this DateTime.
  * @return {number}
  */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
  * Returns the epoch seconds (as a whole number) of this DateTime.
  * @return {number}
  */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
  * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
  * @return {string}
  */
  toJSON() {
    return this.toISO();
  }
  /**
  * Returns a BSON serializable equivalent to this DateTime.
  * @return {Date}
  */
  toBSON() {
    return this.toJSDate();
  }
  /**
  * Returns a JavaScript object with this DateTime's year, month, day, and so on.
  * @param opts - options for generating the object
  * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
  * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
  * @return {Object}
  */
  toObject(opts = {}) {
    if (!this.isValid) return {};
    const base = __spreadValues({}, this.c);
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }
  /**
  * Returns a JavaScript Date equivalent to this DateTime.
  * @return {Date}
  */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
  * Return the difference between two DateTimes as a Duration.
  * @param {DateTime} otherDateTime - the DateTime to compare this one to
  * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
  * @param {Object} opts - options that affect the creation of the Duration
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @example
  * var i1 = DateTime.fromISO('1982-05-25T09:45'),
  *     i2 = DateTime.fromISO('1983-10-14T10:30');
  * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
  * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
  * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
  * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
  * @return {Duration}
  */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = __spreadValues({
      locale: this.locale,
      numberingSystem: this.numberingSystem
    }, opts);
    const units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff_default(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
  * Return the difference between this DateTime and right now.
  * See {@link DateTime#diff}
  * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
  * @param {Object} opts - options that affect the creation of the Duration
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @return {Duration}
  */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(_DateTime.now(), unit, opts);
  }
  /**
  * Return an Interval spanning between this DateTime and another DateTime
  * @param {DateTime} otherDateTime - the other end point of the Interval
  * @return {Interval}
  */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
  * Return whether this DateTime is in the same unit of time as another DateTime.
  * Higher-order units must also be identical for this function to return `true`.
  * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
  * @param {DateTime} otherDateTime - the other DateTime
  * @param {string} unit - the unit of time to check sameness on
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
  * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
  * @return {boolean}
  */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, {
      keepLocalTime: true
    });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }
  /**
  * Equality check
  * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
  * To compare just the millisecond values, use `+dt1 === +dt2`.
  * @param {DateTime} other - the other DateTime
  * @return {boolean}
  */
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
  * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
  * platform supports Intl.RelativeTimeFormat. Rounds down by default.
  * @param {Object} options - options that affect the output
  * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
  * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
  * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
  * @param {boolean} [options.round=true] - whether to round the numbers in the output.
  * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
  * @param {string} options.locale - override the locale of this DateTime
  * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
  * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
  * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
  * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
  * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
  * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
  * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
  */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || _DateTime.fromObject({}, {
      zone: this.zone
    }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    let units = [
      "years",
      "months",
      "days",
      "hours",
      "minutes",
      "seconds"
    ];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = void 0;
    }
    return diffRelative(base, this.plus(padding), __spreadProps(__spreadValues({}, options), {
      numeric: "always",
      units,
      unit
    }));
  }
  /**
  * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
  * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
  * @param {Object} options - options that affect the output
  * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
  * @param {string} options.locale - override the locale of this DateTime
  * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
  * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
  * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
  * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
  * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
  * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
  */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;
    return diffRelative(options.base || _DateTime.fromObject({}, {
      zone: this.zone
    }), this, __spreadProps(__spreadValues({}, options), {
      numeric: "auto",
      units: [
        "years",
        "months",
        "days"
      ],
      calendary: true
    }));
  }
  /**
  * Return the min of several date times
  * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
  * @return {DateTime} the min DateTime, or undefined if called with no argument
  */
  static min(...dateTimes) {
    if (!dateTimes.every(_DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }
  /**
  * Return the max of several date times
  * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
  * @return {DateTime} the max DateTime, or undefined if called with no argument
  */
  static max(...dateTimes) {
    if (!dateTimes.every(_DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }
  // MISC
  /**
  * Explain how a string would be parsed by fromFormat()
  * @param {string} text - the string to parse
  * @param {string} fmt - the format the string is expected to be in (see description)
  * @param {Object} options - options taken by fromFormat()
  * @return {Object}
  */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
  * @deprecated use fromFormatExplain instead
  */
  static fromStringExplain(text, fmt, options = {}) {
    return _DateTime.fromFormatExplain(text, fmt, options);
  }
  /**
  * Build a parser for `fmt` using the given locale. This parser can be passed
  * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
  * can be used to optimize cases where many dates need to be parsed in a
  * specific format.
  *
  * @param {String} fmt - the format the string is expected to be in (see
  * description)
  * @param {Object} options - options used to set locale and numberingSystem
  * for parser
  * @returns {TokenParser} - opaque object to be used
  */
  static buildFormatParser(fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return new TokenParser(localeToUse, fmt);
  }
  /**
  * Create a DateTime from an input string and format parser.
  *
  * The format parser must have been created with the same locale as this call.
  *
  * @param {String} text - the string to parse
  * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
  * @param {Object} opts - options taken by fromFormat()
  * @returns {DateTime}
  */
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined(text) || isUndefined(formatParser)) {
      throw new InvalidArgumentError("fromFormatParser requires an input string and a format parser");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError(`fromFormatParser called with a locale of ${localeToUse}, but the format parser was created for ${formatParser.locale}`);
    }
    const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);
    if (invalidReason) {
      return _DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(result, zone, opts, `format ${formatParser.format}`, text, specificOffset);
    }
  }
  // FORMAT PRESETS
  /**
  * {@link DateTime#toLocaleString} format like 10/14/1983
  * @type {Object}
  */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
  * @type {Object}
  */
  static get DATE_MED() {
    return DATE_MED;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
  * @type {Object}
  */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'October 14, 1983'
  * @type {Object}
  */
  static get DATE_FULL() {
    return DATE_FULL;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
  * @type {Object}
  */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  /**
  * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
};
__name(_DateTime, "DateTime");
var DateTime = _DateTime;
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(`Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`);
  }
}
__name(friendlyDateTime, "friendlyDateTime");

// src/common/date.schema.ts
import { coerce as coerce2, z as z9 } from "zod";
var CustomLuxonDateSchema = z9.custom((value) => value && DateTime.fromJSDate(value).toJSDate());
var CommonCustomDateSchema = coerce2.string().date().or(coerce2.string()).or(CustomLuxonDateSchema);
var CustomDateTimeSchema = coerce2.string().datetime().or(coerce2.string()).or(CustomLuxonDateSchema);

// src/common/id.ts
import { coerce as coerce3 } from "zod";
var UnsignedIDSchema = coerce3.number().int().nonnegative();

// src/common/timezone.schema.ts
import { string as string3 } from "zod";
var timezoneSchema = string3().nullable().optional().transform((tz) => {
  if (!tz) {
    return "America/New_York";
  }
  try {
    Intl.DateTimeFormat(void 0, {
      timeZone: tz
    });
    return tz;
  } catch (e) {
    return "America/New_York";
  }
});

// src/common/boolean.schema.ts
import { z as z10 } from "zod";
var StringToBooleanSchema = z10.union([
  z10.boolean(),
  z10.string(),
  z10.number()
]).transform((val) => {
  if (typeof val === "boolean") {
    return val;
  }
  if (typeof val === "number") {
    return val !== 0;
  }
  if (typeof val === "string") {
    const lower = val.toLowerCase().trim();
    return lower === "true" || lower === "1";
  }
  return false;
});

// src/common/permissions.ts
var Permissions = {
  APP_ACTIVE: "sub.active",
  // ── Community / shared ──────────────────────────────────────────────
  CHAT_VIEW: "chat.view",
  CHAT_SEND: "chat.send",
  CHAT_EDIT: "chat.edit",
  CHAT_DELETE: "chat.delete",
  CONTENT_VIEW: "content.view",
  CONTENT_CREATE: "content.create",
  CONTENT_EDIT: "content.edit",
  CONTENT_DELETE: "content.delete",
  FEED_VIEW: "feed.view",
  POST_CREATE: "post.create",
  COMMENT_CREATE: "comment.create",
  SPACE_VIEW: "space.view",
  SPACE_MANAGE: "space.manage",
  // ── FIT ─────────────────────────────────────────────────────────────
  FIT_CONTENT_VIEW: "fit.content.view",
  FIT_CONTENT_MANAGE: "fit.content.manage",
  FIT_SERIES_VIEW: "fit.series.view",
  FIT_SERIES_MANAGE: "fit.series.manage",
  FIT_CHALLENGE_VIEW: "fit.challenge.view",
  FIT_CHALLENGE_MANAGE: "fit.challenge.manage",
  FIT_COMMENT_VIEW: "fit.comment.view",
  FIT_COMMENT_WRITE: "fit.comment.write",
  FIT_COMMENT_EXPORT: "fit.comment.export",
  FIT_COMMENT_MODERATE: "fit.comment.moderate",
  FIT_CLASS_OF_THE_DAY_VIEW: "fit.class-of-the-day.view",
  FIT_CLASS_OF_THE_DAY_MANAGE: "fit.class-of-the-day.manage",
  FIT_SLIDESHOW_MANAGE: "fit.slideshow.manage",
  FIT_EVENT_MANAGE: "fit.event.manage",
  FIT_TRACKING_VIEW: "fit.tracking.view",
  FIT_SIMULATION_ADMIN: "fit.simulation.admin",
  // ── RYC ─────────────────────────────────────────────────────────────
  RYC_ACTIVE: "sub.active",
  RYC_CONTENT_VIEW: "ryc.content.view",
  RYC_CONTENT_MANAGE: "ryc.content.manage",
  RYC_JOURNEY_ACCESS: "ryc.journey.access",
  RYC_COACH_ACCESS: "ryc.coach.access",
  RYC_INSTRUCTION_MANAGE: "ryc.instruction.manage",
  RYC_USER_MANAGEMENT_MANAGE: "ryc.user-management.manage",
  RYC_STATS_VIEW: "ryc.stats.view",
  RYC_TRACKING_VIEW: "ryc.tracking.view",
  RYC_JOURNAL_WRITE: "ryc.journal.write",
  RYC_SIMULATION_ADMIN: "ryc.simulation.admin",
  // ── PD ──────────────────────────────────────────────────────────────
  PD_PUBLIC_LISTING: "pd.public-listing"
};

// src/comment/entity.ts
import { z as z11 } from "zod";
var MentionUserSchema = z11.object({
  id: z11.string(),
  displayName: z11.string(),
  avatar: z11.string().nullable().optional()
});
var MentionUserCacheSchema = MentionUserSchema.extend({
  userId: z11.string(),
  isPrivate: z11.boolean(),
  apps: z11.array(AppNameEnumObj)
});
var BaseCommentSchema = z11.object({
  id: z11.number(),
  contentId: z11.string(),
  userId: z11.coerce.string(),
  content: z11.string(),
  parentId: z11.number().nullable(),
  likesCount: z11.number(),
  isDeleted: z11.boolean(),
  isEdited: z11.boolean().optional(),
  reviewedAt: z11.string().nullable().optional(),
  isReject: z11.boolean(),
  onBehalfOfUserId: z11.string().nullable().optional(),
  createdAt: z11.string(),
  updatedAt: z11.string(),
  userName: z11.string().optional(),
  userAvatar: z11.string().nullable().optional(),
  onBehalfOfUserName: z11.string().nullable().optional(),
  onBehalfOfUserAvatar: z11.string().nullable().optional(),
  isLikedByCurrentUser: z11.boolean().optional(),
  canEdit: z11.boolean().optional(),
  canDelete: z11.boolean().optional()
});
var AdminCommentRowSchema = BaseCommentSchema.extend({
  videoTitle: z11.string().nullable().optional(),
  videoId: z11.string().nullable().optional(),
  instructorName: z11.string().nullable().optional(),
  instructorId: z11.string().nullable().optional()
});
var CommentWithRepliesSchema = z11.lazy(() => BaseCommentSchema.extend({
  replies: z11.array(CommentWithRepliesSchema).optional()
}));
var CommentSchema = CommentWithRepliesSchema;
var visibleContentLength = /* @__PURE__ */ __name((val) => val.replace(/<[^>]*>/g, "").trim().length, "visibleContentLength");
var CreateCommentDtoSchema = z11.object({
  contentId: z11.string().min(1, "content ID is required"),
  content: z11.string().refine((val) => visibleContentLength(val) > 0, "Comment content is required").refine((val) => visibleContentLength(val) <= 1e3, "Comment content is too long"),
  parentId: z11.number().optional()
});
var UpdateCommentDtoSchema = z11.object({
  content: z11.string().refine((val) => visibleContentLength(val) > 0, "Comment content is required").refine((val) => visibleContentLength(val) <= 1e3, "Comment content is too long")
});
var GetCommentsDtoSchema = z11.object({
  contentId: z11.string().min(1, "content ID is required"),
  page: z11.coerce.number().min(1).default(1).optional(),
  limit: z11.coerce.number().min(1).max(100).default(10).optional(),
  enabled: z11.boolean().default(true).optional()
});
var CommentsResponseSchema = z11.object({
  comments: z11.array(CommentWithRepliesSchema),
  total: z11.number(),
  hasMore: z11.boolean()
});
var LikeResponseSchema = z11.object({
  liked: z11.boolean(),
  likesCount: z11.number()
});
var GetContentsByCommentsDateRangeSchema = z11.object({
  app: AppNameEnumObj,
  page: z11.coerce.number().min(1).default(1),
  limit: z11.coerce.number().min(1).max(100).default(15),
  fromDate: z11.string().optional(),
  toDate: z11.string().optional()
});
var csvStringToArray = z11.union([
  z11.string(),
  z11.array(z11.string())
]).transform((val) => {
  if (Array.isArray(val)) {
    return val.filter(Boolean);
  }
  if (!val) {
    return [];
  }
  return val.split(",").map((v) => v.trim()).filter(Boolean);
}).optional();
var GetAdminCommentsDtoSchema = z11.object({
  instructorIds: csvStringToArray,
  isReject: z11.coerce.boolean().optional(),
  notReviewed: z11.coerce.boolean().optional(),
  fromDate: z11.string().optional(),
  toDate: z11.string().optional(),
  page: z11.coerce.number().min(1).default(1).optional(),
  limit: z11.coerce.number().min(1).max(200).default(20).optional()
});
var ExportAdminCommentsDtoSchema = z11.object({
  instructorIds: csvStringToArray,
  isReject: z11.coerce.boolean().optional(),
  notReviewed: z11.coerce.boolean().optional(),
  fromDate: z11.string().optional(),
  toDate: z11.string().optional()
});
var AdminReplyDtoSchema = z11.object({
  contentId: z11.string().min(1, "content ID is required"),
  instructorId: z11.string().min(1, "instructor ID is required"),
  content: z11.string().refine((val) => visibleContentLength(val) > 0, "Reply content is required").refine((val) => visibleContentLength(val) <= 1e3, "Reply content is too long"),
  parentId: z11.number().optional()
});
var ToggleRejectDtoSchema = z11.object({
  isReject: z11.boolean()
});
var validateCreateComment = /* @__PURE__ */ __name((data) => {
  return CreateCommentDtoSchema.parse(data);
}, "validateCreateComment");
var validateUpdateComment = /* @__PURE__ */ __name((data) => {
  return UpdateCommentDtoSchema.parse(data);
}, "validateUpdateComment");
var validateGetComments = /* @__PURE__ */ __name((data) => {
  return GetCommentsDtoSchema.parse(data);
}, "validateGetComments");
var validateGetContentsByCommentsDateRange = /* @__PURE__ */ __name((data) => {
  return GetContentsByCommentsDateRangeSchema.parse(data);
}, "validateGetContentsByCommentsDateRange");
var validateComment = /* @__PURE__ */ __name((data) => {
  return CommentWithRepliesSchema.parse(data);
}, "validateComment");
var validateCommentsResponse = /* @__PURE__ */ __name((data) => {
  return CommentsResponseSchema.parse(data);
}, "validateCommentsResponse");
var validateLikeResponse = /* @__PURE__ */ __name((data) => {
  return LikeResponseSchema.parse(data);
}, "validateLikeResponse");

// src/community-hub/access-group.ts
import { z as z12 } from "zod";
var AccessGroupStatus = /* @__PURE__ */ function(AccessGroupStatus2) {
  AccessGroupStatus2["ACTIVE"] = "active";
  AccessGroupStatus2["INACTIVE"] = "inactive";
  return AccessGroupStatus2;
}({});
var AccessGroupStatusSchema = z12.nativeEnum(AccessGroupStatus);
var MemberStatus = /* @__PURE__ */ function(MemberStatus2) {
  MemberStatus2["ACTIVE"] = "active";
  MemberStatus2["INACTIVE"] = "inactive";
  MemberStatus2["SUSPENDED"] = "suspended";
  return MemberStatus2;
}({});
var MemberStatusSchema = z12.nativeEnum(MemberStatus);
var GrantReason = /* @__PURE__ */ function(GrantReason2) {
  GrantReason2["MANUAL"] = "manual";
  GrantReason2["IMPORTED"] = "imported";
  GrantReason2["AUTO_ASSIGNED"] = "auto_assigned";
  return GrantReason2;
}({});
var GrantReasonSchema = z12.nativeEnum(GrantReason);
var CreateAccessGroupSchema = z12.object({
  name: z12.string().min(1, "Name is required").max(100, "Name must be 100 characters or less")
});
var UpdateAccessGroupSchema = z12.object({
  name: z12.string().min(1, "Name is required").max(100, "Name must be 100 characters or less").optional()
});
var AddMemberSchema = z12.object({
  userId: z12.string().uuid("Invalid user ID"),
  roleId: z12.number().int().positive("Invalid role ID"),
  expiresAt: z12.coerce.date().optional(),
  grantReason: GrantReasonSchema.optional()
});
var UpdateMemberRoleSchema = z12.object({
  roleId: z12.number().int().positive("Invalid role ID")
});
var UpdateMemberStatusSchema = z12.object({
  status: MemberStatusSchema
});
var AccessGroupBaseSchema = z12.object({
  id: z12.number().int(),
  name: z12.string().min(1).max(100),
  isDefault: z12.boolean().optional(),
  status: z12.string().max(20).optional(),
  createdBy: z12.string().uuid().optional().nullable(),
  createdAt: z12.coerce.date(),
  updatedAt: z12.coerce.date().optional()
});
var AccessGroupMemberBaseSchema = z12.object({
  id: z12.number().int(),
  accessGroupId: z12.number().int(),
  userId: z12.string().uuid(),
  roleId: z12.number().int(),
  createdAt: z12.coerce.date()
});

// src/community-hub/role.ts
import { z as z13 } from "zod";
var CreateRoleSchema = z13.object({
  name: z13.string().min(1, "Name is required").max(50, "Name must be 50 characters or less"),
  description: z13.string().max(200, "Description must be 200 characters or less").optional()
});
var UpdateRoleSchema = z13.object({
  name: z13.string().min(1, "Name is required").max(50, "Name must be 50 characters or less").optional(),
  description: z13.string().max(200, "Description must be 200 characters or less").optional()
});
var AddPermissionToRoleSchema = z13.object({
  permissionId: z13.number().int().positive("Invalid permission ID")
});
var RoleBaseSchema = z13.object({
  id: z13.number().int(),
  name: z13.string().min(1).max(50),
  description: z13.string().max(200).nullable(),
  is_system: z13.boolean()
});
var RoleWithPermissionsSchema = RoleBaseSchema.extend({
  permissions: z13.array(z13.object({
    id: z13.number().int(),
    name: z13.string(),
    description: z13.string().nullable()
  }))
});

// src/community-hub/permission.ts
import { z as z14 } from "zod";
var CreatePermissionSchema = z14.object({
  name: z14.string().min(1, "Name is required").max(50, "Name must be 50 characters or less").regex(/^[a-z_]+\.[a-z_]+$/, "Permission name must be in format: resource.action (e.g., post.create)"),
  description: z14.string().max(200, "Description must be 200 characters or less").optional()
});
var UpdatePermissionSchema = z14.object({
  name: z14.string().min(1, "Name is required").max(50, "Name must be 50 characters or less").regex(/^[a-z_]+\.[a-z_]+$/, "Permission name must be in format: resource.action (e.g., post.create)").optional(),
  description: z14.string().max(200, "Description must be 200 characters or less").optional()
});
var PermissionBaseSchema = z14.object({
  id: z14.number().int(),
  name: z14.string().min(1).max(50),
  description: z14.string().max(200).nullable()
});
var PermissionWithUsageSchema = PermissionBaseSchema.extend({
  usedByRoles: z14.number().int().min(0)
});

// src/community-hub/chat.ts
import { z as z15 } from "zod";
var ConversationType = /* @__PURE__ */ function(ConversationType2) {
  ConversationType2["GROUP"] = "group";
  ConversationType2["DIRECT"] = "direct";
  return ConversationType2;
}({});
var ConversationTypeSchema = z15.nativeEnum(ConversationType);
var MessageType = /* @__PURE__ */ function(MessageType2) {
  MessageType2["TEXT"] = "text";
  MessageType2["SYSTEM"] = "system";
  return MessageType2;
}({});
var MessageTypeSchema = z15.nativeEnum(MessageType);
var CreateConversationSchema = z15.object({
  conversationType: ConversationTypeSchema,
  title: z15.string().max(255, "Title must be 255 characters or less").optional(),
  memberUserIds: z15.array(z15.string().uuid("Invalid user ID")).min(1, "At least one member is required")
});
var SendMessageSchema = z15.object({
  body: z15.string().min(1, "Message body is required").max(1e4, "Message is too long")
});
var UpdateMessageSchema = z15.object({
  body: z15.string().min(1, "Message body is required").max(1e4, "Message is too long")
});
var MarkAsReadSchema = z15.object({
  messageId: z15.string().uuid("Invalid message ID")
});
var ConversationBaseSchema = z15.object({
  id: z15.string().uuid(),
  spaceId: z15.string().uuid(),
  conversationType: ConversationTypeSchema,
  title: z15.string().max(255).nullable(),
  lastMessageAt: z15.coerce.date().nullable(),
  createdAt: z15.coerce.date()
});
var MessageBaseSchema = z15.object({
  id: z15.string().uuid(),
  conversationId: z15.string().uuid(),
  senderId: z15.string().uuid(),
  body: z15.string(),
  messageType: MessageTypeSchema,
  editedAt: z15.coerce.date().nullable(),
  deletedAt: z15.coerce.date().nullable(),
  createdAt: z15.coerce.date()
});

// src/community-hub/content.ts
import { z as z16 } from "zod";
var LessonStatus = /* @__PURE__ */ function(LessonStatus2) {
  LessonStatus2["DRAFT"] = "draft";
  LessonStatus2["PUBLISHED"] = "published";
  LessonStatus2["ARCHIVED"] = "archived";
  return LessonStatus2;
}({});
var LessonStatusSchema = z16.nativeEnum(LessonStatus);
var LessonColorScheme = /* @__PURE__ */ function(LessonColorScheme2) {
  LessonColorScheme2["CORAL"] = "coral";
  LessonColorScheme2["GREEN"] = "green";
  LessonColorScheme2["PEACH"] = "peach";
  LessonColorScheme2["BLUE"] = "blue";
  return LessonColorScheme2;
}({});
var LessonColorSchemeSchema = z16.nativeEnum(LessonColorScheme);
var ContentBlockType = /* @__PURE__ */ function(ContentBlockType2) {
  ContentBlockType2["TEXT"] = "text";
  ContentBlockType2["VIMEO"] = "vimeo";
  ContentBlockType2["PDF"] = "pdf";
  ContentBlockType2["QUIZ"] = "quiz";
  ContentBlockType2["FORM"] = "form";
  ContentBlockType2["EMBED"] = "embed";
  ContentBlockType2["REDIRECT"] = "redirect";
  ContentBlockType2["GCS_UPLOAD"] = "gcs_upload";
  return ContentBlockType2;
}({});
var ContentBlockTypeSchema = z16.nativeEnum(ContentBlockType);
var ContentBlockResourceType = /* @__PURE__ */ function(ContentBlockResourceType2) {
  ContentBlockResourceType2["VIDEO"] = "video";
  ContentBlockResourceType2["PDF"] = "pdf";
  ContentBlockResourceType2["TEXT"] = "text";
  ContentBlockResourceType2["CANVA_TEMPLATE"] = "canva_template";
  ContentBlockResourceType2["GOOGLE_DOC"] = "google_doc";
  ContentBlockResourceType2["WORKSHEET"] = "worksheet";
  ContentBlockResourceType2["QUIZ"] = "quiz";
  ContentBlockResourceType2["FORM"] = "form";
  ContentBlockResourceType2["REDIRECT"] = "redirect";
  ContentBlockResourceType2["EMBED"] = "embed";
  return ContentBlockResourceType2;
}({});
var ContentBlockResourceTypeSchema = z16.nativeEnum(ContentBlockResourceType);
var ContentBlockContentCategory = /* @__PURE__ */ function(ContentBlockContentCategory2) {
  ContentBlockContentCategory2["STRENGTH"] = "STRENGTH";
  ContentBlockContentCategory2["CARDIO"] = "CARDIO";
  ContentBlockContentCategory2["FLOW"] = "FLOW";
  ContentBlockContentCategory2["RESTORE"] = "RESTORE";
  return ContentBlockContentCategory2;
}({});
var ContentBlockContentCategorySchema = z16.nativeEnum(ContentBlockContentCategory);
var LessonProgressStatus = /* @__PURE__ */ function(LessonProgressStatus2) {
  LessonProgressStatus2["NOT_STARTED"] = "not_started";
  LessonProgressStatus2["IN_PROGRESS"] = "in_progress";
  LessonProgressStatus2["COMPLETED"] = "completed";
  return LessonProgressStatus2;
}({});
var LessonProgressStatusSchema = z16.nativeEnum(LessonProgressStatus);
var LessonRefSchema = z16.object({
  id: z16.string().uuid(),
  title: z16.string(),
  position: z16.number().int().optional(),
  status: LessonStatusSchema,
  colorScheme: LessonColorSchemeSchema.optional().nullable()
});
var SECTION_TITLE_MAX = 100;
var sectionTitleSchema = z16.string().max(SECTION_TITLE_MAX, `Must be ${SECTION_TITLE_MAX} characters or less`).optional().nullable();
var CreateLessonSchema = z16.object({
  title: z16.string().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  shortDescription: z16.string().max(500, "Short description must be 500 characters or less").optional(),
  longDescription: z16.string().max(1e4, "Long description is too long").optional(),
  position: z16.number().int().min(0).optional(),
  colorScheme: LessonColorSchemeSchema.optional(),
  parentId: z16.string().uuid("Invalid parent lesson ID").optional(),
  categoryId: z16.string().uuid("Invalid category ID").optional().nullable(),
  videoSectionTitle: sectionTitleSchema,
  documentSectionTitle: sectionTitleSchema,
  quizSectionTitle: sectionTitleSchema,
  communityDiscussionTitle: z16.string().max(1e4, "Community discussion title is too long").optional().nullable(),
  additionalResources: z16.string().max(1e4, "Additional resources is too long").optional().nullable(),
  showProgressBar: z16.boolean().optional()
});
var UpdateLessonSchema = z16.object({
  title: z16.string().min(1, "Title is required").max(255, "Title must be 255 characters or less").optional(),
  shortDescription: z16.string().max(500, "Short description must be 500 characters or less").optional(),
  longDescription: z16.string().max(1e4, "Long description is too long").optional(),
  position: z16.number().int().min(0).optional(),
  status: LessonStatusSchema.optional(),
  colorScheme: LessonColorSchemeSchema.optional(),
  categoryId: z16.string().uuid("Invalid category ID").optional().nullable(),
  videoSectionTitle: sectionTitleSchema,
  documentSectionTitle: sectionTitleSchema,
  quizSectionTitle: sectionTitleSchema,
  communityDiscussionTitle: z16.string().max(1e4, "Community discussion title is too long").optional().nullable(),
  additionalResources: z16.string().max(1e4, "Additional resources is too long").optional().nullable(),
  showProgressBar: z16.boolean().optional()
});
var optionalUrl = z16.string().optional();
var optionalUuid = z16.string().uuid().optional().or(z16.literal("")).transform((val) => val === "" ? void 0 : val);
var CreateContentBlockSchema = z16.object({
  blockType: ContentBlockTypeSchema,
  position: z16.number().int().min(0).optional(),
  title: z16.string().max(255, "Title must be 255 characters or less").optional(),
  body: z16.string().max(5e4, "Body is too long").optional(),
  textBannerUrl: optionalUrl,
  // Vimeo fields
  vimeoId: z16.string().max(50, "Vimeo ID is too long").optional(),
  vimeoDurationSeconds: z16.number().int().min(0).optional(),
  vimeoThumbnailUrl: optionalUrl,
  instructorId: z16.string().max(50, "Instructor ID is too long").nullable().optional().or(z16.literal("")).transform((val) => val === "" ? null : val),
  isPublicViewMarkAndWatched: z16.boolean().optional(),
  contentCategory: ContentBlockContentCategorySchema.nullable().optional(),
  // PDF fields
  pdfUrl: optionalUrl,
  pdfBannerUrl: optionalUrl,
  pdfFilename: z16.string().max(255, "Filename is too long").optional(),
  pdfFileSize: z16.number().int().min(0).optional(),
  pdfPageCount: z16.number().int().min(0).optional(),
  // Quiz
  quizId: optionalUuid,
  // Form
  formId: optionalUuid,
  // Redirect
  redirectUrl: optionalUrl,
  // GCS Upload — config per block for external NestJS GCS uploader
  gcsBaseUrl: optionalUrl,
  gcsApiSecret: z16.string().max(255).optional().nullable(),
  gcsCallbackUrl: optionalUrl,
  gcsDriveId: z16.string().max(255).optional().nullable(),
  gcsAutoTransferToDrive: z16.boolean().optional(),
  gcsSheetUrl: optionalUrl,
  gcsSubfolder: z16.string().max(255).optional().nullable(),
  gcsOrganizeByUser: z16.boolean().optional(),
  gcsSuccessMessage: z16.string().max(500).optional().nullable(),
  resourceType: ContentBlockResourceTypeSchema.nullable().optional(),
  metadata: z16.record(z16.unknown()).optional()
});
var UpdateContentBlockSchema = z16.object({
  blockType: ContentBlockTypeSchema.optional(),
  position: z16.number().int().min(0).optional(),
  title: z16.string().max(255, "Title must be 255 characters or less").optional(),
  body: z16.string().max(5e4, "Body is too long").optional(),
  textBannerUrl: optionalUrl,
  // Vimeo fields
  vimeoId: z16.string().max(50, "Vimeo ID is too long").optional(),
  vimeoDurationSeconds: z16.number().int().min(0).optional(),
  vimeoThumbnailUrl: optionalUrl,
  instructorId: z16.string().max(50, "Instructor ID is too long").nullable().optional().or(z16.literal("")).transform((val) => val === "" ? null : val),
  isPublicViewMarkAndWatched: z16.boolean().optional(),
  contentCategory: ContentBlockContentCategorySchema.nullable().optional(),
  // PDF fields
  pdfUrl: optionalUrl,
  pdfBannerUrl: optionalUrl,
  pdfFilename: z16.string().max(255, "Filename is too long").optional(),
  pdfFileSize: z16.number().int().min(0).optional(),
  pdfPageCount: z16.number().int().min(0).optional(),
  // Quiz
  quizId: optionalUuid,
  // Form
  formId: optionalUuid,
  // Redirect
  redirectUrl: optionalUrl,
  // GCS Upload
  gcsBaseUrl: optionalUrl,
  gcsApiSecret: z16.string().max(255).optional().nullable(),
  gcsCallbackUrl: optionalUrl,
  gcsDriveId: z16.string().max(255).optional().nullable(),
  gcsAutoTransferToDrive: z16.boolean().optional(),
  gcsSheetUrl: optionalUrl,
  gcsSubfolder: z16.string().max(255).optional().nullable(),
  gcsOrganizeByUser: z16.boolean().optional(),
  gcsSuccessMessage: z16.string().max(500).optional().nullable(),
  resourceType: ContentBlockResourceTypeSchema.nullable().optional(),
  metadata: z16.record(z16.unknown()).optional()
});
var UpdateProgressSchema = z16.object({
  lastBlockId: z16.string().uuid("Invalid block ID").optional(),
  status: LessonProgressStatusSchema.optional(),
  logAction: z16.string().optional(),
  percentWatched: z16.number().min(0).max(100).optional()
});
var LessonBaseSchema = z16.object({
  id: z16.string().uuid(),
  spaceId: z16.string().uuid(),
  parentId: z16.string().uuid().optional().nullable(),
  categoryId: z16.string().uuid().optional().nullable(),
  title: z16.string().max(255),
  shortDescription: z16.string().nullable(),
  longDescription: z16.string().nullable(),
  position: z16.number().int(),
  status: LessonStatusSchema,
  colorScheme: LessonColorSchemeSchema,
  videoSectionTitle: z16.string().nullable().optional(),
  documentSectionTitle: z16.string().nullable().optional(),
  quizSectionTitle: z16.string().nullable().optional(),
  communityDiscussionTitle: z16.string().nullable().optional(),
  additionalResources: z16.string().nullable().optional(),
  showProgressBar: z16.boolean(),
  createdBy: z16.string().uuid(),
  createdAt: z16.coerce.date(),
  updatedAt: z16.coerce.date(),
  // Computed stats for lesson content
  videoCount: z16.number().int().optional(),
  pdfCount: z16.number().int().optional(),
  hasDownloadableAssets: z16.boolean().optional(),
  // Hierarchy relations (populated when loaded with relations)
  parent: LessonRefSchema.optional().nullable(),
  children: z16.array(LessonRefSchema).optional(),
  subLessonCount: z16.number().int().optional(),
  // Category relation (for sub-lessons)
  category: z16.lazy(() => LessonCategoryBaseSchema).optional().nullable(),
  // Categories relation (for parent lessons - their defined categories)
  categories: z16.lazy(() => z16.array(LessonCategoryBaseSchema)).optional()
});
var ModuleProgressSchema = z16.object({
  totalLessons: z16.number().int(),
  completedLessons: z16.number().int(),
  progressPercent: z16.number().int().min(0).max(100)
});
var ContentBlockBaseSchema = z16.object({
  id: z16.string().uuid(),
  lessonId: z16.string().uuid(),
  blockType: ContentBlockTypeSchema,
  position: z16.number().int(),
  title: z16.string().max(255).nullable(),
  body: z16.string().nullable(),
  bodyHtml: z16.string().nullable(),
  textBannerUrl: z16.string().max(500).nullable(),
  // Vimeo fields
  vimeoId: z16.string().max(50).nullable(),
  vimeoDurationSeconds: z16.number().int().nullable(),
  vimeoThumbnailUrl: z16.string().max(500).nullable(),
  instructorId: z16.string().max(50).nullable(),
  isPublicViewMarkAndWatched: z16.boolean().nullable(),
  contentCategory: ContentBlockContentCategorySchema.nullable(),
  // PDF fields
  pdfUrl: z16.string().max(500).nullable(),
  pdfBannerUrl: z16.string().max(500).nullable(),
  pdfFilename: z16.string().max(255).nullable(),
  pdfFileSize: z16.number().int().nullable(),
  pdfPageCount: z16.number().int().nullable(),
  // Quiz
  quizId: z16.string().uuid().nullable(),
  // Form
  formId: z16.string().uuid().nullable(),
  // Status of the linked form (server-enriched for FORM blocks). Members
  // hide non-published forms; admins surface them to keep editing them.
  formStatus: z16.enum([
    "draft",
    "published",
    "archived"
  ]).optional().nullable(),
  // Redirect
  redirectUrl: z16.string().max(500).nullable(),
  // GCS Upload — admin-configured per-block fields. NOTE: `gcsApiSecret` is
  // returned by the API today (no row-level filtering), so we declare it here
  // for type parity. Strip it server-side before sending to members if/when
  // the field becomes sensitive.
  gcsBaseUrl: z16.string().max(500).nullable().optional(),
  gcsApiSecret: z16.string().max(255).nullable().optional(),
  gcsCallbackUrl: z16.string().max(500).nullable().optional(),
  gcsDriveId: z16.string().max(255).nullable().optional(),
  gcsAutoTransferToDrive: z16.boolean().nullable().optional(),
  gcsSheetUrl: z16.string().max(500).nullable().optional(),
  gcsSubfolder: z16.string().max(255).nullable().optional(),
  gcsOrganizeByUser: z16.boolean().nullable().optional(),
  gcsSuccessMessage: z16.string().max(500).nullable().optional(),
  resourceType: ContentBlockResourceTypeSchema.nullable(),
  metadata: z16.record(z16.unknown()),
  createdAt: z16.coerce.date(),
  updatedAt: z16.coerce.date()
});
var LessonProgressBaseSchema = z16.object({
  id: z16.string().uuid(),
  lessonId: z16.string().uuid(),
  userId: z16.string().uuid(),
  status: LessonProgressStatusSchema,
  startedAt: z16.coerce.date().nullable(),
  completedAt: z16.coerce.date().nullable(),
  lastBlockId: z16.string().uuid().nullable(),
  createdAt: z16.coerce.date(),
  updatedAt: z16.coerce.date(),
  // Computed fields for progress percentage
  progressPercent: z16.number().int().min(0).max(100).optional(),
  totalBlocks: z16.number().int().optional(),
  completedBlocks: z16.number().int().optional()
});
var LessonCategoryBaseSchema = z16.object({
  id: z16.string().uuid(),
  parentLessonId: z16.string().uuid(),
  name: z16.string().min(1).max(100),
  position: z16.number().int(),
  createdAt: z16.coerce.date(),
  updatedAt: z16.coerce.date()
});
var CreateLessonCategorySchema = z16.object({
  name: z16.string().min(1, "Name is required").max(100, "Name must be 100 characters or less"),
  position: z16.number().int().min(0).optional()
});
var UpdateLessonCategorySchema = z16.object({
  name: z16.string().min(1).max(100).optional(),
  position: z16.number().int().min(0).optional()
});
var GcsAllowedMediaType = /* @__PURE__ */ function(GcsAllowedMediaType2) {
  GcsAllowedMediaType2["IMAGE"] = "image";
  GcsAllowedMediaType2["VIDEO"] = "video";
  GcsAllowedMediaType2["AUDIO"] = "audio";
  GcsAllowedMediaType2["PDF"] = "pdf";
  GcsAllowedMediaType2["DOCUMENT"] = "document";
  return GcsAllowedMediaType2;
}({});
var GcsAllowedMediaTypeSchema = z16.nativeEnum(GcsAllowedMediaType);
var GCS_MEDIA_TYPE_PRESETS = {
  image: {
    label: "Images",
    extensions: [
      "jpg",
      "jpeg",
      "png",
      "gif",
      "webp",
      "svg",
      "avif"
    ],
    mimeTypes: [
      "image/*"
    ]
  },
  video: {
    label: "Videos",
    extensions: [
      "mp4",
      "mov",
      "webm",
      "avi",
      "m4v",
      "ogg"
    ],
    mimeTypes: [
      "video/*"
    ]
  },
  audio: {
    label: "Audio",
    extensions: [
      "mp3",
      "wav",
      "m4a",
      "aac",
      "ogg"
    ],
    mimeTypes: [
      "audio/*"
    ]
  },
  pdf: {
    label: "PDFs",
    extensions: [
      "pdf"
    ],
    mimeTypes: [
      "application/pdf"
    ]
  },
  document: {
    label: "Documents",
    extensions: [
      "doc",
      "docx",
      "xls",
      "xlsx",
      "ppt",
      "pptx",
      "txt",
      "csv"
    ],
    mimeTypes: [
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "text/plain",
      "text/csv"
    ]
  }
};
var GCS_ALLOWED_MEDIA_TYPE_KEYS = new Set(Object.values(GcsAllowedMediaType));
var parseAllowedMediaTypes = /* @__PURE__ */ __name((metadata) => {
  if (!metadata || typeof metadata !== "object") {
    return [];
  }
  const raw = metadata["allowedMediaTypes"];
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw.filter((v) => typeof v === "string" && GCS_ALLOWED_MEDIA_TYPE_KEYS.has(v));
}, "parseAllowedMediaTypes");
var parseGcsFilenamePrefix = /* @__PURE__ */ __name((metadata) => {
  if (!metadata || typeof metadata !== "object") {
    return "";
  }
  const raw = metadata["filenamePrefix"];
  return typeof raw === "string" ? raw.trim() : "";
}, "parseGcsFilenamePrefix");
var isGcsFileAllowed = /* @__PURE__ */ __name((allowed, mimeType, extension) => {
  if (allowed.length === 0) {
    return true;
  }
  const ext = extension.replace(/^\./, "").toLowerCase();
  const mime = (mimeType || "").toLowerCase();
  return allowed.some((key) => {
    const preset = GCS_MEDIA_TYPE_PRESETS[key];
    if (preset.extensions.includes(ext)) {
      return true;
    }
    return preset.mimeTypes.some((m) => m.endsWith("/*") ? mime.startsWith(m.slice(0, -1)) : mime === m);
  });
}, "isGcsFileAllowed");
var GcsUploadStatus = /* @__PURE__ */ function(GcsUploadStatus2) {
  GcsUploadStatus2["PROCESSING"] = "processing";
  GcsUploadStatus2["UPLOADED_IN_BUCKET"] = "uploaded_in_bucket";
  GcsUploadStatus2["UPLOADED_IN_DRIVE"] = "uploaded_in_drive";
  GcsUploadStatus2["FAILED"] = "failed";
  return GcsUploadStatus2;
}({});
var GcsUploadStatusSchema = z16.nativeEnum(GcsUploadStatus);
var GcsUploadRowSchema = z16.object({
  id: z16.string().uuid(),
  blockId: z16.string().uuid(),
  lessonId: z16.string().uuid(),
  userId: z16.string(),
  fileKey: z16.string(),
  fileName: z16.string(),
  fileSize: z16.string().nullable(),
  status: GcsUploadStatusSchema,
  driveLink: z16.string().nullable(),
  createdAt: z16.coerce.date(),
  updatedAt: z16.coerce.date()
});
var StartGcsUploadSchema = z16.object({
  fileExtension: z16.string().min(1).max(20),
  contentType: z16.string().min(1).max(100),
  fileSize: z16.number().int().min(1)
});
var StartGcsUploadResultSchema = z16.object({
  uploadId: z16.string().uuid(),
  uploadUrl: z16.string(),
  fileKey: z16.string(),
  fileName: z16.string()
});
var GcsUploadReportRowSchema = z16.object({
  userId: z16.string(),
  email: z16.string(),
  file_name: z16.string(),
  user_firstname: z16.string(),
  user_lastname: z16.string(),
  display_name: z16.string(),
  event_id: z16.string(),
  google_drive_link: z16.string(),
  location: z16.string(),
  occupation: z16.string(),
  file_size: z16.string(),
  uploaded_at: z16.string()
});

// src/community-hub/feed.ts
import { z as z17 } from "zod";
var PostType = /* @__PURE__ */ function(PostType2) {
  PostType2["DISCUSSION"] = "discussion";
  PostType2["ANNOUNCEMENT"] = "announcement";
  PostType2["QUESTION"] = "question";
  return PostType2;
}({});
var PostTypeSchema = z17.nativeEnum(PostType);
var PostStatus = /* @__PURE__ */ function(PostStatus2) {
  PostStatus2["PUBLISHED"] = "published";
  PostStatus2["DRAFT"] = "draft";
  PostStatus2["ARCHIVED"] = "archived";
  PostStatus2["REMOVED"] = "removed";
  return PostStatus2;
}({});
var PostStatusSchema = z17.nativeEnum(PostStatus);
var CommentStatus = /* @__PURE__ */ function(CommentStatus2) {
  CommentStatus2["PUBLISHED"] = "published";
  CommentStatus2["REMOVED"] = "removed";
  return CommentStatus2;
}({});
var CommentStatusSchema = z17.nativeEnum(CommentStatus);
var ReactionTargetType = /* @__PURE__ */ function(ReactionTargetType2) {
  ReactionTargetType2["POST"] = "post";
  ReactionTargetType2["COMMENT"] = "comment";
  return ReactionTargetType2;
}({});
var ReactionTargetTypeSchema = z17.nativeEnum(ReactionTargetType);
var REACTION_EMOJIS = {
  like: "\u{1F44D}",
  love: "\u2764\uFE0F",
  haha: "\u{1F602}",
  wow: "\u{1F62E}",
  sad: "\u{1F622}",
  angry: "\u{1F620}"
};
var AttachmentSchema = z17.object({
  url: z17.string().url(),
  type: z17.enum([
    "image"
  ]),
  width: z17.number().optional(),
  height: z17.number().optional()
});
var CommentAttachmentSchema = AttachmentSchema;
var PostAttachmentSchema = AttachmentSchema;
var CreatePostSchema = z17.object({
  title: z17.string().max(300, "Title must be 300 characters or less").optional(),
  body: z17.string().max(5e4, "Post body is too long"),
  postType: PostTypeSchema.optional(),
  attachments: z17.array(PostAttachmentSchema).max(10).optional()
}).refine((data) => data.body.trim().length > 0 || data.attachments && data.attachments.length > 0, {
  message: "Post must have text or at least one image",
  path: [
    "body"
  ]
});
var UpdatePostSchema = z17.object({
  title: z17.string().max(300, "Title must be 300 characters or less").optional(),
  body: z17.string().min(1, "Post body is required").max(5e4, "Post body is too long").optional(),
  status: PostStatusSchema.optional(),
  isPinned: z17.boolean().optional()
});
var CreateCommentSchema = z17.object({
  body: z17.string().max(1e4, "Comment body is too long"),
  parentId: z17.string().uuid("Invalid parent comment ID").optional(),
  attachments: z17.array(CommentAttachmentSchema).max(4).optional()
}).refine((data) => data.body.trim().length > 0 || data.attachments && data.attachments.length > 0, {
  message: "Comment must have text or at least one image",
  path: [
    "body"
  ]
});
var UpdateCommentSchema = z17.object({
  body: z17.string().min(1, "Comment body is required").max(1e4, "Comment body is too long").optional(),
  status: CommentStatusSchema.optional()
});
var ToggleReactionSchema = z17.object({
  targetType: ReactionTargetTypeSchema,
  targetId: z17.string().uuid("Invalid target ID"),
  emoji: z17.string().min(1).max(50, "Emoji must be 50 characters or less")
});
var PostBaseSchema = z17.object({
  id: z17.string().uuid(),
  spaceId: z17.string().uuid(),
  authorId: z17.string().uuid(),
  title: z17.string().max(300).nullable(),
  body: z17.string(),
  bodyHtml: z17.string().nullable(),
  postType: PostTypeSchema,
  status: PostStatusSchema,
  isPinned: z17.boolean(),
  likeCount: z17.number().int(),
  commentCount: z17.number().int(),
  attachments: z17.array(PostAttachmentSchema).nullable(),
  createdAt: z17.coerce.date(),
  updatedAt: z17.coerce.date()
});
var CommentBaseSchema = z17.object({
  id: z17.string().uuid(),
  postId: z17.string().uuid(),
  authorId: z17.string().uuid(),
  parentId: z17.string().uuid().nullable(),
  body: z17.string(),
  bodyHtml: z17.string().nullable(),
  status: CommentStatusSchema,
  likeCount: z17.number().int(),
  attachments: z17.array(CommentAttachmentSchema).nullable(),
  createdAt: z17.coerce.date(),
  updatedAt: z17.coerce.date()
});
var ReactionBaseSchema = z17.object({
  id: z17.string().uuid(),
  userId: z17.string().uuid(),
  targetType: ReactionTargetTypeSchema,
  targetId: z17.string().uuid(),
  emoji: z17.string().max(50),
  createdAt: z17.coerce.date()
});
var AuthorInfoSchema = z17.object({
  id: z17.string(),
  name: z17.string(),
  avatar: z17.string().nullable()
});
var PostWithAuthorSchema = PostBaseSchema.extend({
  author: AuthorInfoSchema,
  userReaction: z17.string().nullable().optional()
});
var CommentWithAuthorBaseSchema = CommentBaseSchema.extend({
  author: AuthorInfoSchema,
  replyCount: z17.number().int().optional(),
  userReaction: z17.string().nullable().optional()
});
var CommentWithAuthorSchema = CommentWithAuthorBaseSchema.extend({
  replies: z17.array(CommentWithAuthorBaseSchema).optional()
});

// src/community-hub/form.ts
import { z as z20 } from "zod";

// src/community-hub/quiz.ts
import { z as z18 } from "zod";
var QuizStatus = /* @__PURE__ */ function(QuizStatus2) {
  QuizStatus2["DRAFT"] = "draft";
  QuizStatus2["PUBLISHED"] = "published";
  QuizStatus2["ARCHIVED"] = "archived";
  return QuizStatus2;
}({});
var QuizStatusSchema = z18.nativeEnum(QuizStatus);
var QuestionType = /* @__PURE__ */ function(QuestionType2) {
  QuestionType2["MULTIPLE_CHOICE"] = "multiple_choice";
  QuestionType2["MULTIPLE_SELECT"] = "multiple_select";
  QuestionType2["TRUE_FALSE"] = "true_false";
  QuestionType2["SHORT_ANSWER"] = "short_answer";
  QuestionType2["ORDERING"] = "ordering";
  QuestionType2["FILE_UPLOAD"] = "file_upload";
  QuestionType2["ACCEPT"] = "accept";
  QuestionType2["ACCEPT_WITH_SIGNATURE"] = "accept_with_signature";
  QuestionType2["DROPDOWN"] = "dropdown";
  return QuestionType2;
}({});
var QuestionTypeSchema = z18.nativeEnum(QuestionType);
var AttemptStatus = /* @__PURE__ */ function(AttemptStatus2) {
  AttemptStatus2["IN_PROGRESS"] = "in_progress";
  AttemptStatus2["SUBMITTED"] = "submitted";
  AttemptStatus2["GRADED"] = "graded";
  AttemptStatus2["ABANDONED"] = "abandoned";
  return AttemptStatus2;
}({});
var AttemptStatusSchema = z18.nativeEnum(AttemptStatus);
var CreateQuizSchema = z18.object({
  title: z18.string().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  description: z18.string().max(5e3, "Description is too long").optional(),
  passingScorePercent: z18.number().int().min(0).max(100).optional(),
  maxAttempts: z18.number().int().min(1).optional(),
  timeLimitSeconds: z18.number().int().min(1).max(86400, "Time limit cannot exceed 24 hours").optional(),
  shuffleQuestions: z18.boolean().optional(),
  showCorrectAnswers: z18.boolean().optional()
});
var UpdateQuizSchema = z18.object({
  title: z18.string().min(1, "Title is required").max(255, "Title must be 255 characters or less").optional(),
  description: z18.string().max(5e3, "Description is too long").optional(),
  passingScorePercent: z18.number().int().min(0).max(100).optional(),
  maxAttempts: z18.number().int().min(1).optional(),
  timeLimitSeconds: z18.number().int().min(1).max(86400, "Time limit cannot exceed 24 hours").optional(),
  shuffleQuestions: z18.boolean().optional(),
  showCorrectAnswers: z18.boolean().optional(),
  status: QuizStatusSchema.optional()
});
var CreateQuestionSchema = z18.object({
  questionType: QuestionTypeSchema,
  questionText: z18.string().min(1, "Question text is required").max(5e3),
  explanation: z18.string().max(5e3).optional(),
  points: z18.number().int().min(1).optional(),
  position: z18.number().int().min(0).optional(),
  metadata: z18.record(z18.unknown()).optional()
});
var UpdateQuestionSchema = z18.object({
  questionText: z18.string().min(1, "Question text is required").max(5e3).optional(),
  explanation: z18.string().max(5e3).optional(),
  points: z18.number().int().min(1).optional(),
  position: z18.number().int().min(0).optional(),
  metadata: z18.record(z18.unknown()).optional()
});
var CreateOptionSchema = z18.object({
  optionText: z18.string().min(1, "Option text is required").max(1e3),
  isCorrect: z18.boolean().optional(),
  position: z18.number().int().min(0).optional()
});
var UpdateOptionSchema = z18.object({
  optionText: z18.string().min(1, "Option text is required").max(1e3).optional(),
  isCorrect: z18.boolean().optional(),
  position: z18.number().int().min(0).optional()
});
var SubmitAnswerSchema = z18.object({
  questionId: z18.string().uuid("Invalid question ID"),
  selectedOptionIds: z18.array(z18.string().uuid()).optional(),
  orderingSequence: z18.array(z18.string().uuid()).optional(),
  textAnswer: z18.string().max(1e4).optional()
});
var SubmitQuizAttemptSchema = z18.object({
  answers: z18.array(SubmitAnswerSchema).min(1, "At least one answer is required")
});
var QuizBaseSchema = z18.object({
  id: z18.string().uuid(),
  spaceId: z18.string().uuid(),
  title: z18.string().max(255),
  description: z18.string().nullable(),
  passingScorePercent: z18.number().int(),
  maxAttempts: z18.number().int().nullable(),
  timeLimitSeconds: z18.number().int().nullable(),
  shuffleQuestions: z18.boolean(),
  showCorrectAnswers: z18.boolean(),
  status: QuizStatusSchema,
  createdBy: z18.string().uuid(),
  createdAt: z18.coerce.date(),
  updatedAt: z18.coerce.date()
});

// src/community-hub/form-profile-mapping.ts
import { z as z19 } from "zod";
var EProfileFieldKind = /* @__PURE__ */ function(EProfileFieldKind2) {
  EProfileFieldKind2["TEXT"] = "text";
  EProfileFieldKind2["URL"] = "url";
  EProfileFieldKind2["BOOLEAN"] = "boolean";
  return EProfileFieldKind2;
}({});
var MAPPABLE_PROFILE_FIELDS = [
  {
    key: "firstName",
    label: "First name",
    kind: "text"
  },
  {
    key: "lastName",
    label: "Last name",
    kind: "text"
  },
  {
    key: "displayName",
    label: "Display name",
    kind: "text"
  },
  {
    key: "occupation",
    label: "Profession",
    kind: "text"
  },
  {
    key: "bio",
    label: "Bio",
    kind: "text"
  },
  {
    key: "primaryLanguage",
    label: "Primary language",
    kind: "text"
  },
  {
    key: "phoneNumber",
    label: "Phone number",
    kind: "text"
  },
  {
    key: "zoomEmail",
    label: "Zoom email",
    kind: "text"
  },
  {
    key: "timezone",
    label: "Timezone",
    kind: "text"
  },
  {
    key: "isPrivate",
    label: "Private profile",
    kind: "boolean"
  },
  {
    key: "address.street",
    label: "Address \u2014 Street",
    kind: "text"
  },
  {
    key: "address.city",
    label: "Address \u2014 City",
    kind: "text"
  },
  {
    key: "address.state",
    label: "Address \u2014 State",
    kind: "text"
  },
  {
    key: "address.zip",
    label: "Address \u2014 Zip",
    kind: "text"
  },
  {
    key: "address.country",
    label: "Address \u2014 Country",
    kind: "text"
  },
  {
    key: "socials.facebook",
    label: "Social \u2014 Facebook",
    kind: "url"
  },
  {
    key: "socials.instagram",
    label: "Social \u2014 Instagram",
    kind: "url"
  },
  {
    key: "socials.youtube",
    label: "Social \u2014 YouTube",
    kind: "url"
  },
  {
    key: "socials.twitter",
    label: "Social \u2014 Twitter",
    kind: "url"
  },
  {
    key: "socials.linkedin",
    label: "Social \u2014 LinkedIn",
    kind: "url"
  },
  {
    key: "socials.tiktok",
    label: "Social \u2014 TikTok",
    kind: "url"
  }
];
var PROFILE_FIELD_KEYS = MAPPABLE_PROFILE_FIELDS.map((field) => field.key);
var ProfileFieldKeySchema = z19.enum(PROFILE_FIELD_KEYS);
var getProfileFieldByKey = /* @__PURE__ */ __name((key) => MAPPABLE_PROFILE_FIELDS.find((field) => field.key === key), "getProfileFieldByKey");
var getQuestionAnswerShape = /* @__PURE__ */ __name((questionType) => {
  switch (questionType) {
    case QuestionType.SHORT_ANSWER:
    case QuestionType.MULTIPLE_CHOICE:
    case QuestionType.DROPDOWN: {
      return {
        cardinality: "single",
        valueType: "string"
      };
    }
    case QuestionType.TRUE_FALSE: {
      return {
        cardinality: "single",
        valueType: "boolean"
      };
    }
    case QuestionType.MULTIPLE_SELECT:
    case QuestionType.ORDERING: {
      return {
        cardinality: "multiple",
        valueType: "string"
      };
    }
    case QuestionType.ACCEPT:
    case QuestionType.ACCEPT_WITH_SIGNATURE: {
      return {
        cardinality: "single",
        valueType: "none"
      };
    }
    case QuestionType.FILE_UPLOAD:
    default: {
      return {
        cardinality: "multiple",
        valueType: "file"
      };
    }
  }
}, "getQuestionAnswerShape");
var isQuestionTypeMappableToFieldKind = /* @__PURE__ */ __name((questionType, kind) => {
  const shape = getQuestionAnswerShape(questionType);
  if (shape.cardinality !== "single" || shape.valueType === "file" || shape.valueType === "none") {
    return false;
  }
  if (shape.valueType === "boolean") {
    return kind === "boolean";
  }
  return kind === "text" || kind === "url";
}, "isQuestionTypeMappableToFieldKind");
var isQuestionTypeMappableToProfileFieldKey = /* @__PURE__ */ __name((questionType, profileFieldKey) => {
  const field = getProfileFieldByKey(profileFieldKey);
  return !!field && isQuestionTypeMappableToFieldKind(questionType, field.kind);
}, "isQuestionTypeMappableToProfileFieldKey");
var getMappableProfileFieldsForQuestionType = /* @__PURE__ */ __name((questionType) => MAPPABLE_PROFILE_FIELDS.filter((field) => isQuestionTypeMappableToFieldKind(questionType, field.kind)), "getMappableProfileFieldsForQuestionType");

// src/community-hub/form.ts
var FormStatus = /* @__PURE__ */ function(FormStatus2) {
  FormStatus2["DRAFT"] = "draft";
  FormStatus2["PUBLISHED"] = "published";
  FormStatus2["ARCHIVED"] = "archived";
  return FormStatus2;
}({});
var FormStatusSchema = z20.nativeEnum(FormStatus);
var SubmissionStatus = /* @__PURE__ */ function(SubmissionStatus2) {
  SubmissionStatus2["IN_PROGRESS"] = "in_progress";
  SubmissionStatus2["SUBMITTED"] = "submitted";
  return SubmissionStatus2;
}({});
var SubmissionStatusSchema = z20.nativeEnum(SubmissionStatus);
var EFormType = /* @__PURE__ */ function(EFormType2) {
  EFormType2["GENERAL"] = "general";
  EFormType2["REGISTRATION"] = "registration";
  EFormType2["FEEDBACK"] = "feedback";
  return EFormType2;
}({});
var FormTypeSchema = z20.nativeEnum(EFormType);
var CreateFormSchema = z20.object({
  title: z20.string().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  description: z20.string().optional(),
  bannerUrl: z20.string().max(500, "Banner URL is too long").optional().nullable(),
  shuffleQuestions: z20.boolean().optional(),
  allowMultipleSubmissions: z20.boolean().optional(),
  formType: FormTypeSchema.optional().default("general")
});
var UpdateFormSchema = z20.object({
  title: z20.string().min(1, "Title is required").max(255, "Title must be 255 characters or less").optional(),
  description: z20.string().optional(),
  bannerUrl: z20.string().max(500, "Banner URL is too long").optional().nullable(),
  shuffleQuestions: z20.boolean().optional(),
  allowMultipleSubmissions: z20.boolean().optional(),
  status: FormStatusSchema.optional(),
  formType: FormTypeSchema.optional()
});
var CreateFormQuestionGroupSchema = z20.object({
  title: z20.string().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  description: z20.string().optional()
});
var UpdateFormQuestionGroupSchema = z20.object({
  title: z20.string().min(1, "Title is required").max(255, "Title must be 255 characters or less").optional(),
  description: z20.string().optional()
});
var CreateFormQuestionSchema = z20.object({
  questionType: QuestionTypeSchema,
  questionText: z20.string().min(1, "Question text is required").max(5e3),
  questionBody: z20.string().optional(),
  explanation: z20.string().max(5e3).optional(),
  position: z20.number().int().min(0).optional(),
  metadata: z20.record(z20.unknown()).optional(),
  isRequired: z20.boolean().optional().default(false),
  groupId: z20.string().uuid().nullable().optional(),
  profileFieldKey: ProfileFieldKeySchema.nullable().optional()
});
var UpdateFormQuestionSchema = z20.object({
  questionText: z20.string().min(1, "Question text is required").max(5e3).optional(),
  questionBody: z20.string().optional(),
  explanation: z20.string().max(5e3).optional(),
  position: z20.number().int().min(0).optional(),
  metadata: z20.record(z20.unknown()).optional(),
  isRequired: z20.boolean().optional(),
  groupId: z20.string().uuid().nullable().optional(),
  profileFieldKey: ProfileFieldKeySchema.nullable().optional()
});
var EQuestionInputType = /* @__PURE__ */ function(EQuestionInputType2) {
  EQuestionInputType2["TEXT"] = "text";
  EQuestionInputType2["EMAIL"] = "email";
  EQuestionInputType2["URL"] = "url";
  EQuestionInputType2["NUMBER"] = "number";
  EQuestionInputType2["PHONE"] = "phone";
  return EQuestionInputType2;
}({});
var QuestionInputTypeSchema = z20.nativeEnum(EQuestionInputType);
var getQuestionInputType = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["inputType"];
    if (typeof raw === "string" && Object.values(EQuestionInputType).includes(raw)) {
      return raw;
    }
  }
  return "text";
}, "getQuestionInputType");
var isShortAnswerValueValid = /* @__PURE__ */ __name((inputType, value) => {
  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return true;
  }
  switch (inputType) {
    case "email": {
      return z20.string().email().safeParse(trimmed).success;
    }
    case "url": {
      return z20.string().url().safeParse(trimmed).success;
    }
    case "number": {
      return !Number.isNaN(Number(trimmed));
    }
    case "phone": {
      return /^[+]?[\d\s()-]{6,20}$/.test(trimmed);
    }
    case "text":
    default: {
      return true;
    }
  }
}, "isShortAnswerValueValid");
var getAcceptButtonLabel = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["buttonLabel"];
    if (typeof raw === "string" && raw.trim().length > 0) {
      return raw;
    }
  }
  return "Accept";
}, "getAcceptButtonLabel");
var getAcceptCheckboxLabel = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["checkboxLabel"];
    if (typeof raw === "string" && raw.trim().length > 0) {
      return raw;
    }
  }
  return "I acknowledge the above";
}, "getAcceptCheckboxLabel");
var getDropdownOptions = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["options"];
    if (Array.isArray(raw)) {
      return raw.filter((o) => typeof o === "string" && o.trim().length > 0);
    }
  }
  return [];
}, "getDropdownOptions");
var CreateFormOptionSchema = z20.object({
  optionText: z20.string().min(1, "Option text is required").max(1e3),
  position: z20.number().int().min(0).optional()
});
var UpdateFormOptionSchema = z20.object({
  optionText: z20.string().min(1, "Option text is required").max(1e3).optional(),
  position: z20.number().int().min(0).optional()
});
var SubmitFormAnswerSchema = z20.object({
  questionId: z20.string().uuid("Invalid question ID"),
  selectedOptionIds: z20.array(z20.string().uuid()).optional(),
  orderingSequence: z20.array(z20.string().uuid()).optional(),
  textAnswer: z20.string().max(1e4).optional(),
  fileUrls: z20.array(z20.string().max(1e3)).max(10).optional()
});
var SubmitFormSchema = z20.object({
  answers: z20.array(SubmitFormAnswerSchema).min(1, "At least one answer is required")
});
var SaveFormProgressSchema = z20.object({
  answers: z20.array(SubmitFormAnswerSchema)
});
var FormBaseSchema = z20.object({
  id: z20.string().uuid(),
  spaceId: z20.string().uuid(),
  title: z20.string().max(255),
  description: z20.string().nullable(),
  bannerUrl: z20.string().max(500).nullable(),
  shuffleQuestions: z20.boolean(),
  allowMultipleSubmissions: z20.boolean(),
  status: FormStatusSchema,
  formType: FormTypeSchema,
  createdBy: z20.string().uuid(),
  createdAt: z20.coerce.date(),
  updatedAt: z20.coerce.date()
});
var FormQuestionGroupSchema = z20.object({
  id: z20.string().uuid(),
  formId: z20.string().uuid(),
  title: z20.string().max(255),
  description: z20.string().nullable(),
  createdAt: z20.coerce.date(),
  updatedAt: z20.coerce.date()
});
var FormAnalyticsUserSchema = z20.object({
  userId: z20.string(),
  name: z20.string().nullable(),
  displayName: z20.string().nullable(),
  email: z20.string().nullable(),
  avatar: z20.string().nullable(),
  // Extended profile fields — populated from the Supabase profile table.
  // Optional + nullable so the schema stays backward-compatible.
  firstName: z20.string().nullable().optional(),
  lastName: z20.string().nullable().optional(),
  occupation: z20.string().nullable().optional(),
  city: z20.string().nullable().optional(),
  state: z20.string().nullable().optional(),
  country: z20.string().nullable().optional(),
  timezone: z20.string().nullable().optional(),
  facebook: z20.string().nullable().optional(),
  instagram: z20.string().nullable().optional(),
  youtube: z20.string().nullable().optional(),
  twitter: z20.string().nullable().optional(),
  linkedin: z20.string().nullable().optional(),
  tiktok: z20.string().nullable().optional(),
  hasSubmitted: z20.boolean(),
  submissionCount: z20.number().int(),
  inProgressCount: z20.number().int(),
  lastSubmittedAt: z20.coerce.date().nullable(),
  latestSubmissionId: z20.string().uuid().nullable()
});
var FormAnalyticsSubmissionByDateSchema = z20.object({
  date: z20.string(),
  count: z20.number().int()
});
var FormAnalyticsSchema = z20.object({
  totalMembers: z20.number().int(),
  submittedCount: z20.number().int(),
  notSubmittedCount: z20.number().int(),
  totalSubmissions: z20.number().int(),
  inProgressSubmissions: z20.number().int(),
  users: z20.object({
    data: z20.array(FormAnalyticsUserSchema),
    pagination: z20.object({
      totalItems: z20.number().int(),
      totalPages: z20.number().int(),
      currentPage: z20.number().int(),
      perPage: z20.number().int()
    })
  }),
  submissionsByDate: z20.array(FormAnalyticsSubmissionByDateSchema)
});

// src/community-hub/moderation.ts
import { z as z21 } from "zod";
var CreateReportSchema = z21.object({
  targetType: z21.enum([
    "post",
    "comment",
    "message",
    "user"
  ]),
  targetId: z21.string().uuid(),
  reason: z21.string().min(1).max(100).optional(),
  description: z21.string().max(1e3).optional()
});
var UpdateReportStatusSchema = z21.object({
  status: z21.enum([
    "pending",
    "reviewing",
    "resolved",
    "dismissed"
  ]),
  reason: z21.string().max(500).optional()
});

// src/community-hub/notification.ts
import { z as z22 } from "zod";
var NotificationType = /* @__PURE__ */ function(NotificationType2) {
  NotificationType2["POST_REPLY"] = "post.reply";
  NotificationType2["POST_REACTION"] = "post.reaction";
  NotificationType2["COMMENT_REPLY"] = "comment.reply";
  NotificationType2["COMMENT_REACTION"] = "comment.reaction";
  NotificationType2["MENTION"] = "mention";
  NotificationType2["QUIZ_GRADED"] = "quiz.graded";
  NotificationType2["LESSON_ASSIGNED"] = "lesson.assigned";
  NotificationType2["SPACE_INVITE"] = "space.invite";
  NotificationType2["ACHIEVEMENT_EARNED"] = "achievement.earned";
  return NotificationType2;
}({});
var NotificationTypeSchema = z22.nativeEnum(NotificationType);
var UpdateNotificationPreferencesSchema = z22.object({
  notificationType: NotificationTypeSchema,
  enabledInApp: z22.boolean().optional(),
  enabledEmail: z22.boolean().optional(),
  enabledPush: z22.boolean().optional()
});
var MarkNotificationsAsReadSchema = z22.object({
  notificationIds: z22.array(z22.string().uuid("Invalid notification ID")).min(1, "At least one notification ID required")
});

// src/community-hub/space.ts
import { z as z23 } from "zod";
var SpaceType = /* @__PURE__ */ function(SpaceType2) {
  SpaceType2["CONTAINER"] = "container";
  SpaceType2["FEED"] = "feed";
  SpaceType2["CONTENT"] = "content";
  SpaceType2["CHAT"] = "chat";
  SpaceType2["SINGLE_LESSON"] = "single_lesson";
  return SpaceType2;
}({});
var SpaceTypeSchema = z23.nativeEnum(SpaceType);
var SpaceStatus = /* @__PURE__ */ function(SpaceStatus2) {
  SpaceStatus2["ACTIVE"] = "active";
  SpaceStatus2["ARCHIVED"] = "archived";
  return SpaceStatus2;
}({});
var SpaceStatusSchema = z23.nativeEnum(SpaceStatus);
var SpaceRefSchema = z23.object({
  id: z23.string().uuid(),
  name: z23.string(),
  spaceType: SpaceTypeSchema,
  icon: z23.string().optional().nullable(),
  bannerImage: z23.string().max(500).optional().nullable(),
  mobileBannerImage: z23.string().max(500).optional().nullable(),
  thumbnailImage: z23.string().max(500).optional().nullable(),
  parentId: z23.string().uuid().optional().nullable(),
  accessGroupId: z23.number().int().optional().nullable()
});
var SpaceBaseSchema = z23.object({
  id: z23.string().uuid(),
  name: z23.string().min(1).max(150),
  description: z23.string().optional().nullable(),
  spaceType: SpaceTypeSchema,
  status: SpaceStatusSchema,
  parentId: z23.string().uuid().optional().nullable(),
  accessGroupId: z23.number().int().optional().nullable(),
  icon: z23.string().optional().nullable(),
  bannerImage: z23.string().max(500).optional().nullable(),
  mobileBannerImage: z23.string().max(500).optional().nullable(),
  thumbnailImage: z23.string().max(500).optional().nullable(),
  position: z23.number().int().optional().nullable(),
  settings: z23.record(z23.unknown()).optional().nullable(),
  showProgressBar: z23.boolean(),
  showSubtitle: z23.boolean(),
  showIndexBadge: z23.boolean(),
  showLessonLabel: z23.boolean(),
  showSectionLabel: z23.boolean(),
  createdAt: z23.coerce.date(),
  updatedAt: z23.coerce.date(),
  deletedAt: z23.coerce.date().optional().nullable(),
  // Computed stats for content-type sub-spaces (modules)
  lessonCount: z23.number().int().optional(),
  hasDownloadableAssets: z23.boolean().optional(),
  // Relations (populated when loaded with relations)
  parent: SpaceRefSchema.optional().nullable(),
  children: z23.array(SpaceRefSchema).optional()
});
var CreateSpaceSchema = z23.object({
  name: z23.string().min(1, "Name is required").max(150, "Name must be 150 characters or less"),
  description: z23.string().optional(),
  accessGroupId: z23.number().int().positive("Invalid access group ID"),
  // Top-level space type: 'container' (default) holds sub-spaces; 'single_lesson' holds exactly one lesson
  spaceType: z23.enum([
    "container",
    "single_lesson"
  ]).optional(),
  icon: z23.string().optional(),
  bannerImage: z23.string().max(500).optional(),
  thumbnailImage: z23.string().max(500).optional(),
  position: z23.number().int().min(0).optional(),
  settings: z23.record(z23.unknown()).optional(),
  showIndexBadge: z23.boolean().optional()
});
var CreateSubSpaceSchema = z23.object({
  name: z23.string().min(1, "Name is required").max(150, "Name must be 150 characters or less"),
  description: z23.string().optional(),
  spaceType: z23.enum([
    "feed",
    "content",
    "chat"
  ], {
    errorMap: /* @__PURE__ */ __name(() => ({
      message: "Space type must be feed, content, or chat"
    }), "errorMap")
  }),
  icon: z23.string().optional(),
  bannerImage: z23.string().max(500).optional(),
  mobileBannerImage: z23.string().max(500).optional(),
  thumbnailImage: z23.string().max(500).optional(),
  position: z23.number().int().min(0).optional(),
  settings: z23.record(z23.unknown()).optional(),
  accessGroupId: z23.number().int().positive("Invalid access group ID").optional(),
  showProgressBar: z23.boolean().optional(),
  showSubtitle: z23.boolean().optional(),
  showLessonLabel: z23.boolean().optional(),
  showSectionLabel: z23.boolean().optional()
});
var UpdateSpaceSchema = z23.object({
  name: z23.string().min(1, "Name is required").max(150, "Name must be 150 characters or less").optional(),
  description: z23.string().optional(),
  accessGroupId: z23.number().int().positive("Invalid access group ID").optional(),
  status: SpaceStatusSchema.optional(),
  icon: z23.string().optional(),
  bannerImage: z23.string().max(500).optional(),
  mobileBannerImage: z23.string().max(500).optional(),
  thumbnailImage: z23.string().max(500).optional(),
  position: z23.number().int().min(0).optional(),
  settings: z23.record(z23.unknown()).optional(),
  showProgressBar: z23.boolean().optional(),
  showSubtitle: z23.boolean().optional(),
  showIndexBadge: z23.boolean().optional(),
  showLessonLabel: z23.boolean().optional(),
  showSectionLabel: z23.boolean().optional()
});
var FeedSpaceItemSchema = z23.object({
  id: z23.string().uuid(),
  name: z23.string(),
  icon: z23.string().nullable(),
  bannerImage: z23.string().nullable().optional(),
  thumbnailImage: z23.string().nullable().optional(),
  hasAccess: z23.boolean()
});

// src/community-hub/terms.ts
import { z as z24 } from "zod";
var TermsBaseSchema = z24.object({
  id: z24.string().uuid(),
  name: z24.string().min(1).max(150),
  version: z24.string().min(1).max(100),
  heading: z24.string().max(150).nullable().optional(),
  body: z24.string().min(1),
  termsUrl: z24.string().url().nullable().optional(),
  createdAt: z24.coerce.date(),
  updatedAt: z24.coerce.date()
});
var optionalUrlField = z24.string().max(500).optional().nullable().transform((value) => value && value.length > 0 ? value : void 0).pipe(z24.string().url("Invalid URL").optional());
var CreateTermsSchema = z24.object({
  name: z24.string().min(1, "Name is required").max(150),
  version: z24.string().min(1, "Version is required").max(100),
  heading: z24.string().max(150).optional(),
  body: z24.string().min(1, "Body is required"),
  termsUrl: optionalUrlField
});
var UpdateTermsSchema = z24.object({
  name: z24.string().min(1).max(150).optional(),
  version: z24.string().min(1).max(100).optional(),
  heading: z24.string().max(150).nullable().optional(),
  body: z24.string().min(1).optional(),
  termsUrl: optionalUrlField
});
var TermsAcceptanceResponseSchema = z24.object({
  requiresAcceptance: z24.boolean(),
  accepted: z24.boolean(),
  acceptedVersion: z24.string().nullable(),
  acceptedAt: z24.coerce.date().nullable(),
  terms: TermsBaseSchema.nullable()
});
var AcceptSpaceTermsSchema = z24.object({
  version: z24.string().min(1)
});

// src/community-hub/user.ts
import { z as z25 } from "zod";
var CreateUserSchema = z25.object({
  email: z25.string().email("Invalid email address"),
  password: z25.string().min(8, "Password must be at least 8 characters"),
  firstName: z25.string().min(1, "First name is required").max(100),
  lastName: z25.string().min(1, "Last name is required").max(100),
  displayName: z25.string().max(200).optional(),
  username: z25.string().min(1).max(30),
  avatar: z25.string().url("Invalid avatar URL").optional().or(z25.literal("")),
  accessGroupId: z25.number().int().positive("Access group is required"),
  roleId: z25.number().int().positive("Role is required")
});
var UserResponseSchema = z25.object({
  id: z25.string().uuid(),
  email: z25.string().email(),
  firstName: z25.string(),
  lastName: z25.string(),
  displayName: z25.string().optional().nullable(),
  avatar: z25.string().optional().nullable(),
  createdAt: z25.coerce.date()
});
var UpdateUserSchema = z25.object({
  email: z25.string().email("Invalid email address").optional(),
  password: z25.string().min(8, "Password must be at least 8 characters").optional(),
  firstName: z25.string().min(1, "First name is required").max(100).optional(),
  lastName: z25.string().min(1, "Last name is required").max(100).optional(),
  displayName: z25.string().max(200).optional(),
  avatar: z25.string().url("Invalid avatar URL").optional().or(z25.literal("")),
  accessGroupId: z25.number().int().positive("Access group is required").optional(),
  roleId: z25.number().int().positive("Role is required").optional()
});

// src/community-hub/product.ts
import { z as z26 } from "zod";
var AccessConfigRoleSchema = z26.object({
  trial: z26.string().nullable().optional(),
  subscriber: z26.string().nullable().optional(),
  unsubscriber: z26.string().nullable().optional()
});
var AccessConfigEntrySchema = z26.object({
  app: z26.string(),
  role: AccessConfigRoleSchema.optional(),
  variation: z26.number().optional(),
  access_group: z26.string().nullable().optional()
});
var ProductSchema = z26.object({
  product_id: z26.number().int(),
  product_title: z26.string().nullable(),
  access_config: z26.array(AccessConfigEntrySchema).nullable(),
  created_at: z26.string()
});
var CreateProductSchema = z26.object({
  product_id: z26.number().int().positive("Product ID must be a positive integer"),
  product_title: z26.string().min(1, "Product title is required"),
  access_config: z26.array(AccessConfigEntrySchema).optional().default([])
});
var ProductFiltersSchema = z26.object({
  search: z26.string().optional()
});

// src/content/base.ts
import { array, object as object9, string as string9, union as union2, z as z38, coerce as coerce7, lazy } from "zod";

// src/instructor/base.ts
import { coerce as coerce4, object as object4, string as string4 } from "zod";

// src/instructor/instructor-type.enum.ts
import { z as z27 } from "zod";
var InstructorTypeEnumValues = [
  "REGULAR",
  "GUEST"
];
var InstructorTypeEnumObj = z27.enum(InstructorTypeEnumValues);
var InstructorTypeEnum = InstructorTypeEnumObj.enum;

// src/instructor/media-type.enum.ts
import { z as z28 } from "zod";
var MediaTypeEnumValues = [
  "instagram",
  "facebook",
  "linkedin",
  "twitter",
  "website",
  "youtube",
  "tiktok"
];
var MediaTypeEnumObj = z28.enum(MediaTypeEnumValues);
var MediaTypeEnum = MediaTypeEnumObj.enum;

// src/instructor/base.ts
var SocialMedia = object4({
  mediaType: MediaTypeEnumObj,
  url: string4().url()
});
var ProfilePicture = object4({
  potrait: string4(),
  landscape: string4(),
  square: string4()
});
var InstructorProfilePictureSchema = object4({
  potrait: string4().url().nullable(),
  landscape: string4().url().nullable(),
  square: string4().url().nullable()
}).optional();
var Instructor = object4({
  id: coerce4.string(),
  firstName: string4(),
  lastName: string4(),
  email: string4().email().optional().nullable(),
  isActive: coerce4.boolean(),
  rycProfile: string4().nullable(),
  slug: string4().optional(),
  createdAt: coerce4.string(),
  updatedAt: coerce4.string(),
  profilePicture: InstructorProfilePictureSchema,
  socialMedia: SocialMedia.array().optional().nullable(),
  strongPoints: string4().array().optional().nullable(),
  role: string4().optional(),
  location: string4().optional(),
  bio: string4().optional(),
  type: InstructorTypeEnumObj.optional(),
  affiliateUrl: string4().optional().nullable(),
  userId: string4().optional().nullable()
});
var InstructorRequestSchema = object4({
  type: InstructorTypeEnumObj.optional()
});
var InstructorsByIdsRequestSchema = object4({
  ids: coerce4.string().array().min(1)
});

// src/content/rating.ts
import { coerce as coerce5, object as object5, string as string5, z as z29 } from "zod";
var IndicateorsEnumValues = [
  "difficulty",
  "intensity",
  "nerdiness",
  "awesomeness"
];
var IndicatorsEnumObj = z29.enum(IndicateorsEnumValues);
var IndicatorEnum = IndicatorsEnumObj.enum;
var RatingIndicator = object5({
  [IndicatorEnum.difficulty]: coerce5.number(),
  [IndicatorEnum.intensity]: coerce5.number(),
  [IndicatorEnum.nerdiness]: coerce5.number(),
  [IndicatorEnum.awesomeness]: coerce5.number()
});
var ContentRating = object5({
  contentId: string5(),
  rating: RatingIndicator
});
var ContentRatingResponse = object5({
  contentId: string5(),
  userRating: RatingIndicator,
  averageRating: RatingIndicator
});
var RateContentSchema = object5({
  userId: string5(),
  contentId: string5(),
  ratings: RatingIndicator
});
var GetContentRatingsSchema = RateContentSchema.omit({
  ratings: true
});

// src/content/category.enum.ts
import { z as z30 } from "zod";
var CategoryEnumValues = [
  "STRENGTH",
  "CARDIO",
  "FLOW",
  "RESTORE"
];
var CategoryEnumObj = z30.enum(CategoryEnumValues);
var CategoryEnum = CategoryEnumObj.enum;
var AddonCategoryEnumValues = [
  "INTRODUCTION",
  "EXERCISE",
  "WORKOUT",
  "FOUNDATION"
];
var AddonCategoryEnumObj = z30.enum(AddonCategoryEnumValues);
var AddonCategoryEnum = AddonCategoryEnumObj.enum;

// src/content/content-type.enum.ts
import { z as z31 } from "zod";
var ContentTypeEnumValues = [
  "DOCUMENT",
  "VIDEO",
  "PDF",
  "IMAGE",
  "EVENT"
];
var ContentTypeEnumObj = z31.enum(ContentTypeEnumValues);
var ContentTypeEnum = ContentTypeEnumObj.enum;

// src/content/video-provider.enum.ts
import { z as z32 } from "zod";
var VideoProviderEnumValues = [
  "VIMEO",
  "JW"
];
var VideoProviderEnumObj = z32.enum(VideoProviderEnumValues);
var VideoProviderEnum = VideoProviderEnumObj.enum;

// src/content/equipment.ts
import { number as number2, object as object6, string as string6 } from "zod";
var Equipment = object6({
  id: number2(),
  name: string6(),
  slug: string6()
});

// src/content/status.enum.ts
import { z as z33 } from "zod";
var StatusEnumValues = [
  "DRAFT",
  "PUBLISHED",
  "TRASH"
];
var StatusEnumObj = z33.enum(StatusEnumValues);
var StatusEnum = StatusEnumObj.enum;

// src/ryc/content/meta.ts
import { boolean as boolean2, coerce as coerce6, object as object8, string as string8, z as z37 } from "zod";

// src/ryc/content/series.enum.ts
import { z as z34 } from "zod";
var RYCContentMetaSeriesEnumValues = [
  "Core",
  "Flow",
  "Standing",
  "Express",
  "Chair",
  "Fusion",
  "Scaled"
];
var RYCContentMetaSeriesEnumObject = z34.enum(RYCContentMetaSeriesEnumValues);
var ERYCContentMetaSeries = RYCContentMetaSeriesEnumObject.enum;

// src/ryc/content/type.enum.ts
import { z as z35 } from "zod";
var RYCContentMeTypeEnumValues = [
  "WORKOUT",
  "Educational",
  "Addon"
];
var RYCContentMetaTypeEnumObject = z35.enum(RYCContentMeTypeEnumValues);
var ERYCContentMetaType = RYCContentMetaTypeEnumObject.enum;

// src/ryc/content/category.ts
import { date, number as number3, object as object7, string as string7 } from "zod";
var RYCContentCategorySchema = object7({
  id: number3(),
  name: string7(),
  createdAt: string7().or(date()),
  updatedAt: string7().or(date())
});
var RYCContentCategoryResponseSchema = RYCContentCategorySchema.array();

// src/ryc/step/tier.ts
import { z as z36 } from "zod";
var TierValues = [
  "TIER_1",
  "TIER_2",
  "TIER_3"
];
var TiersEnumObject = z36.enum(TierValues);
var ETiersEnum = TiersEnumObject.enum;

// src/ryc/content/meta.ts
var RYCContentMetaInfromationSchema = object8({
  tiers: TiersEnumObject.array().optional().default([]),
  series: RYCContentMetaSeriesEnumObject.nullable().optional(),
  stage: coerce6.number().nullable().optional(),
  type: RYCContentMetaTypeEnumObject.optional(),
  isRegular: coerce6.boolean().optional().default(false),
  isSupportive: coerce6.boolean().optional().default(false),
  category: CategoryEnumObj,
  categories: RYCContentCategorySchema.array().optional().default([]),
  pdfLink: string8().optional().nullable(),
  hasPdfAttachment: boolean2().optional()
});
var RYCContentMetaInformationBaseSchema = RYCContentMetaInfromationSchema.extend({
  id: coerce6.string().optional(),
  contentId: coerce6.string().optional(),
  createdAt: coerce6.string().or(z37.date()).optional(),
  updatedAt: coerce6.string().or(z37.date()).optional()
});

// src/content/base.ts
var VimeoVideo = object9({
  vimeoVideoId: string9().optional(),
  jwVideoUrl: string9().nullable().optional(),
  provider: VideoProviderEnumObj,
  bannerUrl2x: string9(),
  duration: coerce7.number(),
  description: string9().nullable()
});
var TrashContentVimeoVideo = object9({
  bannerUrl2x: string9(),
  duration: coerce7.number(),
  description: string9()
});
var CommonContentFields = object9({
  id: string9(),
  name: string9().min(3, "name is required"),
  category: lazy(() => CategoryEnumObj.or(AddonCategoryEnumObj)),
  instructor: lazy(() => Instructor),
  createdAt: coerce7.string(),
  updatedAt: coerce7.string(),
  watchedDate: coerce7.string().optional(),
  meta: lazy(() => RYCContentMetaInformationBaseSchema.partial().optional())
});
var BareContent = CommonContentFields.extend({
  type: lazy(() => ContentTypeEnumObj),
  status: StatusEnumObj,
  video: lazy(() => VimeoVideo),
  isAllowComment: coerce7.boolean().default(false),
  equipments: lazy(() => Equipment.array()),
  publishedDate: z38.union([
    z38.string(),
    z38.date(),
    CustomLuxonDateSchema
  ]),
  averageRating: lazy(() => RatingIndicator),
  isNew: coerce7.boolean().default(false).optional(),
  favorite: coerce7.boolean().default(false).optional(),
  instructorId: string9(),
  // this is needed for for react rendering. id is not unique in watch history response.
  uniqueId: string9().optional(),
  createdAt: coerce7.date(),
  updatedAt: coerce7.date(),
  meta: lazy(() => RYCContentMetaInformationBaseSchema.partial().optional())
});
var Content = BareContent.extend({
  parentPlaylistsIds: string9().array().default([]).optional(),
  userHasLeftRating: coerce7.boolean().default(false).optional(),
  instructor: Instructor
});
var TrashContentSchema = CommonContentFields.extend({
  status: z38.literal(StatusEnum.TRASH),
  video: lazy(() => TrashContentVimeoVideo)
});
var AllStatusContentSchema = Content.omit({
  status: true
}).extend({
  status: lazy(() => StatusEnumObj)
});
var ContentWithRatingFlagSchema = AllStatusContentSchema.extend({
  createdAt: coerce7.date(),
  updatedAt: coerce7.date(),
  publishedDate: z38.union([
    z38.string(),
    z38.date()
  ]).optional().nullable(),
  instructor: Instructor.extend({
    id: z38.union([
      coerce7.string(),
      coerce7.number()
    ]),
    createdAt: coerce7.date(),
    updatedAt: coerce7.date()
  }),
  userHasLeftRating: coerce7.boolean()
});
var ContentFindAllResponseSchema = object9({
  items: ContentWithRatingFlagSchema.array(),
  meta: object9({
    page: coerce7.number(),
    perPage: coerce7.number(),
    total: coerce7.number(),
    totalPages: coerce7.number()
  })
});
var ContentAndTrashContentUnion = z38.union([
  Content,
  TrashContentSchema
]);
var ContentWithWatchedDate = Content.extend({
  watchedDate: string9().or(CustomLuxonDateSchema).optional()
});
var ContentByDate = object9({
  id: string9(),
  activeOn: string9(),
  createdAt: coerce7.date(),
  updatedAt: coerce7.date(),
  content: Content
});
var ContentByDateResponseSchema = object9({
  items: union2([
    array(ContentByDate),
    z38.null()
  ]),
  meta: object9({
    startDate: string9(),
    endDate: string9()
  })
});
var DateRangeQuerySchema = object9({
  startDate: string9().nullable(),
  endDate: string9().nullable(),
  page: coerce7.number().optional()
});
var UserContentRatingResponse = array(RatingIndicator);
var WatchedStatusEnumValues = [
  "WATCHED",
  "UNWATCHED",
  "ALL"
];
var WatchedStatusEnumObj = z38.enum(WatchedStatusEnumValues);
var WatchedFilterEnum = WatchedStatusEnumObj.enum;

// src/content/content.request.ts
import { object as object10, string as string10, coerce as coerce8, array as array2 } from "zod";

// src/fit/content/recently-added.enum.ts
import { z as z39 } from "zod";
var ContentFilterTypeValues = [
  "recentlyAdded"
];
var ContentFilterTypeObj = z39.enum(ContentFilterTypeValues);
var ContentFilterTypeEnum = ContentFilterTypeObj.enum;

// src/content/content.request.ts
var ContentRequestSchema = object10({
  type: ContentFilterTypeObj.optional(),
  instructorId: string10().optional(),
  categoryId: string10().optional(),
  duration: string10().optional(),
  equipments: string10().optional(),
  difficulty: string10().optional(),
  intensity: string10().optional(),
  nerdiness: string10().optional(),
  awesomeness: string10().optional(),
  perPage: coerce8.number().optional(),
  page: coerce8.number().optional()
});
var ContentRequestBESchema = object10({
  app: AppNameEnumObj.optional(),
  query: string10().optional(),
  shuffle: CoerceBoolean.optional().default(false),
  loadAll: CoerceBoolean.optional().default(false),
  type: ContentFilterTypeObj,
  instructorIds: array2(string10()).default([]),
  categoryId: CategoryEnumObj,
  equipments: array2(string10()).default([]),
  status: StatusEnumObj.array().optional(),
  dashboard: CoerceBoolean.optional().default(false),
  durationFrom: coerce8.number().default(1),
  durationTo: coerce8.number().default(1e3),
  difficultyFrom: coerce8.number().default(1),
  difficultyTo: coerce8.number().default(5),
  intensityFrom: coerce8.number().default(1),
  intensityTo: coerce8.number().default(5),
  nerdinessFrom: coerce8.number().default(1),
  nerdinessTo: coerce8.number().default(5),
  awesomenessFrom: coerce8.number().default(1),
  awesomenessTo: coerce8.number().default(5),
  watchedStatus: WatchedStatusEnumObj,
  perPage: coerce8.number().max(150),
  page: coerce8.number(),
  sortByNewlyAdded: CoerceBoolean.optional().default(false),
  period: string10(),
  date: string10(),
  orderBy: string10().optional(),
  userTimezone: string10().optional(),
  addon: CoerceBoolean.optional().default(false)
}).partial();
var contentFilterDefaultValues = {
  categoryId: "",
  difficulty: "0-5",
  duration: "1-60",
  equipments: "",
  instructorId: "",
  intensity: "0-5",
  nerdiness: "0-5",
  awesomeness: "0-5",
  page: "1",
  perPage: "15",
  type: "",
  query: "",
  shuffle: "true"
};
var contentFilterEmptyDefaultValues = {
  categoryId: "",
  difficulty: "",
  duration: "",
  equipments: "",
  instructorId: "",
  intensity: "",
  nerdiness: "",
  awesomeness: "",
  page: "",
  perPage: "",
  type: "",
  query: ""
};

// src/content/you-may-like.request.ts
import { coerce as coerce9, object as object11, string as string11 } from "zod";
var YouMayLikeRequestFilterSchema = object11({
  contentId: string11(),
  commentId: coerce9.number().optional().transform((val) => val == null ? void 0 : val.toString()),
  date: string11().optional(),
  category: CategoryEnumObj.or(AddonCategoryEnumObj).optional(),
  instructorId: coerce9.string().optional(),
  playlistId: coerce9.string().optional(),
  seriesId: coerce9.string().optional()
});

// src/content/content.response.ts
import { coerce as coerce10, object as object12 } from "zod";
var ContentFindByIdsResponseSchema = object12({
  items: Content.array(),
  meta: object12({
    total: coerce10.number(),
    page: coerce10.number(),
    perPage: coerce10.number(),
    totalPages: coerce10.number()
  })
});

// src/equipments/equipments.enum.ts
import { z as z40 } from "zod";
var EquipmentsValues = [
  "CHAIR",
  "BALL",
  "ROPE",
  "YOGA_MAT",
  "CUP"
];
var EQuipmentObj = z40.enum(EquipmentsValues);
var EQuipmentEnum = EQuipmentObj.enum;

// src/events/base.ts
import { z as z43 } from "zod";

// src/events/event.ts
import { z as z41 } from "zod";
var EventStatusEnumValues = [
  "SCHEDULED",
  "STARTED",
  "ENDED"
];
var EventStatusEnumObj = z41.enum(EventStatusEnumValues);
var EventStatusEnum = EventStatusEnumObj.enum;

// src/events/type.enum.ts
import { z as z42 } from "zod";
var EventTypeValues = [
  "CLASS",
  "LECTURE",
  "WORKSHOP",
  "MEETUP",
  "CONFERENCE"
];
var EventTypeObj = z42.enum(EventTypeValues);
var EEventTypeEnum = EventTypeObj.enum;

// src/events/base.ts
var BaseEventSchema = z43.object({
  id: z43.string(),
  title: z43.string().min(1, "title is required"),
  description: z43.string().optional(),
  instructor: Instructor,
  status: EventStatusEnumObj,
  videoStreamUrl: z43.string().url().min(1, "video stream url is required"),
  type: EventTypeObj,
  contentId: z43.coerce.string(),
  calendarLink: z43.string().optional(),
  scheduleDateTime: CustomLuxonDateSchema,
  isDataMigrated: z43.boolean().optional().default(false)
});

// src/events/be-schema.ts
import { string as string12 } from "zod";
var CreateEventSchemaBE = BaseEventSchema.pick({
  title: true,
  description: true,
  videoStreamUrl: true,
  type: true,
  calendarLink: true,
  scheduleDateTime: true,
  contentId: true
}).extend({
  instructorId: string12()
});
var UpdateEventSchemaBE = BaseEventSchema.omit({
  id: true,
  instructor: true
}).extend({
  instructorId: string12()
}).partial();

// src/events/fe-schema.ts
import { string as string13, z as z44 } from "zod";
var CreateEventSchemaFE = BaseEventSchema.pick({
  title: true,
  description: true,
  videoStreamUrl: true,
  type: true,
  calendarLink: true,
  scheduleDateTime: true
}).extend({
  instructorId: z44.coerce.string(),
  contentId: string13().min(1, "content id is required")
});
var UpdateEventSchemaFE = CreateEventSchemaFE.partial();
var defaultEventSchemaValues = {
  title: "",
  description: "",
  videoStreamUrl: "",
  calendarLink: "",
  type: EEventTypeEnum.CLASS,
  scheduleDateTime: void 0,
  instructorId: ""
};

// src/events/socket-event.enum.ts
import { z as z45 } from "zod";
var SocketEventTypeEnumValues = [
  "connect",
  "disconnect",
  "USER_JOINED",
  "USER_LEFT",
  "EVENT_STARTED",
  "EVENT_FINISHED",
  "EVENT_INFO",
  "SEND_MESSAGE",
  "REACT_TO_MESSAGE",
  "MESSAGE_ERROR"
];
var SocketEventTypeEnumObj = z45.enum(SocketEventTypeEnumValues);
var SocketEventTypeEnum = SocketEventTypeEnumObj.enum;

// src/events/pub-sub-event.enum.ts
import { z as z46 } from "zod";
var PubSubEventsEnumValues = [
  "VIEWER_JOINED",
  "VIEWER_LEFT",
  "EVENT_ENDED",
  "EVENT_STARTED",
  "SEND_MESSAGE",
  "REACT_TO_MESSAGE",
  "BROADCAST_MESSAGE"
];
var PubSubEventsEnumObj = z46.enum(PubSubEventsEnumValues);
var PubSubEventsEnum = PubSubEventsEnumObj.enum;

// src/events/message.ts
import { number as number4, object as object13, string as string14, z as z47 } from "zod";
var EventMessageUserInfoSchema = object13({
  id: string14(),
  avatarUrl: string14(),
  username: string14(),
  userRoles: z47.array(string14()).optional()
});
var EventMessageSchema = z47.object({
  id: number4(),
  user: EventMessageUserInfoSchema,
  message: string14(),
  event: object13({
    id: string14()
  }),
  createdAt: string14(),
  updatedAt: string14()
});
var EventMessagePayloadSchema = object13({
  message: string14(),
  userId: string14(),
  parentId: number4().optional(),
  eventId: string14(),
  avatarUrl: string14(),
  username: string14(),
  userRoles: z47.array(string14()).optional()
});
var SendEventMessageRequestSchema = object13({
  message: string14().min(1, "Message cannot be empty"),
  parentId: number4().optional()
});

// src/events/reply.ts
import { z as z48 } from "zod";

// src/events/reaction.ts
import { number as number5, object as object14, string as string15 } from "zod";
var EventReactionSchema = object14({
  id: string15().uuid(),
  eventMessage: EventMessageSchema,
  userId: string15()
});
var ReactToEventMessageSchema = object14({
  messageId: number5().positive(),
  userId: string15(),
  eventId: string15()
});

// src/events/reply.ts
var RepliesSchema = z48.lazy(() => EventMessageSchema.array());
var EventMessageSchemaWithReplies = EventMessageSchema.extend({
  replies: RepliesSchema,
  reactions: EventReactionSchema.array()
});

// src/leaderboard/base.ts
import { z as z49, object as object15, number as number6, string as string16, boolean as boolean3, coerce as coerce11 } from "zod";
var LeaderBoardSchema = object15({
  id: coerce11.string().min(1),
  index: number6(),
  userId: coerce11.string().min(1),
  avatar: string16().url(),
  name: string16(),
  location: string16(),
  daysActive: string16().nullable(),
  workouts: coerce11.string(),
  points: coerce11.number(),
  isSelf: boolean3(),
  ranked: boolean3(),
  funFact: string16(),
  totalCompletedClass: number6(),
  date: string16()
});
var LeaderBoardTypeEnumValues = [
  "thisWeek",
  "lastWeek",
  "thisMonth",
  "lastMonth"
];
var LeaderBoardTypeEnumObj = z49.enum(LeaderBoardTypeEnumValues);
var LeaderBoardTypeEnum = LeaderBoardTypeEnumObj.enum;
var LeaderBoardRequestSchema = object15({
  type: LeaderBoardTypeEnumObj,
  page: coerce11.number().nullable().optional(),
  perPage: coerce11.number().nullable().optional()
});

// src/leaderboard/be-privacy-schema.ts
import { number as number7, object as object16, string as string17 } from "zod";
var UserPrivacySchemaBE = object16({
  id: number7().positive(),
  userId: string17(),
  isPrivate: CoerceBoolean,
  createdAt: string17(),
  updatedAt: string17()
});
var UserPrivacyRedisSchemaBE = UserPrivacySchemaBE.pick({
  userId: true,
  isPrivate: true
});
var UpdateUserPrivacyBESchema = UserPrivacySchemaBE.pick({
  userId: true,
  isPrivate: true
});

// src/login/base.ts
import { object as object17, string as string18 } from "zod";
var LoginSchema = object17({
  username: string18().min(3),
  password: string18().min(6)
});
var EmailLoginSchema = object17({
  password: string18().min(6),
  email: string18().email()
});

// src/login/exception.enum.ts
import { z as z50 } from "zod";
var JwtExceptionEnumValues = [
  "TokenExpired"
];
var JwtExceptionEnumObj = z50.enum(JwtExceptionEnumValues);

// src/login/password-reset.ts
import { z as z51 } from "zod";
var ForgotPasswordSchema = z51.object({
  email: z51.string().email()
});
var ResetPasswordSchema = z51.object({
  password: z51.string().min(8, "Password must be at least 8 characters"),
  confirmPassword: z51.string().min(8, "Password must be at least 8 characters")
}).refine((d) => d.password === d.confirmPassword, {
  message: "Passwords do not match",
  path: [
    "confirmPassword"
  ]
});
var SendPasswordResetSchema = z51.object({
  email: z51.string().email(),
  redirectUrl: z51.string().url(),
  expiresInHours: z51.number().int().min(1).max(8).optional()
});
var SetPasswordWithTokenSchema = z51.object({
  token: z51.string().uuid(),
  password: z51.string().min(8)
});
var AdminSetPasswordSchema = z51.object({
  email: z51.string().email(),
  password: z51.string().min(8)
});
var SetPasswordWithWpTokenSchema = z51.object({
  password: z51.string().min(8, "Password must be at least 8 characters"),
  userId: z51.string().min(1, "User ID is required")
});
var ResetPasswordSearchParamsSchema = z51.object({
  token: z51.string().uuid().optional()
});

// src/notification/be-condition-json-schema.ts
import { z as z53 } from "zod";

// src/notification/notification.enum.ts
import { z as z52 } from "zod";
var RealTimeNotificationEventTypeValues = [
  "CUSTOM_NOTIFICATION",
  "FIT_COMMENT_MENTION",
  "FIT_COMMENT_REACTION",
  "FIT_INSTRUCTOR_NOTIFICATION",
  "FIT_VIDEO_COMMENT",
  "FIT_WELCOME",
  "MAGIC_LINK_LOGIN",
  "PASSWORD_CHANGE",
  "PASSWORD_RESET",
  // Community Hub Feed notifications
  "CH_NEW_POST",
  "CH_POST_COMMENT",
  "CH_POST_REACTION",
  "CH_COMMENT_REPLY",
  "CH_COMMENT_REACTION",
  "CH_MENTION"
];
var CronNotificationEventTypeValues = [
  "INACTIVITY"
];
var NotificationRulesTypeValues = [
  ...CronNotificationEventTypeValues,
  ...RealTimeNotificationEventTypeValues
];
var NotificationRulesTypeEnumObject = z52.enum(NotificationRulesTypeValues);
var ENotificationRulesType = NotificationRulesTypeEnumObject.enum;
var NotificationRuleStatusValues = [
  "ACTIVE",
  "INACTIVE",
  "DRAFT"
];
var NotificationRuleStatusEnumObject = z52.enum(NotificationRuleStatusValues);
var ENotificationRuleStatus = NotificationRuleStatusEnumObject.enum;
var NotificationChannelValues = [
  "EMAIL",
  "In-App"
];
var NotificationChannelEnumObject = z52.enum(NotificationChannelValues);
var ENotificationChannel = NotificationChannelEnumObject.enum;
var NotificationStatusValues = [
  "PENDING",
  "SENT",
  "FAILED",
  "SCHEDULED"
];
var NotificationStatusEnumObject = z52.enum(NotificationStatusValues);
var ENotificationStatus = NotificationStatusEnumObject.enum;
var NotificationTypeValues = [
  "CRON",
  "REALTIME"
];
var NotificationTypeEnumObject = z52.enum(NotificationTypeValues);
var ENotificationType = NotificationTypeEnumObject.enum;

// src/notification/be-condition-json-schema.ts
var BaseRuleConditionSchema = z53.object({
  type: NotificationRulesTypeEnumObject
});
var FitVideoCommentConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.FIT_VIDEO_COMMENT)
});
var FitCommentMentionConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.FIT_COMMENT_MENTION)
});
var FitInstructorCommentConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.FIT_INSTRUCTOR_NOTIFICATION)
});
var FitCommentLikeConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.FIT_COMMENT_REACTION)
});
var CustomNotificationConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.CUSTOM_NOTIFICATION)
});
var FitWelcomeConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.FIT_WELCOME)
});
var PasswordChangeConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.PASSWORD_CHANGE)
});
var PasswordResetConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.PASSWORD_RESET)
});
var MagicLinkLoginConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.MAGIC_LINK_LOGIN)
});
var ChNewPostConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.CH_NEW_POST)
});
var ChPostCommentConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.CH_POST_COMMENT)
});
var ChPostReactionConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.CH_POST_REACTION)
});
var ChCommentReplyConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.CH_COMMENT_REPLY)
});
var ChCommentReactionConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.CH_COMMENT_REACTION)
});
var ChMentionConditionSchema = BaseRuleConditionSchema.extend({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.CH_MENTION)
});
var RuleConditionJsonColumnValues = [
  "daysOfInactivity",
  "postPurchase",
  "totalCheckins"
];
var RuleConditionJsonColumnObject = z53.enum(RuleConditionJsonColumnValues);
var EnumRuleConditionJsonColumnObject = RuleConditionJsonColumnObject.enum;
var InactivityRuleConditionJsonSchemaBE = z53.object({
  type: z53.literal(NotificationRulesTypeEnumObject.enum.INACTIVITY),
  daysOfInactivity: z53.coerce.number().int().positive().describe("Number of days user has been inactive").optional(),
  postPurchase: z53.tuple([
    z53.number().positive(),
    z53.number().positive()
  ]).describe("Number of days since purchase").optional(),
  totalCheckins: z53.tuple([
    z53.number(),
    z53.number()
  ]).describe("Number of checkins").optional()
});
var RuleConditionJsonSchemaBE_ = z53.discriminatedUnion("type", [
  InactivityRuleConditionJsonSchemaBE,
  CustomNotificationConditionSchema,
  FitCommentMentionConditionSchema,
  FitCommentLikeConditionSchema,
  FitInstructorCommentConditionSchema,
  FitVideoCommentConditionSchema,
  FitWelcomeConditionSchema,
  MagicLinkLoginConditionSchema,
  PasswordChangeConditionSchema,
  PasswordResetConditionSchema,
  // Community Hub Feed notifications
  ChNewPostConditionSchema,
  ChPostCommentConditionSchema,
  ChPostReactionConditionSchema,
  ChCommentReplyConditionSchema,
  ChCommentReactionConditionSchema,
  ChMentionConditionSchema
]);
var RuleConditionJsonSchemaBE = RuleConditionJsonSchemaBE_.refine((data) => {
  if (data.type === "INACTIVITY") {
    return data.daysOfInactivity !== void 0 || data.postPurchase !== void 0 || data.totalCheckins !== void 0;
  }
  return true;
}, {
  message: 'For INACTIVITY, at least one of "Days of Inactivity", "Post Purchase", or "Total Checkins" must be provided.'
});
function validateRuleConditions(conditionsJson) {
  const parsed = JSON.parse(conditionsJson);
  return RuleConditionJsonSchemaBE.parse(parsed);
}
__name(validateRuleConditions, "validateRuleConditions");

// src/notification/be-request.ts
import { coerce as coerce12, object as object18, string as string19 } from "zod";
var NotificationFindAllRequestQuerySchema = object18({
  page: coerce12.number().optional().default(1).describe("Page number (default: 1)"),
  perPage: coerce12.number().optional().default(10).describe("Items per page (default: 10)"),
  isActive: coerce12.boolean().optional().describe("Filter by active status")
});
var NotificationLogFindAllRequestQuerySchema = object18({
  page: coerce12.number().optional().default(1).describe("Page number (default: 1)"),
  perPage: coerce12.number().optional().default(10).describe("Items per page (default: 10)"),
  status: NotificationStatusEnumObject.optional().describe("Filter by notification status"),
  userId: string19().optional().describe("Filter by user ID"),
  channel: NotificationChannelEnumObject.optional().describe("Filter by notification channel")
});

// src/notification/be-response-schema.ts
import { boolean as boolean4, number as number8, string as string20, z as z54 } from "zod";
var TemplateResponseSchema = z54.object({
  id: number8(),
  name: string20(),
  subject: string20(),
  body: string20(),
  isEnabled: boolean4(),
  createdAt: string20(),
  updatedAt: string20(),
  redirectUrl: string20().nullable().optional()
});
var NotificationRuleResponseSchemaBE = z54.object({
  id: string20(),
  name: string20(),
  app: AppNameEnumObj,
  type: NotificationTypeEnumObject,
  conditionsJson: RuleConditionJsonSchemaBE,
  template: TemplateResponseSchema,
  channel: NotificationChannelEnumObject,
  isActive: boolean4(),
  workflowId: string20(),
  createdBy: number8().nullable().optional(),
  updatedBy: number8().nullable().optional(),
  createdAt: string20(),
  updatedAt: string20()
});
var NotificationLogResponseSchemaBE = z54.object({
  id: string20(),
  userId: string20(),
  app: AppNameEnumObj,
  ruleId: string20(),
  templateId: string20(),
  status: NotificationStatusEnumObject,
  scheduledAt: string20().nullable().optional(),
  sentAt: string20().nullable().optional(),
  failedAt: string20().nullable().optional(),
  errorMessage: string20().nullable().optional(),
  retryCount: number8().default(0),
  maxRetries: number8().default(3),
  metadata: z54.record(z54.unknown()).nullable().optional(),
  rule: z54.object({
    id: number8(),
    name: string20(),
    type: NotificationTypeEnumObject,
    channel: NotificationChannelEnumObject,
    isActive: boolean4()
  }).nullable().optional(),
  createdAt: string20(),
  updatedAt: string20()
});

// src/notification/be-schema.ts
import { boolean as boolean5, object as object19, string as string21 } from "zod";
var CreateTemplateSchema = object19({
  name: string21().min(1, "Template name is required"),
  subject: string21().min(1, "Email subject is required"),
  body: string21().min(1, "Email body is required"),
  isEnabled: boolean5().optional().default(true),
  redirectUrl: string21().optional().nullable()
});

// src/notification/rule-engine-communication.ts
import { z as z55 } from "zod";
var RuleConditionTypeSchema = z55.enum([
  "INACTIVITY",
  "POST_PURCHASE",
  "NEVER_LOGIN",
  "SUBSCRIPTION_EXPIRY",
  "TRIAL_ENDING",
  "DAY_STEP_CHANGE"
]);
var NotificationRuleSchema = z55.object({
  id: z55.number().describe("Unique rule identifier"),
  name: z55.string().describe("Human-readable rule name"),
  type: NotificationTypeEnumObject.describe("Rule type for categorization"),
  conditionsJson: RuleConditionJsonSchemaBE.describe("Rule conditions in structured format"),
  templateId: z55.number().describe("Associated template ID (for notification app use)"),
  isActive: z55.boolean().describe("Whether rule is currently active"),
  createdAt: z55.string().datetime().describe("Rule creation timestamp"),
  updatedAt: z55.string().datetime().describe("Rule last update timestamp")
});
var RuleEvaluationRequestSchema = z55.object({
  jobDueDate: z55.string().describe("for which date the log should be created"),
  batchId: z55.string().uuid().describe("Unique batch identifier for tracking"),
  requestedAt: z55.string().datetime().describe("When the evaluation was requested"),
  requestSource: z55.string().default("NOTIFICATION_CRON").describe("Source of the request"),
  rules: z55.array(NotificationRuleSchema).min(1).describe("Active rules to evaluate against user data"),
  metadata: z55.record(z55.any()).optional().describe("Additional request metadata")
});
var UserDataSchema = z55.object({
  userId: z55.string().describe("User identifier"),
  username: z55.string().optional().describe("User display name"),
  email: z55.string().email().optional().describe("User email address"),
  registrationDate: z55.string().datetime().optional().describe("User registration date"),
  lastLoginDate: z55.string().datetime().optional().describe("Last login timestamp"),
  lastPurchaseDate: z55.string().datetime().optional().describe("Last purchase timestamp"),
  lastCheckinDate: z55.string().datetime().optional().describe("Last checkin timestamp"),
  purchaseDate: z55.string().datetime().optional().describe("Purchase timestamp"),
  tier: z55.number().optional().describe("User tier level"),
  subscriptionStatus: z55.string().optional().describe("Current subscription status"),
  additionalData: z55.record(z55.any()).optional().describe("Additional user-specific data")
});
var RuleMatchResultSchema = z55.object({
  userId: z55.string().describe("User ID that matched the rule"),
  ruleId: z55.number().describe("Rule ID that was matched"),
  templateId: z55.number().describe("Template ID for notification app to use"),
  matchedConditions: z55.record(z55.any()).describe("Details about which conditions were matched"),
  userData: UserDataSchema.describe("User data for notification app template rendering"),
  matchedAt: z55.string().datetime().describe("When the match was identified"),
  priority: z55.number().default(3).describe("Notification priority (1=highest, 5=lowest)")
});
var RuleEvaluationResponseSchema = z55.object({
  batchId: z55.string().uuid().describe("Same batch ID from request"),
  jobDueDate: z55.string().describe("for which date the job was created"),
  processedAt: z55.string().datetime().describe("When evaluation was completed"),
  totalRulesEvaluated: z55.number().describe("Number of rules processed"),
  totalUsersMatched: z55.number().describe("Total users matched across all rules"),
  matches: z55.array(RuleMatchResultSchema).describe("Array of user-rule matches with user data"),
  processingTimeMs: z55.number().describe("Processing time in milliseconds"),
  statistics: z55.object({
    ruleBreakdown: z55.record(z55.number()).describe("Matches per rule ID"),
    conditionTypeBreakdown: z55.record(z55.number()).describe("Matches per condition type")
  }).optional().describe("Evaluation statistics"),
  metadata: z55.record(z55.any()).optional().describe("Additional response metadata")
});

// src/notification/notification-log.ts
import { boolean as boolean6, number as number9, object as object22, string as string23, z as z58 } from "zod";

// src/notification/realtime-notification/be-payload.ts
import { array as array3, coerce as coerce13, lazy as lazy2, object as object21, string as string22 } from "zod";

// src/notification/novu-workflows.ts
import { object as object20, z as z56 } from "zod";
var NovuWorkflowValues = [
  "inactivity",
  "post-purchase",
  "welcome-notification"
];
var NovuWorkflowsEnumObject = z56.enum(NovuWorkflowValues);
var ENovuWorkflowsEnum = NovuWorkflowsEnumObject.enum;
var NovuEmailTemplateNameValues = [
  "send-inactivity-email",
  "send-post-purchase-email",
  "send-fit-welcome-email"
];
var NovuEmailTemplateNameEnumObject = z56.enum(NovuEmailTemplateNameValues);
var ENovuEmailTemplateNameEnum = NovuEmailTemplateNameEnumObject.enum;
var NovuTenantIdentifierValues = [
  "fit",
  "ryc",
  "members",
  "addon"
];
var NovuTenantIdentifierEnumObject = z56.enum(NovuTenantIdentifierValues);
var ENovuTenantIdentifierEnum = NovuTenantIdentifierEnumObject.enum;
var GenerateSubscriberIdWithTenantSchema = object20({
  tenantIdentifier: NovuTenantIdentifierEnumObject,
  userId: z56.coerce.string()
}).transform((data) => {
  const { tenantIdentifier, userId: userId2 } = data;
  return `${tenantIdentifier}:${userId2}`;
});

// src/notification/realtime-notification/be-payload.ts
var RealtimeNotificationBePayloadSchemaBE = object21({
  appName: lazy2(() => AppNameEnumObj),
  tenantIdentifier: lazy2(() => NovuTenantIdentifierEnumObject),
  type: lazy2(() => NotificationRulesTypeEnumObject),
  content: object21({
    id: string22().optional(),
    name: string22().optional()
  }).optional(),
  liker: object21({
    id: string22(),
    name: string22()
  }).optional(),
  mentioner: object21({
    id: string22(),
    name: string22()
  }).optional(),
  comment: object21({
    id: coerce13.string().optional(),
    body: string22().optional(),
    replier: object21({
      id: string22(),
      name: string22()
    }).optional(),
    commenter: object21({
      id: string22(),
      name: string22()
    }).optional()
  }).optional(),
  user: object21({
    id: string22(),
    name: string22().optional(),
    email: string22().optional()
  }).optional(),
  userIdsToNotify: array3(string22()),
  title: string22().optional(),
  message: string22().optional(),
  redirectUrl: string22().optional(),
  iconUrl: string22().url().optional()
});
var WelcomeNotificationPayloadSchemaBE = object21({
  appName: lazy2(() => AppNameEnumObj),
  tenantIdentifier: lazy2(() => NovuTenantIdentifierEnumObject),
  type: lazy2(() => NotificationRulesTypeEnumObject),
  user: object21({
    id: string22(),
    name: string22().optional(),
    email: string22().optional()
  }),
  userIdsToNotify: array3(string22())
});

// src/notification/realtime-notification/messages.enum.ts
import { z as z57 } from "zod";
var RealtimeNotificationMessageTypeValues = [
  "COMMON",
  "WELCOME"
];
var RealtimeNotificationMessageTypeEnumObject = z57.enum(RealtimeNotificationMessageTypeValues);
var ERealtimeNotificationMessageType = RealtimeNotificationMessageTypeEnumObject.enum;

// src/notification/notification-log.ts
var BasicRuleSchema = object22({
  id: string23(),
  name: string23(),
  type: NotificationTypeEnumObject,
  channel: NotificationChannelEnumObject,
  isActive: boolean6(),
  conditionsJson: RuleConditionJsonSchemaBE,
  workflowId: string23().nullable().optional(),
  template: object22({
    name: string23(),
    subject: string23(),
    body: string23()
  }).nullable().optional()
});
var NotificationLogSchema = object22({
  id: string23(),
  userId: string23(),
  ruleId: string23(),
  templateId: string23(),
  status: NotificationStatusEnumObject,
  scheduledAt: string23().datetime().nullable().optional(),
  sentAt: string23().datetime().nullable().optional(),
  failedAt: string23().datetime().nullable().optional(),
  errorMessage: string23().nullable().optional(),
  retryCount: number9().default(0),
  maxRetries: number9().default(3),
  metadata: z58.record(z58.unknown()).optional(),
  rule: BasicRuleSchema.nullable().optional(),
  createdAt: string23().datetime()
});
var GetNotificationLogsRequestSchema = RequestSchema.extend({
  status: NotificationStatusEnumObject.optional(),
  userId: string23().optional(),
  channel: NotificationChannelEnumObject.optional()
});
var GetNotificationLogsResponseSchema = object22({
  items: z58.array(NotificationLogSchema),
  meta: object22({
    totalPages: number9(),
    page: number9(),
    perPage: number9(),
    total: number9()
  })
});
var NotificationLogMetadataSchema = object22({
  ruleName: string23(),
  ruleType: NotificationTypeEnumObject,
  conditions: RuleConditionJsonSchemaBE,
  batchId: string23().uuid(),
  userData: object22({
    userId: string23()
  }),
  matchedAt: string23().datetime(),
  requestSource: string23(),
  matchedConditions: object22({
    type: RuleConditionTypeSchema,
    daysOfInactivity: number9().int().nonnegative(),
    lastCheckinDate: string23().optional()
  }).partial(),
  totalRulesProcessed: number9().int().nonnegative(),
  averageProcessingTimePerRule: number9().nonnegative(),
  // Bulk notification fields (title/message from RealtimeNotificationBePayloadSchemaBE)
  isBulkNotification: boolean6(),
  scheduledBy: string23()
}).merge(RealtimeNotificationBePayloadSchemaBE).partial().nullable();

// src/notification/template/be-schema.ts
import { boolean as boolean7, number as number10, object as object23, string as string24 } from "zod";
var NotificationTemplateSchemaBE = object23({
  id: number10().int().positive(),
  name: string24().min(1),
  subject: string24().min(1),
  body: string24().min(1),
  isEnabled: boolean7().optional(),
  createdAt: string24(),
  updatedAt: string24()
});

// src/notification/template/novu-workflow.ts
var NovuWorkflowTemplateSchema = NotificationTemplateSchemaBE.pick({
  body: true,
  subject: true
});

// src/notification/template/variables.ts
var cronVariables = [
  "name",
  "humanizedDate",
  "relativeDate",
  "daysOfInactivity"
];
var userProfileVariables = [
  "name",
  "firstName",
  "lastName",
  "email"
];
var TemplateVariables = {
  [ENotificationRulesType.FIT_VIDEO_COMMENT]: [
    "contentId",
    "contentName",
    "commentOwner",
    "commentId",
    "commentBody",
    "replierId",
    "replierName",
    "commenterId",
    "commenterName"
  ],
  [ENotificationRulesType.FIT_INSTRUCTOR_NOTIFICATION]: [
    "contentId",
    "contentName",
    "commentOwner",
    "commentId",
    "commentBody",
    "commenterId",
    "commenterName"
  ],
  [ENotificationRulesType.FIT_COMMENT_MENTION]: [
    "contentId",
    "contentName",
    "commentId",
    "commentBody",
    "mentionerId",
    "mentionerName"
  ],
  [ENotificationRulesType.FIT_COMMENT_REACTION]: [
    "contentId",
    "contentName",
    "commentOwner",
    "commentId",
    "commentBody",
    "likerId",
    "likerName"
  ],
  [ENotificationRulesType.CUSTOM_NOTIFICATION]: userProfileVariables,
  [ENotificationRulesType.INACTIVITY]: cronVariables,
  [ENotificationRulesType.FIT_WELCOME]: userProfileVariables,
  [ENotificationRulesType.MAGIC_LINK_LOGIN]: [
    "magicLink",
    "expiresInMinutes",
    "email"
  ],
  [ENotificationRulesType.PASSWORD_CHANGE]: [
    "changedAt"
  ],
  // Community Hub Feed notifications
  [ENotificationRulesType.CH_NEW_POST]: [
    "postAuthorId",
    "postAuthorName",
    "spaceName"
  ],
  [ENotificationRulesType.CH_POST_COMMENT]: [
    "postId",
    "commenterId",
    "commenterName",
    "commentBody"
  ],
  [ENotificationRulesType.CH_POST_REACTION]: [
    "postId",
    "reactorId",
    "reactorName",
    "emoji"
  ],
  [ENotificationRulesType.CH_COMMENT_REPLY]: [
    "commentId",
    "replierId",
    "replierName",
    "replyBody"
  ],
  [ENotificationRulesType.CH_COMMENT_REACTION]: [
    "commentId",
    "reactorId",
    "reactorName",
    "emoji"
  ],
  [ENotificationRulesType.CH_MENTION]: [
    "mentionerId",
    "mentionerName",
    "targetType"
  ],
  [ENotificationRulesType.PASSWORD_RESET]: [
    "resetUrl",
    "expiresInMinutes",
    "username",
    "firstName",
    "lastName",
    "displayName",
    "name",
    "email"
  ]
};

// src/notification/rule/be-schema.ts
import { boolean as boolean8, number as number11, object as object24, string as string25 } from "zod";
var NotificationRuleSchemaBE = object24({
  id: number11().positive().int().min(1),
  name: string25().min(1),
  app: AppNameEnumObj,
  type: NotificationTypeEnumObject,
  conditionsJson: RuleConditionJsonSchemaBE,
  template: NotificationTemplateSchemaBE,
  workflowId: string25().min(1, "Workflow ID is required").describe("novu workflow identifier. (e.g post-purchase)"),
  channel: NotificationChannelEnumObject,
  isActive: boolean8().optional(),
  createdBy: number11().nullable(),
  updatedBy: number11().nullable(),
  createdAt: string25(),
  updatedAt: string25()
});

// src/notification/rule/be-request-schema.ts
import { coerce as coerce14 } from "zod";
var CreateNotificationRuleSchemaBE = NotificationRuleSchemaBE.pick({
  name: true,
  app: true,
  type: true,
  conditionsJson: true,
  workflowId: true,
  channel: true,
  isActive: true
}).extend({
  template: CreateTemplateSchema
});
var UpdateNotificationRuleSchemaBE = CreateNotificationRuleSchemaBE.extend({
  template: CreateTemplateSchema.extend({
    id: coerce14.number()
  })
});

// src/notification/user-management/get-users-request.ts
import { coerce as coerce15, object as object25, string as string26 } from "zod";
var GetNotificationUsersRequestBESchema = object25({
  tierInfo: coerce15.number().optional(),
  subscriptionsType: AppSpaceNameEnumObj.array(),
  limit: coerce15.number().max(100),
  page: coerce15.number(),
  query: string26().optional()
});

// src/notification/bulk-notification.ts
import { array as array4, boolean as boolean9, number as number12, object as object26, string as string27 } from "zod";
var CreateBulkNotificationSchema = object26({
  appName: AppNameEnumObj,
  tenantIdentifier: NovuTenantIdentifierEnumObject,
  selectAll: boolean9().optional(),
  userIds: array4(string27()).optional(),
  title: string27().min(1, "Title is required"),
  message: string27().min(1, "Message is required"),
  redirectUrl: string27().optional(),
  iconUrl: string27().url().optional()
});
var BulkNotificationBatchStatusSchema = object26({
  batchId: string27().uuid(),
  total: number12().int().nonnegative(),
  scheduled: number12().int().nonnegative(),
  pending: number12().int().nonnegative(),
  sent: number12().int().nonnegative(),
  failed: number12().int().nonnegative(),
  createdAt: string27().datetime().optional(),
  scheduledAt: string27().datetime().optional()
});
var CreateBulkNotificationResponseSchema = object26({
  batchId: string27().uuid(),
  logsCreated: number12().int().nonnegative()
});

// src/playlist/base.ts
import { coerce as coerce25, number as number17, object as object39, string as string36, z as z81 } from "zod";

// src/playlist/series-type.enum.ts
import { z as z59 } from "zod";
var SeriesTypeValues = [
  "collections",
  "mini-programs"
];
var SeriesTypeObj = z59.enum(SeriesTypeValues);
var SeriesTypeEnum = SeriesTypeObj.enum;

// src/fit/user-online/namespace.ts
var UserOnlineNamespace = "i-am-online";

// src/fit/user-online/response.ts
import { number as number14, object as object28 } from "zod";

// src/fit/user-online/user.ts
import { object as object27, string as string28, boolean as boolean10, lazy as lazy3, number as number13 } from "zod";
var UserOnlineLastWatchedContentSchema = BareContent.pick({
  id: true,
  name: true
}).extend({
  instructor: Instructor.pick({
    id: true,
    firstName: true,
    lastName: true
  }).nullable().optional()
});
var OnlineUserSchema = object27({
  id: string28(),
  avatarUrl: string28(),
  name: string28(),
  username: string28(),
  isPrivate: boolean10(),
  isActive: boolean10(),
  app: string28(),
  lastWatchedContent: lazy3(() => UserOnlineLastWatchedContentSchema.nullable().optional()),
  timestamp: number13()
});

// src/fit/user-online/response.ts
var OnlineUsersResponseSchema = object28({
  users: OnlineUserSchema.array(),
  meta: MetaSchema
});
var HeartbeatResponseSchema = object28({
  users: OnlineUserSchema.array(),
  totalUsers: number14(),
  disconnectTimeoutMs: number14()
});

// src/fit/user-online/topics.enum.ts
import { z as z60 } from "zod";
var UserOnlineTopicValues = [
  "JOIN",
  "USER_JOINED",
  "LEAVE",
  "GET_NEXT_PAGE_USERS",
  "GET_PREVIOUS_PAGE_USERS",
  "GET_INITIAL_PUBLIC_USERS",
  "GET_ALL_USERS",
  "REFRESH_USERS",
  "REFRESH_ONLINE_PUBLIC_USERS",
  "NEW_USER"
];
var UserOnlineTopicEnumObject = z60.enum(UserOnlineTopicValues);
var EUserOnlineTopicEnum = UserOnlineTopicEnumObject.enum;

// src/fit/user-online/pub-sub.ts
import { lazy as lazy4, z as z61 } from "zod";
var USER_ONLINE_REDIS_CHANNEL = "USER_ONLINE";
var UserOnlinePubSubValues = [
  "UPDATE_LAST_WATCHED_CONTENT"
];
var UserOnlinePubSubEnumObject = z61.enum(UserOnlinePubSubValues);
var EUserOnlinePubSub = UserOnlinePubSubEnumObject.enum;
var UpadateUserOnlineLastWatchedContentSchema = z61.object({
  type: z61.literal(EUserOnlinePubSub.UPDATE_LAST_WATCHED_CONTENT),
  userId: z61.string(),
  lastWatchedContent: lazy4(() => UserOnlineLastWatchedContentSchema)
});
var UserOnlinePubSubSchema = z61.discriminatedUnion("type", [
  UpadateUserOnlineLastWatchedContentSchema
]);
var UserOnlinePubSubSchemaStringifiedSchema = UserOnlinePubSubSchema.transform((data) => JSON.stringify(data));
var stringifyUserOnlinePubSubSchema = /* @__PURE__ */ __name((data) => {
  return UserOnlinePubSubSchemaStringifiedSchema.parse(data);
}, "stringifyUserOnlinePubSubSchema");

// src/fit/onboarding/step.enum.ts
import { z as z62 } from "zod";
var FitOnboardingStepValues = [
  "WELCOME",
  "MILESTONE_NAV"
];
var FitOnboardingStepEnumObject = z62.enum(FitOnboardingStepValues);
var EFitOnboardingStep = FitOnboardingStepEnumObject.enum;

// src/fit/onboarding/base.ts
import { coerce as coerce17, object as object30, string as string29 } from "zod";

// src/fit/onboarding/step.ts
import { coerce as coerce16, object as object29, z as z63 } from "zod";
var FitOnboardingStepSchema = object29({
  id: coerce16.number().int().positive(),
  name: FitOnboardingStepEnumObject,
  isCompleted: CoerceBoolean,
  updatedAt: coerce16.string().date()
});
var CreateFitOnboardingStepSchemaBE = FitOnboardingStepSchema.extend({
  isCompleted: z63.boolean()
});
var UpdateFitOnboardingStepSchemaBE = object29({
  step: FitOnboardingStepEnumObject,
  timezone: z63.string().optional()
});

// src/fit/onboarding/base.ts
var FitOnboardingProgressSchema = object30({
  onboarding: FitOnboardingStepSchema.array(),
  tour: FitOnboardingStepSchema.array()
});
var BaseFitOnboardingSchema = object30({
  id: coerce17.number(),
  progress: FitOnboardingProgressSchema,
  userId: string29(),
  createdAt: coerce17.string().date(),
  updatedAt: coerce17.string().date()
});

// src/fit/onboarding/be-schema.ts
var CreateFitOnboardingSchemaBE = CreateFitOnboardingStepSchemaBE.array();

// src/fit/challenge/base.ts
import { z as z68 } from "zod";

// src/fit/challenge/maintained-by.ts
import { z as z64 } from "zod";
var FitChallengeMaintainedBySchema = z64.record(z64.string().datetime(), z64.string());

// src/fit/challenge-content/base.ts
import { z as z67 } from "zod";

// src/fit/challenge-content/type.enum.ts
import { z as z65 } from "zod";
var FitChallengeContentTypeValues = [
  "event",
  "content"
];
var FitChallengeContentTypeEnumObject = z65.enum(FitChallengeContentTypeValues);
var EFitChallengeContentType = FitChallengeContentTypeEnumObject.enum;

// src/fit/content/schema.ts
import { array as array5, boolean as boolean11, object as object31, string as string30, union as union3, z as z66, coerce as coerce18, lazy as lazy5 } from "zod";
var FITCommonContentFields = object31({
  id: string30(),
  name: string30().min(3, "name is required"),
  category: CategoryEnumObj,
  instructor: Instructor,
  watchedDate: coerce18.string().optional(),
  createdAt: coerce18.date(),
  updatedAt: coerce18.date()
});
var FITBareContent = FITCommonContentFields.extend({
  type: lazy5(() => ContentTypeEnumObj),
  status: StatusEnumObj,
  video: VimeoVideo,
  isAllowComment: coerce18.boolean().default(false),
  equipments: lazy5(() => Equipment.array()),
  publishedDate: z66.union([
    z66.string(),
    z66.date(),
    CustomLuxonDateSchema
  ]),
  averageRating: lazy5(() => RatingIndicator),
  isNew: coerce18.boolean().default(false).optional(),
  favorite: coerce18.boolean().default(false).optional(),
  instructorId: string30(),
  // this is needed for for react rendering. id is not unique in watch history response.
  uniqueId: string30().optional()
});
var FITContent = FITBareContent.extend({
  parentPlaylistsIds: string30().array().default([]).optional(),
  userHasLeftRating: coerce18.boolean().default(false).optional(),
  instructor: Instructor
});
var FITTrashContentSchema = FITCommonContentFields.extend({
  status: z66.literal(StatusEnum.TRASH),
  video: lazy5(() => TrashContentVimeoVideo)
});
var FITContentWithRatingFlagSchema = FITContent.extend({
  createdAt: coerce18.date(),
  updatedAt: coerce18.date(),
  publishedDate: z66.union([
    z66.string(),
    z66.date()
  ]).optional().nullable(),
  instructor: Instructor.extend({
    id: z66.union([
      coerce18.string(),
      coerce18.number()
    ]),
    createdAt: coerce18.date(),
    updatedAt: coerce18.date()
  }),
  userHasLeftRating: coerce18.boolean()
});
var FITContentFindAllResponseSchema = object31({
  items: FITContentWithRatingFlagSchema.array(),
  meta: object31({
    page: coerce18.number(),
    perPage: coerce18.number(),
    total: coerce18.number(),
    totalPages: coerce18.number()
  })
});
var FITContentAndTrashContentUnion = z66.union([
  FITContent,
  FITTrashContentSchema
]);
var FITContentWithWatchedDate = FITContent.extend({
  watchedDate: string30().or(CustomLuxonDateSchema)
});
var FITContentByDate = object31({
  id: string30(),
  activeOn: string30(),
  createdAt: coerce18.date(),
  updatedAt: coerce18.date(),
  content: FITContent
});
var FITContentResponseSchema = object31({
  items: FITContent.array().nullable(),
  // Computed from the requesting user's profile/subscription so the client can
  // lock cards straight from this response — no separate permissions request.
  hasAccess: boolean11().optional(),
  meta: object31({
    total: coerce18.number(),
    page: coerce18.number(),
    perPage: coerce18.number(),
    totalPages: coerce18.number()
  })
});
var FITContentByDateResponseSchema = object31({
  items: union3([
    array5(FITContentByDate),
    z66.null()
  ]),
  meta: object31({
    startDate: string30(),
    endDate: string30()
  })
});
var FITDateRangeQuerySchema = object31({
  startDate: string30().nullable(),
  endDate: string30().nullable(),
  page: coerce18.number().optional()
});
var FITUserContentRatingResponse = array5(RatingIndicator);
var FITWatchedStatusEnumValues = [
  "WATCHED",
  "UNWATCHED",
  "ALL"
];
var FITWatchedStatusEnumObj = z66.enum(FITWatchedStatusEnumValues);
var FITWatchedFilterEnum = FITWatchedStatusEnumObj.enum;

// src/fit/challenge-content/base.ts
var BaseFitChallengeContentSchema = z67.object({
  id: z67.number().int().positive(),
  contentId: z67.string().max(36),
  type: FitChallengeContentTypeEnumObject,
  dayIndex: z67.number().int().min(1),
  createdAt: z67.date(),
  updatedAt: z67.date(),
  content: z67.lazy(() => FITContent.passthrough()).optional(),
  event: z67.lazy(() => BaseEventSchema.passthrough()).optional()
});

// src/fit/challenge/base.ts
var BaseFitChallengeSchema = z68.object({
  id: z68.number().int().positive(),
  title: z68.string().max(255),
  description: z68.string().max(255).nullable().optional(),
  isActive: z68.boolean(),
  startDate: z68.string().datetime(),
  createdAt: z68.string(),
  updatedAt: z68.string(),
  maintainedBy: FitChallengeMaintainedBySchema,
  contents: z68.lazy(() => z68.array(BaseFitChallengeContentSchema.passthrough()).optional()),
  isChallengeRunning: z68.boolean().optional().transform((value) => value != null ? value : false),
  isChallengeFinished: z68.boolean().optional().transform((value) => value != null ? value : false),
  isChallengeStarted: z68.boolean().optional().transform((value) => value != null ? value : false),
  bufferDays: z68.number().int().optional(),
  isWithinOfficialChallengeDates: z68.boolean().optional().transform((value) => value != null ? value : false)
});

// src/fit/challenge/status.ts
import { boolean as boolean12, object as object32 } from "zod";
var ChallengeCompletionStatusSchema = object32({
  earnedDailyDedication: boolean12().describe("Given if daily dedication badge is already earned!"),
  earnedChallengeChampion: boolean12().describe("Given if challenge champion badge is already earned!"),
  canEarnDailyDedication: boolean12().describe("Given if all day badges are earned!"),
  canEarnChallengeChampion: boolean12().describe("Given if all video badges are earned!")
}).strict();

// src/fit/community-updates/namespace.ts
var CommunityUpdatesNamespace = "community-updates";
var COMMUNITY_UPDATES_MAX_ITEMS = 5;

// src/fit/community-updates/activity.ts
import { z as z69 } from "zod";
var CommunityActivityTypeEnum = {
  COMMENT: "COMMENT",
  REACTION: "REACTION"
};
var CommunityUpdatesEventPattern = {
  ADD_ACTIVITY: "community-updates.add",
  REMOVE_ACTIVITY: "community-updates.remove"
};
var CommunityActivitySchema = z69.object({
  id: z69.string(),
  type: z69.enum([
    CommunityActivityTypeEnum.COMMENT,
    CommunityActivityTypeEnum.REACTION
  ]),
  contentId: z69.string(),
  contentName: z69.string(),
  contentCategory: CategoryEnumObj,
  instructorName: z69.string(),
  parentPlaylistsIds: z69.array(z69.string()).default([]),
  user: z69.object({
    id: z69.string(),
    name: z69.string(),
    avatarUrl: z69.string().nullable().optional()
  }),
  commentText: z69.string().nullable().optional(),
  hasRating: z69.boolean(),
  createdAt: z69.string()
});
var CommunityActivityResponseSchema = z69.object({
  activities: z69.array(CommunityActivitySchema)
});

// src/fit/content/fe-schema.ts
import { coerce as coerce19, lazy as lazy6, z as z70 } from "zod";
var CreateContentBasicSchemaFE = FITContent.omit({
  id: true,
  video: true,
  instructor: true,
  createdAt: true,
  updatedAt: true,
  isNew: true,
  status: true
}).extend({
  instructorId: coerce19.string(),
  equipments: coerce19.number().array().min(1, "Please select at least one equipment"),
  isAllowComment: coerce19.boolean().default(false),
  status: lazy6(() => StatusEnumObj),
  publishedDate: z70.string().or(CustomLuxonDateSchema).optional()
});
var CreateContentVideoSchemaFE = FITContent.pick({
  video: true
});
var CreateContentSchemaFE = CreateContentBasicSchemaFE.omit({
  averageRating: true
}).merge(CreateContentVideoSchemaFE).refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var CreateContentSchemaFEWithoutValidation = CreateContentBasicSchemaFE.omit({
  averageRating: true
}).merge(CreateContentVideoSchemaFE);
var UpdateContentSchemaFE = CreateContentSchemaFEWithoutValidation.partial();
var FITDashboardUpdateContentSchemaFE = UpdateContentSchemaFE;
var FITDashboardCreateContentSchemaFEWithoutValidation = CreateContentSchemaFEWithoutValidation;
var FITDashboardCreateContentSchemaFE = CreateContentSchemaFE;
var defaultContentSchemaValues = {
  video: {
    bannerUrl2x: "",
    description: "",
    duration: 0,
    jwVideoUrl: "",
    provider: "VIMEO",
    vimeoVideoId: ""
  },
  name: "",
  instructorId: "",
  equipments: [],
  isAllowComment: false,
  type: "VIDEO",
  favorite: false,
  category: "STRENGTH",
  status: "PUBLISHED",
  publishedDate: void 0
};

// src/fit/content/be-schema.ts
import { coerce as coerce20, lazy as lazy7, object as object33, string as string31, z as z71 } from "zod";
var CreateContentSchemaBEBase = CreateContentSchemaFEWithoutValidation.extend({
  category: lazy7(() => CategoryEnumObj),
  app: AppNameEnumObj,
  equipments: object33({
    id: coerce20.number().min(1, "id is required")
  }).array().min(1, "Please select at least one equipment"),
  video: VimeoVideo.extend({
    duration: coerce20.number().min(1, "duration is required")
  }),
  publishedDate: z71.string().or(CustomLuxonDateSchema).optional().nullable(),
  id: string31().optional(),
  instructorId: string31().optional()
});
var CreateContentSchemaBE = CreateContentSchemaBEBase.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var UpdateContentSchemaBE = CreateContentSchemaBEBase.partial();

// src/fit/content/complete-content-action.enum.ts
import { z as z72 } from "zod";
var CompleteContentActionValues = [
  "1min_before_finish",
  "2min_watch",
  "5min_watch"
];
var CompleteContentActionEnumObject = z72.enum(CompleteContentActionValues);
var ECompleteContentAction = CompleteContentActionEnumObject.enum;

// src/fit/content/complete-content.request.ts
import { object as object38, string as string35 } from "zod";

// src/tracking/user-log/action.enum.ts
import { z as z73 } from "zod";
var UserLogActionValues = [
  "CHECKIN",
  "WATCH_COMPLETE",
  "ATTENDING_LIVE",
  "PURCHASE",
  "PURCHASE_FAILED",
  "PURCHASE_CANCELLED",
  "PURCHASE_REFUND",
  "PURCHASE_PROCESSING",
  "PURCHASE_PENDING",
  "PURCHASE_ON_HOLD",
  "PURCHASE_PROCESSING",
  "VIDEO_PLAY",
  "PURCHASE_PENDING_CANCEL",
  "PURCHASE_EXPIRED",
  // Community hub — navigation
  "LESSON_VIEW",
  "MODULE_VIEW",
  "SPACE_VIEW",
  "COMMUNITY_VIEW",
  // Community hub — content block views
  "VIDEO_VIEW",
  "PDF_VIEW",
  "QUIZ_VIEW",
  "EMBED_VIEW",
  "FORM_VIEW",
  "GCS_UPLOAD_VIEW",
  "TEXT_VIEW",
  // Community hub — video lifecycle
  "VIDEO_COMPLETE",
  "VIDEO_PROGRESS_25",
  "VIDEO_PROGRESS_50",
  "VIDEO_PROGRESS_75",
  // Community hub — form submission states
  "FORM_SUBMISSION_IN_PROGRESS",
  "FORM_SUBMITTED",
  // Community hub — GCS upload status transitions
  "GCS_UPLOAD_STARTED",
  "GCS_UPLOAD_IN_BUCKET",
  "GCS_UPLOAD_IN_DRIVE",
  "GCS_UPLOAD_FAILED",
  // Community hub — social feed
  "POST_VIEW",
  "POST_CREATE",
  "COMMENT_CREATE",
  "REACTION_ADD"
];
var UserLogActionEnumObj = z73.enum(UserLogActionValues);
var EUserLogActionEnum = UserLogActionEnumObj.enum;

// src/tracking/user-log/base.ts
import { coerce as coerce21, object as object34, string as string32, z as z74 } from "zod";
var UserLogBaseSchema = object34({
  id: coerce21.number().min(1, "id is required"),
  action: UserLogActionEnumObj,
  // Optional at the base level: purchase rows carry no app name (they have
  // productId instead). Non-purchase writes tighten this to required via
  // CreateUserLogSchemaBE.
  appName: string32().min(1).optional(),
  appTrackingId: string32().nullable().optional(),
  productId: string32().nullable().optional(),
  contentId: string32().min(1, "content id is required").nullable().optional(),
  contentTitle: string32().min(1, "content title is required").nullable().optional(),
  createdAt: string32().or(CustomLuxonDateSchema).or(z74.instanceof(Date)),
  ipAddress: string32().min(1, "ip address is required").nullable().optional(),
  userId: string32().min(1, "user id is required"),
  meta: z74.record(z74.any()).nullable().optional(),
  skipAddWatchPoint: z74.boolean().optional()
});
var UserLogBaseSchemaWithFullContent = UserLogBaseSchema.extend({
  content: Content
});

// src/tracking/user-log/be-schema.ts
import { coerce as coerce23, z as z78 } from "zod";

// src/emailer/be-schema.ts
import { coerce as coerce22, number as number15, object as object35, string as string33, z as z76 } from "zod";

// src/emailer/send-reason.enum.ts
import { z as z75 } from "zod";
var EmailSentReasonValues = [
  "COMPLETED_STEP_5",
  "COMPLETED_STEP_6_DAY_2",
  "COMPLETED_STEP_8",
  "COMPLETED_STEP_9_DAY_2",
  "COMPLETED_STEP_2",
  "COMPLETED_STEP_3_DAY_2",
  "IMMEDIATELY_AFTER_PURCHASE",
  "THREE_DAYS_AFTER_PURCHASE",
  "EIGHT_DAYS_AFTER_PURCHASE",
  "FIFTEEN_DAYS_AFTER_PURCHASE",
  "TWENTY_FIVE_DAYS_AFTER_PURCHASE",
  "NINE_DAYS_AFTER_PURCHASE_WITH_SEVEN_DAYS_LOGIN",
  "FIFTEEN_DAYS_AFTER_PURCHASE_WITH_THIRTEEN_DAYS_LOGIN",
  "DID_NOT_TRY_PROGRAM_AFTER_SEVEN_DAYS",
  "THIRTEEN_DAYS_AFTER_PURCHASE",
  "DID_NOT_TRY_PROGRAM_AFTER_FOURTEEN_DAYS",
  "DID_NOT_TRY_PROGRAM_AFTER_TWENTY_FOUR_DAYS",
  "NOT_LOGGED_IN_FOR_SEVEN_DAYS",
  "NOT_LOGGED_IN_FOR_FOURTEEN_DAYS",
  "THIRTY_DAYS_AFTER_PURCHASE_NO_LOGIN",
  "PURCHASE_OVER_EIGHT_DAYS_LOGIN_SIX_DAYS"
];
var EmailSendReasonObj = z75.enum(EmailSentReasonValues);
var EEmailSentReason = EmailSendReasonObj.enum;

// src/emailer/be-schema.ts
var SendEmailSchema = object35({
  email: string33().email(),
  emailType: EmailSendReasonObj,
  context: object35({
    name: string33(),
    userId: coerce22.string(),
    tier: number15()
  })
});
var EmailMetaSchema = object35({
  email: string33().email(),
  body: string33(),
  context: object35({
    name: string33(),
    userId: coerce22.string(),
    subject: string33()
  })
});
var SendStepAndDayCompletionSchema = object35({
  email: string33().email(),
  name: string33(),
  step: number15(),
  day: number15()
});
var EImmediateAfterPurchaseSchema = SendEmailSchema.omit({
  emailType: true
});
var SendTransactionalEmailSchema = object35({
  to: string33().email(),
  ruleName: string33(),
  context: z76.record(string33(), string33()),
  userId: string33().optional()
});

// src/emailer/send-email-response.ts
import { boolean as boolean13, number as number16, object as object36, string as string34 } from "zod";
var EmailReturnResponse = object36({
  to: string34().email(),
  subject: string34(),
  body: string34(),
  status: string34(),
  persistInDb: boolean13()
});
var EmailResponse = object36({
  accepted: string34().array(),
  rejected: string34().array(),
  ehlo: string34().array(),
  envelopeTime: number16(),
  messageTime: number16(),
  messageSize: number16(),
  response: string34(),
  envelope: object36({
    from: string34(),
    to: string34().array()
  }),
  messageId: string34()
});

// src/emailer/email-status.enum.ts
import { z as z77 } from "zod";
var EmailSentStatusValues = [
  "COMPLETED",
  "SCHEDULED",
  "FAILED"
];
var EmailSentStatusObj = z77.enum(EmailSentStatusValues);
var EEmailSentStatus = EmailSentStatusObj.enum;

// src/tracking/user-log/be-schema.ts
var PurchaseProductSchema = z78.object({
  product_id: z78.number().int(),
  variation_id: z78.number().int().nullable().optional(),
  subscription_id: z78.number().int().nullable().optional(),
  product_name: z78.string().optional(),
  tier: z78.number().optional(),
  price: z78.number().optional(),
  quantity: z78.number().int().optional()
});
var CreateUserLogSchemaBE = UserLogBaseSchema.omit({
  id: true,
  createdAt: true
}).extend({
  appName: z78.string().min(1, "app name is required")
});
var CreatePurchaseLogSchemaBE = UserLogBaseSchema.omit({
  id: true,
  createdAt: true,
  action: true,
  contentId: true,
  appName: true
}).extend({
  email: z78.string().email("Invalid email format")
});
var UserDayChangeSchemaBe = z78.object({
  email: z78.string().email(),
  eventType: EmailSendReasonObj,
  appName: AppNameEnumObj,
  tier: z78.number(),
  userId: z78.string().min(1, "user id is required"),
  name: z78.string().min(1, "name is required")
});
var AfterPurchaseRequestDtoBe = z78.object({
  appName: z78.string().optional(),
  productId: z78.string().optional(),
  userId: z78.string().min(1, "user id is required"),
  name: z78.string().min(1, "name is required"),
  action: UserLogActionEnumObj,
  // Purchase identifiers live inside `meta` — they're stored in the
  // `meta_information` jsonb column on user_log, not as first-class columns.
  // `.passthrough()` keeps other keys (email, tier, wpUserId, etc.) intact.
  meta: z78.object({
    orderId: z78.number().int().nullable().optional(),
    subscriptionId: z78.number().int().nullable().optional(),
    status: z78.string().max(30).nullable().optional(),
    tier: TiersEnumObject.optional(),
    email: z78.string().email().optional(),
    wpUserId: z78.string().optional(),
    product: PurchaseProductSchema.optional()
  }).passthrough().optional()
});
var UserLogFilterDtoBe = z78.object({
  page: coerce23.number(),
  perPage: coerce23.number().max(150),
  userId: z78.string().min(1, "user id is required"),
  appName: AppNameEnumObj,
  actions: UserLogActionEnumObj.array().optional()
});
var FindOneUserLogSchemaBe = z78.object({
  userId: z78.string().min(1)
});
var GetEventAttendeesSchemaBe = z78.string().min(1);
var FindUserLogSchemaBe = z78.object({
  userId: z78.string().optional(),
  appName: z78.string(),
  perPage: coerce23.number().optional(),
  page: coerce23.number().optional(),
  period: z78.string().optional(),
  date: z78.string().optional(),
  month: z78.string().optional(),
  contentIds: z78.array(z78.string()).optional(),
  action: z78.array(UserLogActionEnumObj)
});
var UserCheckInSchemaBe = z78.object({
  appName: z78.string(),
  userId: z78.string(),
  page: z78.number(),
  perPage: z78.number()
});
var UserLastCheckInSchemaBe = z78.object({
  userId: z78.string(),
  appName: z78.string()
});

// src/tracking/user-log/purchase-request.ts
import { z as z79 } from "zod";
var PurchaseStatusValues = [
  "active",
  "expired",
  "cancelled",
  "completed",
  "failed",
  "refunded",
  "processing",
  "on-hold",
  "pending",
  "pending-cancel"
];
var PurchaseStatusEnum = z79.enum(PurchaseStatusValues);
var EPurchaseStatusEnum = PurchaseStatusEnum.enum;
var PurchaseRequestSchema = z79.object({
  appName: AppNameEnumObj.optional(),
  productId: z79.string().min(1, "product id is required"),
  userId: z79.string().min(1, "user id is required"),
  name: z79.string().min(1, "name is required"),
  email: z79.string().email("Invalid email format"),
  status: PurchaseStatusEnum,
  meta: z79.record(z79.any()).optional()
});

// src/tracking/watch-history/base.ts
import { coerce as coerce24, object as object37 } from "zod";
var WatchHistoryBaseSchema = object37({
  id: coerce24.number(),
  userId: coerce24.string().min(1, "user id is required"),
  contentId: coerce24.string().min(1, "content id is required"),
  createdAt: coerce24.string().or(CustomLuxonDateSchema)
});

// src/tracking/watch-history/be-schema.ts
import { z as z80 } from "zod";
var CreateWatchHistoryBeSchema = WatchHistoryBaseSchema.omit({
  id: true,
  createdAt: true
}).extend({
  email: z80.string().email("Invalid email format").optional()
});
var UpdateWatchHistoryBeSchema = CreateWatchHistoryBeSchema.partial();
var GetActivityDatesByMonthBeSchema = z80.object({
  appName: AppNameEnumObj,
  userId: z80.string(),
  timezone: z80.string(),
  month: z80.number(),
  year: z80.number()
});
var FindAllWatchHistoryBeSchema = z80.object({
  userId: z80.string().optional(),
  appName: z80.string(),
  perPage: z80.coerce.number().optional(),
  page: z80.coerce.number().optional(),
  period: z80.string().optional(),
  date: z80.string().optional(),
  month: z80.string().optional(),
  contentIds: z80.array(z80.string()).optional()
});
var FindAllByContentIdBeSchema = z80.object({
  contentId: z80.string().min(1),
  appName: z80.string().min(1),
  perPage: z80.coerce.number().optional(),
  page: z80.coerce.number().optional()
});
var FindOneWatchHistoryBeSchema = z80.object({
  id: z80.number().optional(),
  userId: z80.string().optional(),
  contentId: z80.string().optional(),
  appName: z80.string().min(1)
}).refine((data) => data.id !== void 0 || data.userId !== void 0 && data.contentId !== void 0, {
  message: "Either id or both userId and contentId must be provided"
});
var DeleteWatchHistoryBeSchema = z80.object({
  userId: z80.string(),
  appName: z80.string()
});

// src/fit/content/complete-content.request.ts
var CompleteContentRequestSchema = object38({
  contentId: string35(),
  action: UserLogActionEnumObj,
  app: AppSpaceNameEnumObj
});

// src/playlist/base.ts
var PlaylistStatusEnumValues = [
  "ACTIVE",
  "DELETED"
];
var PlaylistStatusEnumObj = z81.enum(PlaylistStatusEnumValues);
var PlaylistStatusEnum = PlaylistStatusEnumObj.enum;
var PlaylistItem = object39({
  id: number17(),
  order: number17().int().positive(),
  content: FITContent
});
var PlaylistItemReorder = object39({
  id: number17().optional(),
  order: number17().int().positive(),
  content: object39({
    id: string36()
  })
});
var Playlist = object39({
  id: coerce25.string(),
  name: string36(),
  description: string36().nullable().default(""),
  imageUrl: coerce25.string().optional(),
  imageUrl2x: coerce25.string().optional(),
  classCount: coerce25.number().default(0).optional(),
  isFavorite: coerce25.boolean(),
  seriesType: z81.preprocess((val) => val === "" ? null : val, SeriesTypeObj.nullable().default(null)),
  status: PlaylistStatusEnumObj,
  items: PlaylistItem.array(),
  startButtonText: string36().optional().nullable(),
  createdAt: coerce25.string(),
  updatedAt: coerce25.string()
});
var PlaylistFormSchema = Playlist.omit({
  status: true,
  items: true,
  seriesType: true,
  createdAt: true,
  updatedAt: true
});
var CreatePlaylistSchema = Playlist.omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
var UpdatePlaylistSchema = Playlist.partial().omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  items: true
});
var PlaylistResponseSchema = object39({
  items: Playlist
});
var PlaylistsResponseSchema = object39({
  items: Playlist.array(),
  meta: object39({
    total: z81.number().int().nonnegative(),
    page: z81.number().int().positive(),
    perPage: z81.number().int().positive(),
    totalPages: z81.number().int().nonnegative()
  })
});

// src/playlist/requests.schema.ts
import { object as object40, string as string37, coerce as coerce26, number as number18 } from "zod";
var Name = string37().min(1).max(100).trim();
var userId = coerce26.string();
var playlistId = coerce26.number().int().positive();
var id = coerce26.number().int().positive();
var CreatePlaylistRequestSchema = object40({
  name: Name,
  contentId: coerce26.string().optional()
});
var CreatePlaylistBeRequestSchema = CreatePlaylistRequestSchema.extend({
  userId
});
var UpdatePlaylistRequestSchema = object40({
  playlistId,
  name: Name.optional()
});
var ReorderPlaylistRequestSchema = object40({
  items: object40({
    id: number18(),
    order: number18(),
    content: object40({
      id: string37()
    })
  }).array(),
  id
});
var UpdatePlaylistBeRequestSchema = UpdatePlaylistRequestSchema.extend({
  userId
});
var ReorderPlaylistRequestSchemaBE = ReorderPlaylistRequestSchema.extend({
  userId
});
var InsertContentInPlaylistRequestSchema = object40({
  playlistId: playlistId.min(1),
  contentId: string37()
});
var DeleteContentFromPlaylistRequestSchema = object40({
  playlistId: playlistId.min(1),
  itemId: id.min(1)
});
var MovePlaylistContentRequestSchema = object40({
  currentPlaylistId: playlistId.min(1),
  newPlaylistId: playlistId.min(1),
  itemId: id.min(1)
});
var MovePlaylistContentRequestSchemaBE = MovePlaylistContentRequestSchema.extend({
  userId: userId.min(1)
});
var DeleteContentFromPlaylistBeRequestSchema = DeleteContentFromPlaylistRequestSchema.extend({
  userId
});
var InsertContentInPlaylistBeRequestSchema = InsertContentInPlaylistRequestSchema.extend({
  userId
});
var GetFavoriteContentBeRequestSchema = RequestSchema.omit({
  isHidden: true
}).extend({
  userId: string37()
});
var GetPlaylistsRequestSchema = object40({
  page: coerce26.number().int().positive().optional(),
  perPage: coerce26.number().int().positive().max(100).optional()
});
var GetPlaylistsBeRequestSchema = GetPlaylistsRequestSchema.extend({
  userId
});
var GetSinglePlaylistRequestSchema = object40({
  playlistId
});
var GetSinglePlaylistBeRequestSchema = GetSinglePlaylistRequestSchema.extend({
  userId
});
var RemovePlaylistRequestSchema = object40({
  playlistId
});
var RemovePlaylistBeRequestSchema = RemovePlaylistRequestSchema.extend({
  userId
});

// src/playlist/playlist-type.enum.ts
import { z as z82 } from "zod";
var PlaylistTypeValues = [
  "playlist",
  "series"
];
var PlaylistTypeObj = z82.enum(PlaylistTypeValues);
var PlaylistTypeEnum = PlaylistTypeObj.enum;

// src/playlist/settings.schema.ts
import { object as object41, string as string38 } from "zod";
var PlaylistSettingsSchema = object41({
  resourceBtnLabel: string38(),
  resourceBtnUrl: string38().url(),
  resourceBtnLabel2: string38().optional(),
  resourceBtnUrl2: string38().url().optional(),
  resourceBtnLabel3: string38().optional(),
  resourceBtnUrl3: string38().url().optional()
});

// src/roles/index.ts
import { z as z83 } from "zod";
var RoleValues = [
  "instructor",
  "administrator",
  "kit_organizer"
];
var RolesEnumObj = z83.enum(RoleValues);
var ERolesEnum = RolesEnumObj.enum;
var MANAGEMENT_ROLES = [
  ERolesEnum.administrator,
  ERolesEnum.kit_organizer
];

// src/series/base.ts
import { number as number19, object as object42, string as string39, z as z84, array as array6, coerce as coerce27 } from "zod";
var Series = object42({
  id: coerce27.string(),
  classCount: number19().default(0).optional(),
  isFavorite: coerce27.boolean(),
  name: string39(),
  description: string39().nullable().default(""),
  imageUrl: coerce27.string().optional(),
  imageUrl2x: coerce27.string().optional(),
  isHidden: coerce27.boolean().default(false).optional(),
  settings: PlaylistSettingsSchema.optional(),
  seriesType: z84.preprocess((val) => val === "" ? null : val, SeriesTypeObj.nullable().default(null)),
  // publishDate: string(),
  order: coerce27.number().optional().nullable(),
  startButtonText: string39().optional().nullable()
});
var SingleSeries = Series.extend({
  contents: array6(FITContent)
});
var SeriesResponseSchema = Series.extend({
  items: PlaylistItem.array()
});

// src/series/fe-schema.ts
import { array as array7, string as string40 } from "zod";
var CreateSeriesSchemaFE = Series.omit({
  id: true,
  isFavorite: true,
  classCount: true,
  imageUrl: true,
  imageUrl2x: true,
  settings: true
}).extend({
  imageUrl: string40().url(),
  imageUrl2x: string40().url().optional(),
  items: array7(PlaylistItem),
  resourceBtnLabel: string40().optional(),
  resourceBtnUrl: string40().optional(),
  resourceBtnLabel2: string40().optional(),
  resourceBtnUrl2: string40().optional(),
  resourceBtnLabel3: string40().optional(),
  resourceBtnUrl3: string40().optional()
});
var defaultSeriesSchemaValues = {
  name: "",
  imageUrl: "",
  imageUrl2x: "",
  description: "",
  isHidden: false,
  seriesType: null,
  items: [],
  resourceBtnLabel: "",
  resourceBtnUrl: "",
  resourceBtnLabel2: "",
  resourceBtnUrl2: "",
  resourceBtnLabel3: "",
  resourceBtnUrl3: "",
  startButtonText: null
};

// src/series/be-schema.ts
import { coerce as coerce28, z as z85 } from "zod";
var CreateSeriesSchemaBE = CreateSeriesSchemaFE.extend({
  items: PlaylistItemReorder.array()
});
var CreateSeriesRequestSchemaBE = CreateSeriesSchemaBE.extend({
  userId: coerce28.string()
});
var SeriesItemsRequestSchemaFE = z85.object({
  id: coerce28.number().int().positive(),
  items: PlaylistItemReorder.array()
});
var UpdateSeriesRequestSchemaFE = CreateSeriesSchemaFE.merge(SeriesItemsRequestSchemaFE);
var UpdateAddonSeriesRequestSchemaFE = UpdateSeriesRequestSchemaFE.omit({
  seriesType: true
});

// src/fit/slideshow/base.ts
import { coerce as coerce30, never as never2, object as object45, string as string43 } from "zod";

// src/fit/slideshow/enums/type.ts
import { z as z86 } from "zod";
var SlideshowTypeValues = [
  "content",
  "event",
  "series",
  "regular",
  "video"
];
var SlideshowTypeEnumObj = z86.enum(SlideshowTypeValues);
var ESlideshowTypeEnum = SlideshowTypeEnumObj.enum;

// src/fit/slideshow/enums/app.ts
import { z as z87 } from "zod";
var SlideshowAppValues = [
  "fit"
];
var SlideshowAppEnumObj = z87.enum(SlideshowAppValues);
var ESlideshowAppEnum = SlideshowAppEnumObj.enum;

// src/fit/slideshow/union.ts
import { lazy as lazy8, literal, never, object as object43, string as string41, z as z88 } from "zod";
var NeverSchema = never().optional().nullable();
var ImageSchema = string41().url().min(1, "image url is required");
var ButtonLabelSchema = string41().min(3, "button label is required");
var ButtonUrlSchema = string41().url().min(1, "button url is required");
var BaseDiscriminatedUnion = z88.discriminatedUnion("type", [
  object43({
    type: literal(ESlideshowTypeEnum.event),
    content: NeverSchema,
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    series: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    event: lazy8(() => BaseEventSchema)
  }),
  object43({
    type: literal(ESlideshowTypeEnum.content),
    event: NeverSchema,
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    series: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    content: lazy8(() => FITContent)
  }),
  object43({
    type: literal(ESlideshowTypeEnum.series),
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    series: lazy8(() => Playlist)
  }),
  object43({
    type: literal(ESlideshowTypeEnum.regular),
    series: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    buttonLabel: ButtonLabelSchema,
    buttonUrl: ButtonUrlSchema
  }),
  object43({
    type: literal(ESlideshowTypeEnum.video),
    series: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    vimeoVideoId: string41().min(1, "vimeo video id is required"),
    image: string41().optional().nullable(),
    buttonLabel: string41().optional().nullable(),
    buttonUrl: string41().url().optional().nullable()
  })
]);
var FEDiscriminatedUnion = z88.discriminatedUnion("type", [
  object43({
    type: literal(ESlideshowTypeEnum.event),
    content: NeverSchema,
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    series: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    event: object43({
      id: string41().min(1, "event id is required")
    })
  }),
  object43({
    type: literal(ESlideshowTypeEnum.content),
    event: NeverSchema,
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    series: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    content: object43({
      id: string41().min(1, "content id is required")
    })
  }),
  object43({
    type: literal(ESlideshowTypeEnum.series),
    event: NeverSchema,
    content: NeverSchema,
    buttonUrl: NeverSchema,
    buttonLabel: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    series: lazy8(() => PlaylistFormSchema)
  }),
  object43({
    type: literal(ESlideshowTypeEnum.regular),
    series: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    buttonLabel: ButtonLabelSchema,
    buttonUrl: ButtonUrlSchema
  }),
  object43({
    type: literal(ESlideshowTypeEnum.video),
    series: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    image: string41().optional().nullable(),
    buttonLabel: string41().optional().nullable(),
    buttonUrl: ButtonUrlSchema.optional().nullable(),
    vimeoVideoId: string41().min(1, "vimeo video id is required")
  })
]);

// src/fit/slideshow/badge.ts
import { object as object44, string as string42, z as z89, coerce as coerce29 } from "zod";
var SlideBadgeImagePositionValues = [
  "top-left",
  "top-right",
  "top-center",
  "bottom-left",
  "bottom-right",
  "bottom-center",
  "center"
];
var SlideBadgeImagePositionEnumObj = z89.enum(SlideBadgeImagePositionValues);
var ESlideBadgeImagePositionEnum = SlideBadgeImagePositionEnumObj.enum;
var SlideBadgeDeviceSizesSchema = object44({
  mobile: coerce29.number().min(20, "Size must be at least 20").max(300, "Size must be at most 300"),
  tablet: coerce29.number().min(20, "Size must be at least 20").max(300, "Size must be at most 300"),
  desktop: coerce29.number().min(20, "Size must be at least 20").max(300, "Size must be at most 300")
});
var SlideBadgeDevicePositionsSchema = object44({
  mobile: SlideBadgeImagePositionEnumObj.optional().nullable(),
  tablet: SlideBadgeImagePositionEnumObj.optional().nullable(),
  desktop: SlideBadgeImagePositionEnumObj.optional().nullable()
});
var SlideBadgeSchema = object44({
  image: string42().optional().nullable(),
  positions: SlideBadgeDevicePositionsSchema.optional().nullable(),
  sizes: SlideBadgeDeviceSizesSchema.optional()
});

// src/fit/slideshow/base.ts
var EventContentSchema = object45({
  event: never2().optional(),
  content: never2().optional()
});
var FromToDateSchema = object45({
  fromDate: coerce30.string().date().or(CustomLuxonDateSchema).or(string43()),
  toDate: coerce30.string().date().or(CustomLuxonDateSchema).or(string43())
});
var FromToDateNeverSchema = FromToDateSchema.extend({
  fromDate: never2().nullable().optional(),
  toDate: never2().nullable().optional()
});
var FromToDateORSchema = FromToDateSchema.or(FromToDateNeverSchema);
var BaseSlideshowSchemaWithoutUnion = object45({
  id: string43().min(1, "id is required"),
  title: coerce30.string().min(3, "Title is required"),
  image: string43().optional().nullable(),
  vimeoVideoId: string43().optional().nullable(),
  isActive: coerce30.boolean().default(true),
  subtitle: string43().optional().nullable(),
  description: string43().optional().nullable(),
  type: SlideshowTypeEnumObj.default("event"),
  badge: SlideBadgeSchema.optional().nullable().default(null),
  createdAt: coerce30.date(),
  updatedAt: coerce30.date()
});
var BaseSlideshowSchema = BaseSlideshowSchemaWithoutUnion.and(BaseDiscriminatedUnion).and(FromToDateORSchema);

// src/fit/slideshow/fe-schema.ts
var CreateSlideshowSchemaFE = BaseSlideshowSchemaWithoutUnion.omit({
  id: true,
  isActive: true,
  image: true,
  updatedAt: true,
  createdAt: true
}).and(FEDiscriminatedUnion).and(FromToDateORSchema).refine((data) => {
  const hasFromDate = !!data.fromDate;
  const hasToDate = !!data.toDate;
  if (!hasFromDate && !hasToDate) {
    return true;
  }
  if (hasFromDate && hasToDate) {
    const fromDate = DateTime.fromISO(data == null ? void 0 : data.fromDate.toString());
    const toDate = DateTime.fromISO(data == null ? void 0 : data.toDate.toString());
    return toDate > fromDate;
  }
  return true;
}, {
  message: "To date must be greater than From date",
  path: [
    "toDate"
  ]
});
var UpdateSlideshowSchemaFE = BaseSlideshowSchemaWithoutUnion.omit({
  id: true
}).partial().and(FEDiscriminatedUnion).and(FromToDateORSchema);
var defaultSlideshowSchemaValues = {
  title: "",
  type: ESlideshowTypeEnum.content,
  image: "",
  subtitle: "",
  description: "",
  buttonUrl: null,
  buttonLabel: null,
  badge: {
    image: null,
    positions: {
      mobile: ESlideBadgeImagePositionEnum["top-right"],
      tablet: ESlideBadgeImagePositionEnum["top-right"],
      desktop: ESlideBadgeImagePositionEnum["top-right"]
    },
    sizes: {
      mobile: 50,
      tablet: 70,
      desktop: 100
    }
  }
};

// src/fit/slideshow/filters.ts
import { z as z90 } from "zod";
var SlideshowFiltersSchema = BaseSlideshowSchemaWithoutUnion.pick({
  isActive: true
}).merge(RequestSchema.omit({
  isHidden: true
}).extend({
  isDashboard: z90.coerce.boolean().optional()
})).partial();

// src/user/check-in.ts
import { number as number20, object as object46, string as string44, z as z91 } from "zod";
var CheckInSchema = object46({
  id: number20().min(1, "id is required"),
  userId: string44().min(1, "user id is required"),
  appName: AppNameEnumObj,
  action: UserLogActionEnumObj,
  contentId: string44().nullable().default(null),
  ipAddress: string44().min(1, "ip address is required").nullable().optional(),
  createdAt: string44().or(z91.instanceof(Date)).or(CustomLuxonDateSchema)
});

// src/user/update-profile.ts
import { z as z92 } from "zod";
var optionalUrl2 = z92.string().url("Must be a valid URL").or(z92.literal("")).nullable().optional();
var UpdateProfileSchema = z92.object({
  firstName: z92.string().min(1, "First name is required"),
  lastName: z92.string().optional(),
  email: z92.string().email("Must be a valid email").optional().or(z92.literal("")),
  displayName: z92.string().optional(),
  occupation: z92.string().optional(),
  timezone: z92.string().min(1, "Timezone is required"),
  isPrivate: z92.boolean().default(false),
  bio: z92.string().nullable().optional(),
  primaryLanguage: z92.string().min(1, "Primary language is required"),
  phoneNumber: z92.string().nullable().optional(),
  zoomEmail: z92.string().email("Must be a valid email").optional().or(z92.literal("")),
  address: z92.object({
    street: z92.string().nullable().optional(),
    city: z92.string().nullable().optional(),
    state: z92.string().nullable().optional(),
    zip: z92.string().nullable().optional(),
    country: z92.string().nullable().optional()
  }).nullable().optional(),
  socials: z92.object({
    facebook: optionalUrl2,
    instagram: optionalUrl2,
    youtube: optionalUrl2,
    twitter: optionalUrl2,
    linkedin: optionalUrl2,
    tiktok: optionalUrl2
  }).nullable().optional()
});
var ProfileFormSchema = UpdateProfileSchema.extend({
  avatar: z92.string().optional(),
  lastName: z92.string().min(1, "Last name is required"),
  email: z92.string().email("Must be a valid email").min(1, "Email is required"),
  displayName: z92.string().min(1, "Display name is required"),
  occupation: z92.string().min(1, "Profession is required"),
  phoneNumber: z92.string().nullable().optional(),
  address: z92.object({
    city: z92.string().min(1, "City is required"),
    state: z92.string().min(1, "State / Province is required"),
    country: z92.string().min(1, "Country is required")
  })
});

// src/user/update-teacher-directory.ts
import { z as z94 } from "zod";

// src/supabase/teacher-directory.ts
import { z as z93 } from "zod";
var TeachingFormatSchema = z93.enum([
  "in_person",
  "online",
  "both"
]);
var TeacherDirectoryRowSchema = z93.object({
  id: z93.string().uuid(),
  bio: z93.string().nullable().optional(),
  profession: z93.array(z93.string()).nullable().optional(),
  company_name: z93.string().nullable().optional(),
  company_email: z93.string().nullable().optional(),
  professional_website: z93.string().nullable().optional(),
  offerings: z93.array(z93.string()).nullable().optional(),
  teaching_format: TeachingFormatSchema.nullable().optional(),
  expertise: z93.array(z93.string()).nullable().optional(),
  languages_taught: z93.array(z93.string()).nullable().optional(),
  casual_image: z93.string().nullable().optional(),
  created_at: z93.string(),
  updated_at: z93.string()
});
var TeacherDirectorySchema = TeacherDirectoryRowSchema.transform((values) => {
  var _a5, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  return {
    id: values.id,
    bio: (_a5 = values.bio) != null ? _a5 : null,
    profession: (_b = values.profession) != null ? _b : [],
    companyName: (_c = values.company_name) != null ? _c : null,
    companyEmail: (_d = values.company_email) != null ? _d : null,
    professionalWebsite: (_e = values.professional_website) != null ? _e : null,
    offerings: (_f = values.offerings) != null ? _f : [],
    teachingFormat: (_g = values.teaching_format) != null ? _g : null,
    expertise: (_h = values.expertise) != null ? _h : [],
    languagesTaught: (_i = values.languages_taught) != null ? _i : [],
    casualImage: (_j = values.casual_image) != null ? _j : null,
    createdAt: values.created_at,
    updatedAt: values.updated_at
  };
});

// src/user/update-teacher-directory.ts
var optionalUrl3 = z94.string().url("Must be a valid URL").or(z94.literal("")).nullable().optional();
var optionalEmail = z94.string().email("Must be a valid email").or(z94.literal("")).nullable().optional();
var UpdateTeacherDirectorySchema = z94.object({
  bio: z94.string().nullable().optional(),
  profession: z94.array(z94.string()).nullable().optional(),
  companyName: z94.string().nullable().optional(),
  companyEmail: optionalEmail,
  professionalWebsite: optionalUrl3,
  offerings: z94.array(z94.string()).nullable().optional(),
  teachingFormat: TeachingFormatSchema.nullable().optional(),
  expertise: z94.array(z94.string()).nullable().optional(),
  languagesTaught: z94.array(z94.string()).nullable().optional(),
  casualImage: z94.string().nullable().optional()
});

// src/user/change-password.ts
import { z as z95 } from "zod";
var ChangePasswordSchema = z95.object({
  currentPassword: z95.string().min(1, "Current password is required"),
  newPassword: z95.string().min(8, "Password must be at least 8 characters"),
  confirmPassword: z95.string().min(1, "Please confirm your new password")
}).refine((data) => data.newPassword !== data.currentPassword, {
  message: "New password must be different from your current password",
  path: [
    "newPassword"
  ]
}).refine((data) => data.newPassword === data.confirmPassword, {
  message: "Passwords don't match",
  path: [
    "confirmPassword"
  ]
});
var ChangePasswordApiSchema = z95.object({
  currentPassword: z95.string().min(1),
  newPassword: z95.string().min(8)
});

// src/wp-jwt/base.ts
import { array as array8, object as object47, string as string45, z as z96 } from "zod";
var WPJwtSchema = z96.object({
  headers: object47({
    "x-forwarded-for": string45().optional(),
    "x-real-ip": string45().optional(),
    "x-forwarded-host": string45().optional(),
    "x-forwarded-proto": string45().optional(),
    "cf-connecting-ip": string45().optional(),
    "true-client-ip": string45().optional()
  }).optional(),
  connection: object47({
    remoteAddress: string45().optional(),
    remotePort: string45().optional()
  }).optional(),
  user: object47({
    wp_token: z96.string(),
    data: object47({
      user_apps: array8(z96.number()).optional(),
      user_email: string45(),
      user_id: z96.number(),
      user_uuid: z96.string().optional(),
      role: string45().array().default([
        "user"
      ])
    })
  }).required()
});
var UserJwtSchema = z96.object({
  wp_token: z96.string(),
  data: object47({
    user_apps: array8(z96.number()).optional(),
    user_email: string45(),
    user_id: z96.number(),
    user_uuid: z96.string().optional(),
    role: string45().array().default([
      "user"
    ])
  })
}).required();
var WpUserSchema = z96.object({
  token: z96.string(),
  user_email: z96.string().email(),
  user_nicename: z96.string(),
  user_display_name: z96.string(),
  user_app: z96.coerce.number().array(),
  user_id: z96.coerce.number(),
  user_uuid: z96.string().optional(),
  user_role: string45().array()
});

// src/service-response/index.ts
import { coerce as coerce31, object as object48, z as z97 } from "zod";
var ServiceResponseErrorSchema = object48({
  message: z97.string(),
  code: z97.number()
});
var ServiceResponseDescriminatedUnionSchema = /* @__PURE__ */ __name((dataType) => {
  return z97.discriminatedUnion("status", [
    object48({
      status: z97.literal("ok"),
      items: dataType,
      meta: z97.object({
        total: coerce31.number(),
        page: coerce31.number(),
        perPage: coerce31.number(),
        totalPages: coerce31.number()
      })
    }),
    object48({
      status: z97.literal("error"),
      error: ServiceResponseErrorSchema
    })
  ]);
}, "ServiceResponseDescriminatedUnionSchema");

// src/settings/settings-schema.ts
import { object as object50, z as z98 } from "zod";

// src/settings/base.ts
import { coerce as coerce32, object as object49, union as union4 } from "zod";
var FeaturedSeriesSettingSchema = object49({
  title: coerce32.string().min(5, "Title is required"),
  subtitle: coerce32.string().min(5, "Subtitle is required"),
  body: coerce32.string().min(5, "Description is required"),
  button_label: coerce32.string().min(3, "Button label is required"),
  video_badge: coerce32.string().min(3, "Video badge is required"),
  isEnable: CoerceBoolean.default(false).optional(),
  seriesId: coerce32.number().optional()
});
var ChallengeBannerSettingSchema = object49({
  isEnable: CoerceBoolean.default(false)
});
var ChallengePageSettingSchema = ChallengeBannerSettingSchema;
var OnboardingSettingSchema = ChallengeBannerSettingSchema;
var UpcomingLiveBannerSettingSchema = ChallengeBannerSettingSchema;
var BaseSettingSchema = union4([
  FeaturedSeriesSettingSchema,
  ChallengeBannerSettingSchema,
  OnboardingSettingSchema,
  UpcomingLiveBannerSettingSchema
]);

// src/settings/settings-schema.ts
var SettingsTypeEnumValues = [
  "FEATURED_SERIES",
  "FEATURED_SERIES_CONTENTS",
  "FIT_CHALLENGE_BANNER",
  "FIT_CHALLENGE_PAGE",
  "ONBOARDING",
  "UPCOMING_LIVE_BANNER",
  "CONTACT_FORM_IFRAME_URL"
];
var SettingsTypeEnumObj = z98.enum(SettingsTypeEnumValues);
var SettingsTypeEnum = SettingsTypeEnumObj.enum;
var SettingsSchema = object50({
  id: SettingsTypeEnumObj,
  values: BaseSettingSchema
});

// src/settings/fe-schema.ts
import { z as z100 } from "zod";

// src/settings/global-settings-schema.ts
import { coerce as coerce33, object as object51, z as z99 } from "zod";
var ContactFormSettingSchema = object51({
  iframeUrl: coerce33.string().url("Must be a valid URL")
});
var GlobalSettingsValue = ContactFormSettingSchema;
var GlobalSettingsTypeEnumValues = [
  "CONTACT_FORM_IFRAME_URL"
];
var GlobalSettingsTypeEnumObj = z99.enum(GlobalSettingsTypeEnumValues);
var GlobalSettingsTypeEnum = GlobalSettingsTypeEnumObj.enum;
var GlobalSettingsSchema = object51({
  id: GlobalSettingsTypeEnumObj,
  values: GlobalSettingsValue
});

// src/settings/fe-schema.ts
var UpdateContentScheduleSettingsFE = FeaturedSeriesSettingSchema;
var CreateFeatureSeriesContentSchemaFE = FeaturedSeriesSettingSchema.omit({
  subtitle: true,
  body: true,
  button_label: true,
  video_badge: true
}).extend({
  seriesId: z100.coerce.number().min(1, "Please select series")
});
var CreateFitChallengeSchemaFE = CreateFeatureSeriesContentSchemaFE.omit({
  title: true,
  seriesId: true
}).extend({
  isEnable: CoerceBoolean.default(false)
});
var defaultFeatureSeriesContentValues = {
  title: "",
  isEnable: false,
  seriesId: 0
};
var defaultFitChallengeValues = {
  isEnable: false
};
var OnboardingSettingSchemaFE = z100.object({
  isEnable: CoerceBoolean.default(false)
});
var defaultOnboardingSettingValues = {
  isEnable: false
};
var UpcomingLiveBannerSettingSchemaFE = UpcomingLiveBannerSettingSchema;
var defaultUpcomingLiveBannerSettingValues = {
  isEnable: false
};
var ContactFormSettingSchemaFE = ContactFormSettingSchema;
var defaultContactFormSettingValues = {
  iframeUrl: ""
};

// src/settings/be-schema.ts
import { object as object52, z as z101 } from "zod";
var UpdateContentScheduleSettingsSchemaBE = FeaturedSeriesSettingSchema.pick({
  title: true,
  subtitle: true,
  body: true,
  button_label: true,
  video_badge: true
}).extend({
  id: z101.coerce.string(),
  seriesId: z101.coerce.number().optional(),
  isHidden: CoerceBoolean.optional()
});
var CreateFeatureSeriesContentSchemaBE = CreateFeatureSeriesContentSchemaFE.extend({
  id: z101.coerce.string()
});
var CreateFitChallengeSchemaBE = CreateFitChallengeSchemaFE.extend({
  id: z101.coerce.string()
});
var OnboardingSettingSchemaBE = OnboardingSettingSchemaFE.extend({
  id: z101.coerce.string()
});
var UpcomingLiveBannerSettingSchemaBE = UpcomingLiveBannerSettingSchemaFE.extend({
  id: z101.coerce.string()
});
var ContactFormSettingSchemaBE = ContactFormSettingSchemaFE.extend({
  id: z101.coerce.string()
});
var SettingBEResponseSchema = object52({
  FEATURED_SERIES: FeaturedSeriesSettingSchema,
  FEATURED_SERIES_CONTENTS: FeaturedSeriesSettingSchema,
  FIT_CHALLENGE_BANNER: ChallengeBannerSettingSchema,
  FIT_CHALLENGE_PAGE: ChallengePageSettingSchema,
  ONBOARDING: OnboardingSettingSchema,
  UPCOMING_LIVE_BANNER: UpcomingLiveBannerSettingSchema,
  CONTACT_FORM_IFRAME_URL: ContactFormSettingSchema
});
var GlobalSettingBEResponseSchema = object52({
  CONTACT_FORM_IFRAME_URL: ContactFormSettingSchema
});

// src/settings/feature-series/fe-schema.ts
import { z as z102 } from "zod";
var CreateFeatureSeriesSchemaFE = FeaturedSeriesSettingSchema.omit({
  title: true,
  subtitle: true,
  body: true,
  video_badge: true
}).extend({
  seriesId: z102.coerce.number().min(1, "Please select series")
});
var defaultSettingsValues = {
  button_label: "",
  isEnable: false,
  seriesId: 0
};

// src/settings/feature-series/be-schema.ts
import { z as z103 } from "zod";
var CreateFeatureSeriesSchemaBE = CreateFeatureSeriesSchemaFE.extend({
  id: z103.coerce.string()
});

// src/ryc/onboarding/step.enum.ts
import { z as z104 } from "zod";
var OnboardingStepValues = [
  "WELCOME",
  "INTRO",
  "UPDATE_PROFILE_INFORMATION",
  "EXPECTATION"
];
var OnboardingStepEnumObject = z104.enum(OnboardingStepValues);
var EOnboardingStep = OnboardingStepEnumObject.enum;

// src/ryc/onboarding/base.ts
import { coerce as coerce43, object as object62, string as string51, z as z114 } from "zod";

// src/ryc/step/step.ts
import { coerce as coerce40, object as object59, z as z111 } from "zod";

// src/ryc/step/stage.ts
import { z as z105 } from "zod";
var Stages = [
  "STAGE_1",
  "STAGE_2",
  "STAGE_3",
  "STAGE_4"
];
var StagesEnumObject = z105.enum(Stages);
var EStagesEnum = StagesEnumObject.enum;

// src/ryc/step/day.ts
import { coerce as coerce39, object as object58 } from "zod";

// src/ryc/step/content.ts
import { coerce as coerce38, object as object57, string as string49 } from "zod";

// src/ryc/content/path.enum.ts
import { z as z106 } from "zod";
var RYCContentPathValues = [
  "REGULAR_PATH",
  "SUPPORTIVE_PATH"
];
var RYCContentPathEnumObject = z106.enum(RYCContentPathValues);
var ERYCContentPath = RYCContentPathEnumObject.enum;

// src/ryc/content/base.ts
import { array as array9, boolean as boolean14, coerce as coerce34, number as number21, object as object53, string as string46, union as union5, z as z107 } from "zod";
var RYCContent = Content.omit({
  category: true
}).extend({
  category: CategoryEnumObj
});
var BaseRYCContentWitMetaInformation = Content;
var RYCContentTypeValues = [
  "CONTENT",
  "JOURNAL"
];
var RYCContentTypeEnumObject = z107.enum(RYCContentTypeValues);
var ERYCContentType = RYCContentTypeEnumObject.enum;
var BaseRYCContentSchema = z107.object({
  id: coerce34.string(),
  contentId: string46(),
  order: coerce34.number().min(1),
  type: RYCContentTypeEnumObject,
  path: RYCContentPathEnumObject,
  createdAt: z107.string(),
  updatedAt: z107.string()
});
var CreateRYCContentSchemaFE = BaseRYCContentSchema.omit({
  id: true,
  path: true,
  type: true,
  contentId: true,
  createdAt: true,
  updatedAt: true
}).extend({
  id: number21().optional(),
  path: string46().optional(),
  content: RYCContent
});
var CreateRYCContentSchemaBE = BaseRYCContentSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
var UpdateRYCContentSchemaBE = BaseRYCContentSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  id: coerce34.number().optional()
});
var ContentResponseSchema = object53({
  items: Content.array().nullable(),
  meta: object53({
    total: coerce34.number(),
    page: coerce34.number(),
    perPage: coerce34.number(),
    totalPages: coerce34.number()
  })
});
var CalendarStateResponse = object53({
  id: number21(),
  stage: number21(),
  level: number21(),
  days: object53({
    day: number21(),
    items: array9(string46()),
    isRest: union5([
      boolean14(),
      z107.null()
    ]),
    checked: union5([
      boolean14(),
      z107.null()
    ])
  }).array()
});

// src/ryc/content/be-schema.ts
import { coerce as coerce35, lazy as lazy9, object as object54, string as string47, z as z108 } from "zod";
var CreateRYCContentBEBase = object54({
  name: string47().min(3, "name is required"),
  instructorId: coerce35.string(),
  status: lazy9(() => StatusEnumObj),
  equipments: object54({
    id: coerce35.number().min(1, "id is required")
  }).array().min(1, "Please select at least one equipment"),
  video: VimeoVideo.extend({
    duration: coerce35.number().min(1, "duration is required")
  }),
  publishedDate: z108.string().or(CustomLuxonDateSchema).optional().nullable(),
  id: string47().optional(),
  meta: lazy9(() => RYCContentMetaInformationBaseSchema.omit({
    id: true,
    contentId: true,
    createdAt: true,
    updatedAt: true
  }).extend({
    type: RYCContentMetaTypeEnumObject.default("WORKOUT"),
    category: lazy9(() => CategoryEnumObj),
    categories: coerce35.number().array().optional().default([])
  }).partial({
    category: true,
    categories: true,
    series: true,
    stage: true,
    isRegular: true,
    isSupportive: true,
    tiers: true,
    pdfLink: true
  }).optional())
});
var CreateRYCContentWithMetaSchemaBE = CreateRYCContentBEBase.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var UpdateRYCContentWithMetaSchemaBE = CreateRYCContentBEBase.partial();

// src/ryc/content/fe-schema.ts
import { coerce as coerce36, lazy as lazy10, object as object55, z as z109 } from "zod";
var RYCDashboardCreateContentSchemaFEBase = object55({
  name: z109.string().min(3, "name is required"),
  instructorId: coerce36.string(),
  equipments: coerce36.number().array().min(1, "Please select at least one equipment"),
  status: lazy10(() => StatusEnumObj),
  publishedDate: z109.string().or(CustomLuxonDateSchema).optional().nullable(),
  video: VimeoVideo,
  meta: object55({
    type: RYCContentMetaTypeEnumObject.default("WORKOUT"),
    category: CategoryEnumObj,
    categories: coerce36.number().array().optional().default([]),
    tiers: TiersEnumObject.array().optional().default([]),
    series: z109.preprocess((v) => v === "" ? void 0 : v, RYCContentMetaSeriesEnumObject.optional()),
    stage: z109.preprocess((v) => v === "" ? void 0 : v, coerce36.number().optional().nullable()),
    isRegular: coerce36.boolean().optional().default(false),
    isSupportive: coerce36.boolean().optional().default(false),
    pdfLink: z109.string().optional().nullable()
  }).optional()
});
var RYCDashboardCreateContentSchemaFEWithoutValidation = RYCDashboardCreateContentSchemaFEBase;
var RYCDashboardCreateContentSchemaFE = RYCDashboardCreateContentSchemaFEBase.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var RYCDashboardUpdateContentSchemaFE = RYCDashboardCreateContentSchemaFEWithoutValidation.partial();
var defaultRYCContentSchemaValues = {
  video: {
    bannerUrl2x: "",
    description: "",
    duration: 0,
    jwVideoUrl: "",
    provider: "VIMEO",
    vimeoVideoId: ""
  },
  name: "",
  instructorId: "",
  equipments: [],
  status: "PUBLISHED",
  publishedDate: void 0,
  meta: {
    type: "WORKOUT",
    category: "RESTORE",
    categories: [],
    tiers: [],
    isRegular: false,
    isSupportive: false
  }
};

// src/ryc/content/request.ts
import { array as array10, coerce as coerce37, object as object56, string as string48 } from "zod";
var CreateRYCContentRequestWithMetaSchema = CreateRYCContentWithMetaSchemaBE;
var UpdateRYCContentRequestWithMetaSchema = UpdateRYCContentWithMetaSchemaBE;
var RYCContentRequestBESchema = object56({
  app: AppNameEnumObj.optional(),
  query: string48().optional(),
  shuffle: CoerceBoolean.optional().default(false),
  loadAll: CoerceBoolean.optional().default(false),
  stage: coerce37.number().optional(),
  series: RYCContentMetaSeriesEnumObject.optional(),
  path: string48().optional(),
  type: RYCContentMetaTypeEnumObject,
  skipTypeFilter: coerce37.boolean().optional().default(false),
  categoryIds: array10(string48()).default([]),
  instructorIds: array10(coerce37.string()).default([]),
  status: StatusEnumObj.array().optional(),
  durationFrom: coerce37.number().default(1),
  durationTo: coerce37.number().default(1e3),
  perPage: coerce37.number().max(150),
  page: coerce37.number()
}).partial();
var rycContentFilterDefaultValues = {
  categoryIds: "",
  duration: "1-60",
  stage: "",
  series: "",
  page: "1",
  path: "",
  perPage: "15",
  type: "",
  query: ""
};
var DownloadPdfRequestBESchema = object56({
  contentId: string48()
});

// src/ryc/step/content.ts
var BaseStepContentSchema = object57({
  id: UnsignedIDSchema,
  isMandatory: coerce38.boolean().optional().default(false),
  hasAlternatives: coerce38.boolean().optional().default(false),
  contentId: string49(),
  order: coerce38.number().min(1),
  path: RYCContentPathEnumObject,
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});
var UpdateStepContentSchemaBE = BaseStepContentSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  id: UnsignedIDSchema.optional(),
  rycContent: UpdateRYCContentSchemaBE
});
var UpdateStepContentSchemaFE = BaseStepContentSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  id: UnsignedIDSchema.optional()
}).merge(CreateRYCContentSchemaFE).extend({
  path: RYCContentPathEnumObject
});
var UpdateStepContentsSchemaBE = object57({
  stepContents: object57({
    // step content id (primary column value)
    id: coerce38.number().optional(),
    // ryc content id (primary column value)
    // rycContentId: coerce.number().optional(),
    // content id from content service
    contentId: coerce38.string(),
    order: coerce38.number().min(1),
    path: RYCContentPathEnumObject,
    type: RYCContentTypeEnumObject,
    isMandatory: coerce38.boolean().optional().default(false),
    hasAlternatives: coerce38.boolean().optional().default(false)
  }).array()
});

// src/ryc/step/day.ts
var BaseStepDaySchema = object58({
  id: coerce39.number().int().nonnegative(),
  day: coerce39.number().int().nonnegative().nullable(),
  stepContents: BaseStepContentSchema.array(),
  electiveContents: BaseStepContentSchema.array(),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});
var BaseStepContentSchemaWithContentInfo = BaseStepContentSchema.extend({
  content: RYCContent.extend({
    instructor: Instructor
  })
});
var BaseStepDayWithContentsSchema = BaseStepDaySchema.extend({
  stepContents: BaseStepContentSchemaWithContentInfo.array(),
  electiveContents: BaseStepContentSchemaWithContentInfo.array()
});
var UpdateStepDaySchemaBE = object58({
  stepContents: UpdateStepContentSchemaBE.array()
});

// src/ryc/step/step-type.ts
import { z as z110 } from "zod";
var StepType = [
  "REGULAR",
  "BONUS"
];
var StepTypeEnumObject = z110.enum(StepType);
var EStepTypeEnum = StepTypeEnumObject.enum;

// src/ryc/step/step.ts
var Steps = [
  "STEP_1",
  "STEP_2",
  "STEP_3",
  "STEP_4"
];
var StepsEnumObject = z111.enum(Steps);
var EStepsEnum = StepsEnumObject.enum;
var BaseStepSchema = object59({
  id: coerce40.number(),
  adjustedStepId: coerce40.number(),
  tier: TiersEnumObject,
  stage: StagesEnumObject,
  days: BaseStepDaySchema.array().nullable(),
  stepType: StepTypeEnumObject.optional(),
  bonusVideos: z111.array(BaseStepContentSchema).nullable(),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});
var BaseStepSchemaWithContents = BaseStepSchema.extend({
  contents: Content.array()
});
var BonusSchemaWithContent = BaseStepContentSchema.extend({
  content: RYCContent.extend({
    instructor: Instructor
  })
});
var BaseStepSchemaWithBonusVideos = BaseStepSchema.extend({
  bonusVideos: BonusSchemaWithContent.array()
});

// src/ryc/step/fe-schema.ts
var CreateStepSchemaFE = BaseStepSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  contents: CreateRYCContentSchemaFE.array()
});
var UpdateStepSchemaFE = BaseStepSchema.partial();
var UpdateStepSchemaBE = BaseStepSchema.omit({
  createdAt: true,
  updatedAt: true
}).extend({
  contents: CreateRYCContentSchemaBE.array()
});

// src/ryc/onboarding/step.ts
import { coerce as coerce42, object as object61, z as z113 } from "zod";

// src/ryc/onboarding/video.ts
import { coerce as coerce41, object as object60, string as string50, z as z112 } from "zod";
var OnboardingVideoSchema = object60({
  id: coerce41.number(),
  title: string50(),
  isWatched: CoerceBoolean,
  thumbnail: string50(),
  type: string50().optional(),
  videoId: string50()
});
var CreateOnboardingVideoSchemaBE = OnboardingVideoSchema.extend({
  isWatched: z112.boolean()
});

// src/ryc/onboarding/step.ts
var OnboardingStepSchema = object61({
  name: OnboardingStepEnumObject,
  isCompleted: CoerceBoolean,
  videos: OnboardingVideoSchema.array(),
  updatedAt: coerce42.string().date()
});
var CreateOnboardingStepSchemaBE = OnboardingStepSchema.extend({
  isCompleted: z113.boolean(),
  videos: CreateOnboardingVideoSchemaBE.array()
});
var UpdateOnboardingStepVideoWatchedSchemaBE = OnboardingStepSchema.extend({
  videoId: coerce42.string().optional(),
  step: OnboardingStepEnumObject
});

// src/ryc/onboarding/base.ts
var BaseOnboardingSchema = object62({
  id: coerce43.number(),
  tier: TiersEnumObject,
  isComplete: z114.boolean(),
  currentProgressStep: OnboardingStepEnumObject,
  isCompleted: coerce43.boolean(),
  progress: OnboardingStepSchema.array(),
  userId: string51(),
  createdAt: coerce43.string().date(),
  updatedAt: coerce43.string().date()
});

// src/ryc/onboarding/be-schema.ts
var CreateOnboardingSchemaBE = CreateOnboardingStepSchemaBE.array();

// src/ryc/todays-workout/fe-schema.ts
import { coerce as coerce44, object as object63 } from "zod";
var TodaysWorkoutSchemaFE = object63({
  step: coerce44.number(),
  completedClass: coerce44.number(),
  classes: BaseRYCContentSchema.array()
});

// src/ryc/journey/base.ts
import { coerce as coerce48, object as object67, string as string53, z as z117 } from "zod";

// src/ryc/journey/user-activity.ts
import { coerce as coerce45, object as object64 } from "zod";

// src/ryc/journey/user-activity-type.ts
import { z as z115 } from "zod";
var UserActivityTypeValues = [
  "CONTENT_WATCH",
  "JOURNAl_SAVED",
  "STAGE_COMPLETE",
  "STEP_COMPLETE",
  "BONUS_CLAIMED",
  "PATH_SWITCH_TO_REGULAR",
  "PATH_SWITCH_TO_SUPPORTIVE",
  "JOURNAL_SKIPPED",
  "NEW_DAY",
  "PROGRAM_COMPLETE",
  "RESET",
  "START_JOURNEY",
  "RESTART_JOURNEY",
  "SPECIAL_JOURNAL",
  "JOINED_ELECTIVE",
  "CHECKIN"
];
var UserActivityTypeEnumObject = z115.enum(UserActivityTypeValues);
var EUserActivityTypeEnum = UserActivityTypeEnumObject.enum;

// src/ryc/journey/user-activity.ts
var UserActivitySchema = object64({
  id: coerce45.number(),
  userId: coerce45.string(),
  type: UserActivityTypeEnumObject,
  exerciseId: coerce45.string().nullable(),
  exercisePath: RYCContentPathEnumObject,
  stepId: coerce45.number().nullable(),
  adjustedStepId: coerce45.number().nullable(),
  stepDay: coerce45.number().nullable(),
  dayNumber: coerce45.number().min(1).max(7).nullable(),
  content: Content.optional().nullable(),
  isMandatory: coerce45.boolean().nullable(),
  createdAt: coerce45.string()
});
var UserActivityItemSchema = UserActivitySchema.extend({
  content: Content.optional()
});
var JourneyUserActivitiesSchema = object64({
  items: UserActivityItemSchema.array()
});
var JourniesUserActivitiesSchema = JourneyUserActivitiesSchema.array();

// src/ryc/journal/base.ts
import { array as array11, coerce as coerce46, object as object65, string as string52, z as z116 } from "zod";
var BaseJournalSchema = object65({
  id: coerce46.string(),
  userId: coerce46.string(),
  content: coerce46.string(),
  path: RYCContentPathEnumObject.nullable(),
  dayNumber: coerce46.number(),
  link: coerce46.string().optional(),
  stepDay: BaseStepDaySchema,
  journey: object65({
    id: coerce46.number()
  }),
  skipJournal: coerce46.boolean().optional().nullable(),
  contents: array11(RYCContentMetaInformationBaseSchema).nullable(),
  createdAt: coerce46.string(),
  updatedAt: coerce46.string()
});
var CreateJournalSchemaBE = BaseJournalSchema.pick({
  content: true,
  path: true,
  link: true,
  skipJournal: true
}).partial();
var SkipJournalSchemaBE = object65({
  journeyId: coerce46.number().or(z116.literal(void 0))
});
var RYCJournalRequestBESchema = object65({
  stage: StagesEnumObject.optional(),
  series: array11(RYCContentMetaSeriesEnumObject).optional(),
  types: array11(RYCContentMetaTypeEnumObject).optional(),
  query: string52().optional(),
  byDate: string52().optional(),
  perPage: coerce46.number().max(150),
  page: coerce46.number()
}).partial();
var rycJournalFilterDefaultValues = {
  byDate: void 0,
  stage: "STAGE_1",
  series: [],
  page: 1,
  perPage: 15,
  types: [],
  query: ""
};
var FindVideoTagsRequestSchema = object65({
  contentIds: array11(string52())
});
var JournalEntryDatesRequestSchema = object65({
  month: coerce46.number().int().min(1).max(12),
  year: coerce46.number().int().min(2e3).max(2100)
});

// src/ryc/journey/elective-content.ts
import { coerce as coerce47, object as object66 } from "zod";
var ElectiveContentSchema = object66({
  id: coerce47.number(),
  userId: coerce47.string(),
  electiveContents: coerce47.number().array(),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});

// src/ryc/journey/base.ts
var JourneyAlreadyClaimedBonusValues = z117.union([
  z117.literal("t"),
  z117.literal("f"),
  z117.literal(null)
]);
var BaseJourneySchema = object67({
  id: coerce48.number(),
  userId: string53(),
  tier: TiersEnumObject,
  stage: StagesEnumObject,
  path: RYCContentPathEnumObject,
  journals: BaseJournalSchema.array(),
  userActivities: UserActivitySchema.array(),
  dayDiffInMS: coerce48.number().optional().default(0),
  currentElectiveDay: coerce48.number().default(0),
  currentElectiveContentId: coerce48.number().nullable().default(null),
  lastElectiveContentSelectedTime: CommonCustomDateSchema,
  electiveContent: ElectiveContentSchema,
  stepId: coerce48.number(),
  adjustedStepId: coerce48.number(),
  currentDay: coerce48.number(),
  isComplete: coerce48.boolean(),
  isCurrent: coerce48.boolean(),
  joinedElective: coerce48.boolean().optional().default(false),
  showBonusSelection: coerce48.boolean(),
  alreadyClaimedBonus: JourneyAlreadyClaimedBonusValues,
  nextStep: BaseStepSchema.optional().nullable(),
  selectElectiveContent: coerce48.boolean().optional().default(false),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});

// src/ryc/journey/filters.ts
import { coerce as coerce49, object as object68 } from "zod";
var JourneyFiltersSchema = object68({
  perPage: coerce49.number().optional(),
  page: coerce49.number().optional()
});
var CurrentJourneyFiltersSchema = object68({
  withNextRestore: CoerceBoolean.optional().default(false)
});

// src/ryc/journey/select-bonus-content.request.ts
import { object as object69, string as string54 } from "zod";
var SelectBonusContentRequestSchema = object69({
  contentIds: string54().array().min(1, "Select at least 1 content").max(3, "Maximum 3 contents allowed")
});

// src/ryc/user/base.ts
import { coerce as coerce50, object as object70 } from "zod";
var BaseUserSchema = object70({
  id: coerce50.string(),
  electiveContents: coerce50.number().array(),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});

// src/ryc/user/user-manage-item-type.enum.ts
import { z as z118 } from "zod";
var UserManageItemTypeValues = [
  "USER_INFORMATION",
  "INSTRUCTION",
  "ACTIVITY",
  "CHECK_IN",
  "BONUS_VIDEOS",
  "JOURNEY",
  "SIMULATION",
  "CUSTOM_NOTIFICATION",
  "NOTIFICATION_HISTORY"
];
var UserManageItemTypeObj = z118.enum(UserManageItemTypeValues);
var UserManageItemTypeEnum = UserManageItemTypeObj.enum;

// src/ryc/user/select-elective-contents.ts
import { coerce as coerce51, object as object71 } from "zod";
var SelectElectiveContentsSchema = object71({
  contentIds: coerce51.number().array().max(3).min(1)
});

// src/help-center/app-names.ts
import { z as z119 } from "zod";
var HelpCenterAppNameValues = [
  "FIT",
  "RYC",
  "BUMP"
];
var HelpCenterAppNameEnumObj = z119.enum(HelpCenterAppNameValues);
var EHelpCenterAppNameEnum = HelpCenterAppNameEnumObj.enum;

// src/help-center/article-base.ts
import { array as array12, coerce as coerce53, lazy as lazy11, number as number22, object as object73, string as string56, z as z120 } from "zod";

// src/help-center/taxonomy-base.ts
import { coerce as coerce52, object as object72, string as string55 } from "zod";
var BaseTaxonomySchema = object72({
  id: coerce52.number(),
  title: string55(),
  slug: string55(),
  createdAt: coerce52.string().date(),
  updatedAt: coerce52.string().date()
});
var BaseTopicTaxonomySchema = BaseTaxonomySchema.extend({
  categoryId: coerce52.number()
});

// src/help-center/article-base.ts
var HelpCenterArticle = object73({
  id: string56(),
  question: string56(),
  answer: string56(),
  category: lazy11(() => HelpCenterArticleCategory),
  createdAt: coerce53.string(),
  topics: lazy11(() => HelpCenterArticleTopic.array()),
  updatedAt: coerce53.string()
});
var HelpCenterArticleDetails = object73({
  details: lazy11(() => HelpCenterArticle),
  category: lazy11(() => HelpCenterArticleCategory),
  topics: lazy11(() => HelpCenterArticleTopic.array())
});
var HelpCenterArticleCategory = object73({
  id: string56(),
  title: string56(),
  slug: string56(),
  topics: lazy11(() => HelpCenterArticleTopic.array()),
  createdAt: coerce53.string(),
  updatedAt: coerce53.string()
});
var HelpCenterArticleTopic = object73({
  id: string56(),
  title: string56(),
  slug: string56(),
  createdAt: coerce53.string(),
  updatedAt: coerce53.string()
});
var HelpCenterArticleTopicWithCategory = object73({
  id: string56(),
  title: string56(),
  slug: string56(),
  category: lazy11(() => HelpCenterArticleCategory),
  createdAt: coerce53.string(),
  updatedAt: coerce53.string()
});
var HelpCenterArticleSearchResponse = object73({
  didYouMean: string56().optional(),
  items: HelpCenterArticle.array(),
  topics: HelpCenterArticleTopic.array().optional()
});
var ArticleStatusValues = [
  "DRAFT",
  "PUBLISHED",
  "ARCHIVED"
];
var ArticleStatusEnumObj = z120.enum(ArticleStatusValues);
var EArticleStatus = ArticleStatusEnumObj.enum;
var BaseHelpCenterArticleSchema = object73({
  id: coerce53.number(),
  question: string56(),
  answer: string56(),
  topics: BaseTaxonomySchema.array(),
  category: BaseTaxonomySchema,
  appNames: HelpCenterAppNameEnumObj.array(),
  status: ArticleStatusEnumObj,
  createdAt: coerce53.string().date(),
  updatedAt: coerce53.string().date()
});
var HelpCenterArticleCreationPayloadSchema = object73({
  id: coerce53.number(),
  question: string56(),
  answer: string56(),
  topicIds: array12(number22()),
  categorySlug: string56(),
  appNames: HelpCenterAppNameEnumObj.array(),
  status: ArticleStatusEnumObj,
  createdAt: coerce53.string().date(),
  updatedAt: coerce53.string().date()
});

// src/help-center/article-be-schema.ts
var CreateHelpCenterArticleSchemaBE = BaseHelpCenterArticleSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
var CreateArticleSchemaBE = HelpCenterArticleCreationPayloadSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
var UpdateHelpCenterArticleSchemaBE = CreateArticleSchemaBE;
var defaultHelpCenterSchemaValues = {
  question: "",
  answer: "",
  topicIds: [],
  categorySlug: "",
  appNames: [],
  status: "DRAFT"
};

// src/help-center/taxonomy-be-schema.ts
var CreateHelpCenterCategoryTaxonomySchemaBE = BaseTaxonomySchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  appNames: HelpCenterAppNameEnumObj.array().optional()
});
var CreateHelpCenterTopicTaxonomySchemaBE = BaseTopicTaxonomySchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  appNames: HelpCenterAppNameEnumObj.array().optional()
});
var UpdateHelpCenterTopicTaxonomySchemaBE = CreateHelpCenterTopicTaxonomySchemaBE;
var UpdateHelpCenterCategoryTaxonomySchemaBE = CreateHelpCenterCategoryTaxonomySchemaBE;

// src/help-center/article-filter.ts
import { coerce as coerce54, object as object74 } from "zod";
var HelpCenterArticlesFiltersSchema = object74({
  categorySlug: coerce54.string().optional(),
  topicId: coerce54.number().optional(),
  topicSlug: coerce54.string().optional(),
  app: HelpCenterAppNameEnumObj.optional(),
  perPage: coerce54.number().optional(),
  page: coerce54.number().optional(),
  query: coerce54.string().optional(),
  enabled: coerce54.boolean().optional(),
  status: ArticleStatusEnumObj.optional()
}).partial();

// src/ryc/user-progress/base.ts
import { coerce as coerce55, object as object75 } from "zod";
var BaseUserProgressSchema = object75({
  totalCompletedClasses: coerce55.number(),
  totalTimeSpentInMin: coerce55.number()
});

// src/ryc/instruction/base.ts
import { array as array13, coerce as coerce56, number as number23, object as object76, string as string57, z as z122 } from "zod";

// src/ryc/instruction/plan-type.enum.ts
import { z as z121 } from "zod";
var PlanTypeValues = [
  "TEXT",
  "PLAN"
];
var PlanTypeObj = z121.enum(PlanTypeValues);
var PlanTypeEnum = PlanTypeObj.enum;

// src/ryc/instruction/base.ts
var InstructionPlanItemResponseSchema = object76({
  id: coerce56.number().optional(),
  day: number23(),
  order: coerce56.number(),
  content: Content.optional(),
  isRestDay: z122.boolean().default(false).optional()
});
var InstructionPlanItemSchema = object76({
  id: coerce56.number().optional(),
  day: number23(),
  order: coerce56.number(),
  contentId: string57().optional(),
  isRestDay: z122.boolean().default(false).optional()
});
var instructionSchema = object76({
  id: coerce56.number(),
  userId: string57(),
  message: string57().optional(),
  type: PlanTypeObj,
  plan: array13(InstructionPlanItemResponseSchema).optional(),
  createdBy: Instructor,
  createdAt: coerce56.string(),
  updatedAt: coerce56.string()
});
var CreateInstructionSchema = instructionSchema.omit({
  id: true,
  plan: true,
  createdBy: true,
  createdAt: true,
  updatedAt: true
}).extend({
  plan: array13(InstructionPlanItemSchema).optional()
});
var UpdateInstructionSchema = CreateInstructionSchema.extend({
  id: coerce56.number()
});

// src/ryc/addon-content/addon-content-type.enum.ts
import { z as z123 } from "zod";
var AddonContentTypeValues = [
  "BONUS",
  "ADDON"
];
var AddonContentTypeObject = z123.enum(AddonContentTypeValues);
var EAddonContentType = AddonContentTypeObject.enum;

// src/ryc/addon-content/base.ts
import { coerce as coerce57, object as object77, string as string58 } from "zod";
var UserMetaSchema = BaseUserSchema.omit({
  electiveContents: true
});
var AddonContentBaseSchema = object77({
  id: coerce57.number(),
  contentId: string58(),
  type: AddonContentTypeObject,
  createdAt: coerce57.date(),
  userMeta: UserMetaSchema
});

// src/ryc/user-management/user-type.ts
import { array as array15, number as number25, object as object79, string as string60, z as z126 } from "zod";

// src/supabase/profile.ts
import { array as array14, coerce as coerce58, number as number24, object as object78, string as string59, z as z124 } from "zod";
var normalizeSubscription = /* @__PURE__ */ __name((data) => {
  var _a5, _b, _c, _d;
  if (!data || typeof data !== "object") {
    return data;
  }
  const d = data;
  const meta = d["meta"];
  return {
    appId: (_a5 = d["appId"]) != null ? _a5 : d["app_id"],
    appName: (_b = d["appName"]) != null ? _b : d["app_name"],
    isActive: (_c = d["isActive"]) != null ? _c : d["is_active"],
    meta: meta ? __spreadProps(__spreadValues({}, meta), {
      isTrial: (_d = meta["isTrial"]) != null ? _d : meta["is_trial"],
      tier: meta["tier"]
    }) : void 0
  };
}, "normalizeSubscription");
var normalizeSubscriptionAddon = /* @__PURE__ */ __name((data) => {
  var _a5, _b;
  if (!data || typeof data !== "object") {
    return data;
  }
  const d = data;
  return {
    appName: (_a5 = d["appName"]) != null ? _a5 : d["app_name"],
    access: d["access"],
    isActive: (_b = d["isActive"]) != null ? _b : d["is_active"]
  };
}, "normalizeSubscriptionAddon");
var Subscription = z124.preprocess(normalizeSubscription, object78({
  appId: coerce58.number().min(1),
  appName: string59().min(1),
  isActive: StringToBooleanSchema,
  meta: z124.object({
    isTrial: StringToBooleanSchema.optional(),
    tier: z124.coerce.string().optional(),
    isPlanChangeAllowed: StringToBooleanSchema.optional(),
    isUpgradable: z124.string().optional(),
    upgradeLink: z124.string().optional()
  }).catchall(z124.unknown()).optional()
}));
var SubscriptionAddon = z124.preprocess(normalizeSubscriptionAddon, object78({
  appName: string59().min(1),
  access: array14(string59()),
  isActive: z124.boolean().default(false)
}));
var SpaceSubscriptionItem = object78({
  id: string59().uuid(),
  name: string59(),
  slug: string59().nullable(),
  spaceType: z124.enum([
    "container",
    "feed",
    "content",
    "chat",
    "single_lesson"
  ]),
  icon: string59().nullable(),
  bannerImage: string59().nullable(),
  thumbnailImage: string59().nullable(),
  role: string59().nullable(),
  roleId: z124.number().nullable(),
  hasAccess: z124.boolean()
});
var SpacesSubscription = object78({
  appName: string59(),
  isActive: z124.boolean().default(true),
  spaces: array14(SpaceSubscriptionItem)
});
var WPSubscriptionArraySchema = z124.array(Subscription);
var SubscriptionObjectSchema = z124.record(z124.string(), Subscription);
var transformSubscriptionArrayToObject = /* @__PURE__ */ __name((subscriptionArray) => {
  return subscriptionArray.reduce((acc, sub) => {
    const key = sanitizeAppName(sub.appName);
    acc[key] = sub;
    return acc;
  }, {});
}, "transformSubscriptionArrayToObject");
var ProfileMetaSchema = object78({
  isInstructor: z124.boolean().nullable().default(false).optional()
});
var ProfileSubscriptionSchema = object78({
  [EAppNameEnum.FIT]: Subscription.optional(),
  [EAppNameEnum.RYC]: Subscription.optional(),
  [EAppNameEnum.ADDON]: SubscriptionAddon.optional(),
  [EAppNameEnum.MEMBERS]: SubscriptionAddon.optional(),
  SPACES: SpacesSubscription.optional()
}).passthrough();
var AccessGroupItemSchema = object78({
  accessGroup: object78({
    id: number24(),
    name: string59()
  }),
  role: object78({
    id: number24(),
    name: string59()
  })
});
var UserAccessPermissionSchema = object78({
  id: number24(),
  name: string59()
});
var UserAccessItemSchema = object78({
  roleId: number24(),
  roleName: string59(),
  permissions: z124.array(UserAccessPermissionSchema).optional()
});
var UserAccessMapSchema = z124.record(z124.string(), UserAccessItemSchema);
var PermissionSchema = z124.object({
  id: z124.number(),
  name: z124.string()
});
var AccessGroupMemberSchema = z124.object({
  role: z124.object({
    id: z124.number(),
    name: z124.string(),
    role_permissions: z124.array(z124.object({
      permissions: PermissionSchema
    })).optional()
  }),
  access_groups: z124.object({
    id: z124.number(),
    name: z124.string()
  })
});
var SupabaseRowProfileSchema = z124.object({
  id: z124.coerce.string(),
  // Legacy WP identifier — surfaced for cross-system integrations (e.g. Novu
  // subscriberId) that key off the original numeric WP user id.
  userid: z124.string().min(1).optional(),
  // Legacy WP subscription-type bucket — preserved for callers that still read
  // this denormalized list off the cached profile.
  subscriptionType: z124.array(z124.string()).optional(),
  first_name: z124.string().optional(),
  last_name: z124.string().optional(),
  name: z124.string(),
  display_name: z124.string().optional(),
  email: z124.string(),
  avatar: z124.string().nullable(),
  auth_user_id: z124.string(),
  created_at: z124.string(),
  updated_at: z124.string(),
  user_roles: z124.array(z124.string()).nullable().optional(),
  last_check_in: z124.string().or(z124.instanceof(Date)).or(CustomLuxonDateSchema).optional(),
  timezone: timezoneSchema,
  is_timezone_set: z124.boolean().default(false),
  occupation: z124.string().nullable().optional(),
  bio: z124.string().nullable().optional(),
  primary_language: z124.string().nullable().optional(),
  phone_number: z124.string().nullable().optional(),
  zoom_email: z124.string().nullable().optional(),
  is_teacher: z124.boolean().nullable().default(false).optional(),
  meta: object78({
    isInstructor: z124.boolean().nullable().default(false).optional()
  }).optional(),
  is_test_user: z124.boolean().nullable().default(false).optional(),
  is_private: z124.boolean().nullable().default(false).optional(),
  address: z124.object({
    street: z124.string().nullable().optional(),
    city: z124.string().nullable().optional(),
    state: z124.string().nullable().optional(),
    zip: z124.string().nullable().optional(),
    country: z124.string().nullable().optional()
  }).nullable().optional(),
  socials: z124.object({
    facebook: z124.string().nullable().optional(),
    instagram: z124.string().nullable().optional(),
    youtube: z124.string().nullable().optional(),
    twitter: z124.string().nullable().optional(),
    linkedin: z124.string().nullable().optional(),
    tiktok: z124.string().nullable().optional()
  }).nullable().optional(),
  username: z124.string().nullable().optional(),
  user_uuid: z124.string(),
  mention_id: z124.string().uuid().nullable().optional(),
  access_group_members: z124.array(AccessGroupMemberSchema).optional(),
  // Reuses the canonical per-app subscription map; `Subscription` and
  // `SubscriptionAddon` already accept snake_case via top-level preprocess.
  subscription: ProfileSubscriptionSchema,
  access: UserAccessMapSchema.optional(),
  user_access: array14(object78({
    app: string59(),
    role: z124.object({
      id: z124.number(),
      name: z124.string(),
      role_permissions: z124.array(z124.object({
        permissions: z124.object({
          id: z124.number(),
          name: z124.string()
        }).nullable()
      })).optional()
    })
  })).optional()
});
var SupabaseProfileSchema = SupabaseRowProfileSchema.transform((values) => {
  var _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const _a5 = values, { id: id2, name, avatar, email, timezone, subscription, access_group_members, access, user_access } = _a5, rest = __objRest(_a5, ["id", "name", "avatar", "email", "timezone", "subscription", "access_group_members", "access", "user_access"]);
  const buildAccessEntry = /* @__PURE__ */ __name((r) => {
    var _a6, _b2;
    const permissions = (_b2 = (_a6 = r.role.role_permissions) == null ? void 0 : _a6.flatMap((rp) => rp.permissions ? [
      rp.permissions
    ] : [])) != null ? _b2 : [];
    return {
      roleId: r.role.id,
      roleName: r.role.name,
      permissions
    };
  }, "buildAccessEntry");
  const resolvedAccess = user_access && user_access.length > 0 ? Object.fromEntries(user_access.map((r) => [
    r.app,
    buildAccessEntry(r)
  ])) : access;
  return {
    id: id2,
    userId: id2,
    userid: rest.userid,
    subscriptionType: rest.subscriptionType,
    name,
    avatar,
    email,
    timezone,
    subscription,
    firstName: rest.first_name,
    lastName: rest.last_name,
    displayName: rest.display_name,
    authUserId: rest.auth_user_id,
    createdAt: rest.created_at,
    updatedAt: rest.updated_at,
    userRoles: (_b = rest.user_roles) != null ? _b : [],
    isManagement: ((_c = rest.user_roles) != null ? _c : []).some((r) => MANAGEMENT_ROLES.includes(r)),
    lastCheckIn: rest.last_check_in,
    isTimezoneSet: rest.is_timezone_set,
    occupation: (_d = rest.occupation) != null ? _d : null,
    bio: (_e = rest.bio) != null ? _e : null,
    primaryLanguage: (_f = rest.primary_language) != null ? _f : null,
    phoneNumber: (_g = rest.phone_number) != null ? _g : null,
    zoomEmail: (_h = rest.zoom_email) != null ? _h : null,
    isTeacher: (_i = rest.is_teacher) != null ? _i : false,
    meta: (_j = rest.meta) != null ? _j : {
      isInstructor: false
    },
    isTestUser: (_k = rest.is_test_user) != null ? _k : false,
    address: (_l = rest.address) != null ? _l : {
      street: null,
      city: null,
      state: null,
      zip: null,
      country: null
    },
    socials: (_m = rest.socials) != null ? _m : {
      facebook: null,
      instagram: null,
      youtube: null,
      twitter: null,
      linkedin: null,
      tiktok: null
    },
    isPrivate: (_n = rest.is_private) != null ? _n : false,
    username: (_o = rest.username) != null ? _o : "",
    userUUID: rest.user_uuid,
    mentionId: (_p = rest.mention_id) != null ? _p : null,
    accessGroups: (access_group_members != null ? access_group_members : []).map((m) => {
      var _a6;
      return {
        accessGroup: {
          id: m.access_groups.id,
          name: m.access_groups.name
        },
        role: {
          id: m.role.id,
          name: m.role.name
        },
        permissions: ((_a6 = m.role.role_permissions) != null ? _a6 : []).map((rp) => rp.permissions)
      };
    }),
    access: resolvedAccess
  };
});
var ProfileSchema = object78({
  id: coerce58.string().min(1),
  userId: coerce58.string().min(1),
  userid: string59().min(1).optional(),
  subscriptionType: array14(string59()).optional(),
  firstName: string59().optional(),
  lastName: string59().optional(),
  name: string59(),
  displayName: string59().optional(),
  avatar: string59().nullable(),
  email: string59(),
  timezone: timezoneSchema,
  subscription: ProfileSubscriptionSchema,
  authUserId: string59(),
  createdAt: string59(),
  updatedAt: string59(),
  userRoles: array14(string59()),
  isManagement: z124.boolean(),
  lastCheckIn: string59().or(z124.instanceof(Date)).or(CustomLuxonDateSchema).optional(),
  isTimezoneSet: z124.boolean(),
  occupation: string59().nullable(),
  bio: string59().nullable(),
  primaryLanguage: string59().nullable(),
  phoneNumber: string59().nullable(),
  zoomEmail: string59().nullable(),
  isTeacher: z124.boolean(),
  meta: ProfileMetaSchema,
  isTestUser: z124.boolean(),
  address: z124.object({
    city: string59().nullable().optional(),
    country: string59().nullable().optional()
  }),
  socials: z124.object({
    facebook: string59().nullable().optional(),
    instagram: string59().nullable().optional()
  }),
  isPrivate: z124.boolean(),
  username: string59().nullable(),
  userUUID: string59().uuid(),
  mentionId: string59().uuid().nullable(),
  accessGroups: array14(AccessGroupItemSchema),
  access: UserAccessMapSchema.optional()
});
var SupabaseMentionableProfileRowSchema = z124.object({
  id: z124.coerce.string(),
  mention_id: z124.string().uuid().nullable().optional(),
  display_name: z124.string().nullable().optional(),
  name: z124.string().nullable().optional(),
  avatar: z124.string().nullable().optional(),
  is_private: z124.boolean().nullable().optional(),
  subscription: z124.record(z124.unknown()).nullable().optional()
});
var SupabaseMentionableProfileSchema = SupabaseMentionableProfileRowSchema.transform((row) => {
  var _a5, _b, _c, _d, _e, _f;
  return {
    id: row.id,
    mentionId: (_a5 = row.mention_id) != null ? _a5 : null,
    displayName: (_b = row.display_name) != null ? _b : null,
    name: (_c = row.name) != null ? _c : null,
    avatar: (_d = row.avatar) != null ? _d : null,
    isPrivate: (_e = row.is_private) != null ? _e : false,
    subscription: (_f = row.subscription) != null ? _f : {}
  };
});

// src/supabase/teacher-public-profile.ts
import { z as z125 } from "zod";
var TeacherPublicProfileSchema = z125.object({
  id: z125.coerce.string(),
  name: z125.string(),
  displayName: z125.string().nullable().optional(),
  firstName: z125.string().nullable().optional(),
  lastName: z125.string().nullable().optional(),
  avatar: z125.string().nullable().optional(),
  primaryLanguage: z125.string().nullable().optional(),
  city: z125.string().nullable().optional(),
  country: z125.string().nullable().optional(),
  socials: z125.object({
    facebook: z125.string().nullable().optional(),
    instagram: z125.string().nullable().optional(),
    youtube: z125.string().nullable().optional(),
    twitter: z125.string().nullable().optional(),
    linkedin: z125.string().nullable().optional(),
    tiktok: z125.string().nullable().optional()
  }).nullable().optional(),
  bio: z125.string().nullable().optional(),
  profession: z125.array(z125.string()).default([]),
  companyName: z125.string().nullable().optional(),
  companyEmail: z125.string().nullable().optional(),
  professionalWebsite: z125.string().nullable().optional(),
  offerings: z125.array(z125.string()).default([]),
  teachingFormat: TeachingFormatSchema.nullable().optional(),
  expertise: z125.array(z125.string()).default([]),
  languagesTaught: z125.array(z125.string()).default([]),
  casualImage: z125.string().nullable().optional()
});
var TeacherDirectoryPaginationSchema = z125.object({
  totalItems: z125.number().int().nonnegative(),
  totalPages: z125.number().int().nonnegative(),
  currentPage: z125.number().int().positive(),
  perPage: z125.number().int().positive()
});
var TeacherDirectoryListResponseSchema = z125.object({
  data: z125.array(TeacherPublicProfileSchema),
  pagination: TeacherDirectoryPaginationSchema
});
var TEACHER_DIRECTORY_DEFAULT_PAGE = 1;
var TEACHER_DIRECTORY_DEFAULT_PER_PAGE = 20;
var TEACHER_DIRECTORY_MAX_PER_PAGE = 100;
var ListTeachersQuerySchema = z125.object({
  page: z125.coerce.number().int().positive().default(TEACHER_DIRECTORY_DEFAULT_PAGE),
  perPage: z125.coerce.number().int().positive().max(TEACHER_DIRECTORY_MAX_PER_PAGE).default(TEACHER_DIRECTORY_DEFAULT_PER_PAGE)
});
var SearchTeachersQuerySchema = ListTeachersQuerySchema.extend({
  q: z125.string().min(1, 'Query "q" is required').max(200)
});

// src/ryc/user-management/user-type.ts
var SingleUserSchema = z126.object({
  userid: number25(),
  name: string60(),
  avatar: string60(),
  email: string60().email(),
  subscriptionType: AppNameEnumObj.array(),
  subscription: array15(Subscription),
  timezone: timezoneSchema.optional()
});
var SubscribedUserSchema = z126.object({
  userid: z126.string(),
  name: z126.string(),
  avatar: z126.string(),
  email: z126.string().email(),
  subscriptionType: z126.array(AppNameEnumObj),
  subscription: z126.array(Subscription)
});
var UserWatchedAContentSchema = SingleUserSchema.extend({
  createdAt: z126.date()
});
var SubscribedUserResponseSchema = z126.object({
  data: SubscribedUserSchema.array(),
  pagination: object79({
    totalItems: z126.number(),
    totalPages: z126.number(),
    currentPage: z126.number(),
    perPage: z126.number()
  })
});

// src/ryc/user-management/get-users-request.ts
import { coerce as coerce60, object as object81, string as string62 } from "zod";

// src/user-activity/get-users-request.ts
import { coerce as coerce59, object as object80, string as string61, z as z127 } from "zod";
var UserSourceEnum = z127.enum([
  "wordpress",
  "supabase"
]);
var GetUsersRequestBESchema = object80({
  limit: coerce59.number().max(100),
  page: coerce59.number(),
  name: string61().optional().transform((v) => v || void 0),
  email: string61().optional().transform((v) => v || void 0),
  source: UserSourceEnum.default("wordpress")
});

// src/ryc/user-management/get-users-request.ts
var GetSubscribedUsersRequestBESchema = object81({
  tierInfo: coerce60.number().optional(),
  limit: coerce60.number().max(100),
  page: coerce60.number(),
  name: string62().optional(),
  email: string62().optional(),
  source: UserSourceEnum.default("wordpress")
});

// src/ryc/user-management/get-users-assigned-instructors-request.ts
import { array as array16, object as object82, string as string63 } from "zod";
var GetAssignedInstructorsWidthUserIdsBESchema = object82({
  userIds: array16(string63())
});

// src/plan/base.ts
import { number as number26, object as object83, string as string64, z as z128, array as array17, coerce as coerce61 } from "zod";
var PlanItemContent = Content.omit({
  averageRating: true,
  publishedDate: true,
  type: true
}).extend({
  type: z128.union([
    RYCContentMetaTypeEnumObject,
    ContentTypeEnumObj
  ])
});
var Plan = object83({
  id: coerce61.string(),
  classCount: number26().default(0).optional(),
  name: string64()
});
var SinglePlan = Plan.extend({
  contents: array17(Content)
});
var PlanItem = object83({
  id: number26(),
  order: number26().int().positive(),
  day: coerce61.number().int().positive(),
  content: PlanItemContent.optional(),
  isRestDay: z128.boolean().optional()
});
var PlanItemReorder = object83({
  id: number26().optional(),
  order: number26().int().positive(),
  day: number26().int().positive(),
  contentId: string64().optional(),
  isRestDay: z128.boolean().optional()
});
var PlanResponseSchema = Plan.extend({
  items: PlanItem.array()
});
var PlansResponseSchema = object83({
  items: Plan.array(),
  meta: object83({
    total: z128.number().int().nonnegative(),
    page: z128.number().int().positive(),
    perPage: z128.number().int().positive(),
    totalPages: z128.number().int().nonnegative()
  })
});

// src/plan/fe-schema.ts
import { array as array18 } from "zod";
var CreatePlanSchemaFE = Plan.omit({
  id: true,
  classCount: true
}).extend({
  items: array18(PlanItem)
});
var defaultPlanSchemaValues = {
  name: "",
  items: []
};

// src/plan/be-schema.ts
import { coerce as coerce62, z as z129 } from "zod";
var CreatePlanSchemaBE = CreatePlanSchemaFE.extend({
  items: PlanItemReorder.array()
});
var CreatePlanRequestSchemaBE = CreatePlanSchemaBE.extend({
  userId: coerce62.string().min(1)
});
var PlanItemsRequestSchemaFE = z129.object({
  id: coerce62.number().int().positive(),
  items: PlanItemReorder.array()
});
var UpdatePlanRequestSchemaFE = CreatePlanSchemaFE.merge(PlanItemsRequestSchemaFE);

// src/user-activity/base.ts
import { object as object84, string as string65 } from "zod";
var UserSchema = object84({
  userid: string65(),
  name: string65(),
  email: string65()
});

// src/user-activity/user-activity-type.enum.ts
import { z as z130 } from "zod";
var UserActivitiesTypeValues = [
  "USER_ACTIVITY",
  "USER_INFORMATION",
  "PURCHASE_HISTORY",
  "VIDEO_WATCHED",
  "CHECK_IN",
  "TROPHIES",
  "SIMULATION"
];
var UserActivitiesTypeObj = z130.enum(UserActivitiesTypeValues);
var UserActivitiesTypeEnum = UserActivitiesTypeObj.enum;

// src/user-activity/time-period-filter.enum.ts
import { z as z131 } from "zod";
var TimePeriodEnumValues = [
  "WEEK",
  "MONTH",
  "YEAR"
];
var TimePeriodEnumObj = z131.enum(TimePeriodEnumValues);
var TimePeriodEnum = TimePeriodEnumObj.enum;

// src/user-activity/manual-complete-content.request.ts
import { object as object85, string as string66 } from "zod";
var ManualCompleteContentRequestSchema = object85({
  userId: string66(),
  contentId: string66()
});

// src/user-activity/query.ts
import { coerce as coerce63, object as object86, z as z132 } from "zod";
var UserActivityQuerySchema = object86({
  page: coerce63.number().int().positive().default(1),
  perPage: coerce63.number().int().positive().default(15),
  excludeTypes: z132.preprocess((val) => typeof val === "string" ? val.split(",") : val, z132.array(UserActivityTypeEnumObject).optional())
});

// src/user-progress/base.ts
import { coerce as coerce64, object as object87 } from "zod";
var UserTotalWatchedByCategory = object87({
  strength: coerce64.number(),
  flow: coerce64.number(),
  cardio: coerce64.number(),
  restore: coerce64.number()
});
var AddonUserTotalWatchedByCategory = object87({
  introduction: coerce64.number(),
  exercise: coerce64.number(),
  workout: coerce64.number(),
  foundation: coerce64.number()
});
var BaseFitUserProgressSchema = object87({
  totalCompletedClasses: coerce64.number(),
  totalWatchedMin: coerce64.number(),
  activeDays: coerce64.number(),
  watchedCategory: UserTotalWatchedByCategory
});
var BaseAddonUserProgressSchema = object87({
  totalCompletedClasses: coerce64.number(),
  totalWatchedMin: coerce64.number(),
  activeDays: coerce64.number(),
  watchedCategory: AddonUserTotalWatchedByCategory
});

// src/user-progress/get-watch-history-date.ts
import { coerce as coerce65, z as z133 } from "zod";
var UserWatchHistoryDates = z133.array(coerce65.string());

// src/class-of-the-day-theme/base.ts
import { number as number27, object as object88, string as string67, array as array19, coerce as coerce66 } from "zod";
var contentSchema = FITContent.omit({
  averageRating: true
});
var ClassOfTheDayTheme = object88({
  id: coerce66.string(),
  title: string67().min(1),
  description: string67().optional(),
  month: number27().int().min(1).max(12),
  year: number27().int().min(2e3).max(2100),
  buttonLabel: string67().nullable()
});
var SingleContentSchedule = ClassOfTheDayTheme.extend({
  contents: array19(FITContent)
});
var ContentScheduleItemWithContent = object88({
  id: number27(),
  day: coerce66.number().int().positive(),
  content: contentSchema
});
var ContentScheduleItem = object88({
  id: number27().optional(),
  day: coerce66.number().int().positive(),
  contentId: string67().optional()
});
var ContentScheduleResponseSchema = ClassOfTheDayTheme.extend({
  items: ContentScheduleItemWithContent.array()
});

// src/class-of-the-day-theme/fe-schema.ts
import { array as array20 } from "zod";
var ClassOfTheDayThemeSchemaFE = ClassOfTheDayTheme.omit({
  id: true
}).extend({
  items: array20(ContentScheduleItemWithContent)
});
var currentDate = /* @__PURE__ */ new Date();
var defaultClassOfTheDayThemeSchemaValues = {
  title: "",
  description: "",
  items: [],
  buttonLabel: null,
  month: currentDate.getMonth() + 1,
  year: currentDate.getFullYear()
};

// src/class-of-the-day-theme/be-schema.ts
import { coerce as coerce67, object as object89, string as string68 } from "zod";
var CODPayloadItem = object89({
  contentId: string68(),
  day: coerce67.number().int().positive()
});
var CreateCODThemeSchemaBE = ClassOfTheDayTheme.omit({
  id: true
}).merge(object89({
  items: CODPayloadItem.array()
}));
var UpdateCODThemeSchemaBE = ClassOfTheDayTheme.merge(object89({
  items: CODPayloadItem.array()
}));

// src/ws-url.ts
import { string as string69 } from "zod";
var WsUrl = string69().refine((url) => url.startsWith("//") || /^wss?:\/\//.test(url) || /^https?:\/\//.test(url), {
  message: "Must be a valid URL or protocol-relative URL (//host)"
});

// src/user-meta/get-user-ids-request.ts
import { array as array21, object as object90, string as string70 } from "zod";
var GetUserIdsBESchema = object90({
  userIds: array21(string70())
});

// src/version.ts
import { z as z134 } from "zod";
var VersionInfoSchema = z134.object({
  timestamp: z134.number(),
  buildDate: z134.string(),
  version: z134.string()
});

// src/user-management/update-timezone.schema.ts
import { object as object91, string as string71 } from "zod";
var UpdateTimezoneSchema = object91({
  timezone: string71().min(1, "Timezone is required").refine((tz) => {
    try {
      Intl.DateTimeFormat(void 0, {
        timeZone: tz
      });
      return true;
    } catch (e) {
      return false;
    }
  }, {
    message: "Invalid IANA timezone"
  })
});

// src/search/global-search.schema.ts
import { array as array22, number as number28, object as object92, string as string72 } from "zod";
var GlobalSearchRequestSchema = object92({
  q: string72().min(2)
});
var SearchContentItemSchema = object92({
  id: string72(),
  title: string72(),
  instructorName: string72().nullable().optional(),
  banner: string72().nullable().optional(),
  duration: number28()
});
var SearchContentSchema = object92({
  contents: array22(SearchContentItemSchema),
  total: number28()
});
var SearchTextItemSchema = object92({
  id: string72(),
  title: string72(),
  videoCount: number28()
});
var SearchCategoryItemSchema = object92({
  name: string72()
});
var SearchInstructorItemSchema = object92({
  id: string72(),
  name: string72(),
  avatar: string72().nullable().optional()
});
var GlobalSearchResultSchema = object92({
  content: SearchContentSchema,
  playlists: array22(SearchTextItemSchema),
  series: array22(SearchTextItemSchema),
  categories: array22(SearchCategoryItemSchema),
  instructors: array22(SearchInstructorItemSchema)
});

// src/billing/index.ts
import { z as z135 } from "zod";
var GetOrdersSchema = z135.object({
  page: z135.coerce.number().int().positive().default(1),
  perPage: z135.coerce.number().int().positive().default(10)
});
var OrderProductSchema = z135.object({
  productId: z135.number(),
  productName: z135.string(),
  price: z135.number(),
  quantity: z135.number()
});
var OrderSchema = z135.object({
  orderNo: z135.number(),
  date: z135.string(),
  status: z135.string(),
  paymentUrl: z135.string().url().nullable().optional(),
  products: z135.array(OrderProductSchema),
  subtotal: z135.number(),
  discount: z135.number(),
  total: z135.number(),
  currency: z135.string()
});
var OrdersResponseSchema = z135.object({
  totalPages: z135.number(),
  page: z135.number(),
  perPage: z135.number(),
  total: z135.number(),
  items: z135.array(OrderSchema)
});
var BillingSubscriptionSchema = z135.object({
  subscriptionNo: z135.number(),
  status: z135.string(),
  nextPaymentOn: z135.string(),
  products: z135.array(OrderProductSchema),
  subtotal: z135.number(),
  discount: z135.number(),
  total: z135.number(),
  currency: z135.string(),
  orderIds: z135.array(z135.number())
});
var SubscriptionsResponseSchema = z135.object({
  totalPages: z135.number(),
  page: z135.number(),
  perPage: z135.number(),
  total: z135.number(),
  items: z135.array(BillingSubscriptionSchema)
});
var PaymentPlanSchema = z135.object({
  paymentPlanId: z135.number(),
  status: z135.string(),
  nextPaymentOn: z135.string(),
  products: z135.array(OrderProductSchema),
  subtotal: z135.number(),
  discount: z135.number(),
  total: z135.number(),
  currency: z135.string(),
  orderIds: z135.array(z135.number())
});
var PaymentPlansResponseSchema = z135.object({
  totalPages: z135.number(),
  page: z135.number(),
  perPage: z135.number(),
  total: z135.number(),
  items: z135.array(PaymentPlanSchema)
});

// src/upload/index.ts
import { z as z137 } from "zod";

// src/media/base.ts
import { z as z136, coerce as coerce68 } from "zod";
var EMediaFileStatus = /* @__PURE__ */ function(EMediaFileStatus2) {
  EMediaFileStatus2["ACTIVE"] = "active";
  EMediaFileStatus2["SOFT_DELETED"] = "soft_deleted";
  EMediaFileStatus2["PROCESSING"] = "processing";
  EMediaFileStatus2["FAILED"] = "failed";
  return EMediaFileStatus2;
}({});
var EImageVariant = /* @__PURE__ */ function(EImageVariant2) {
  EImageVariant2["w400"] = "w400";
  EImageVariant2["w1070"] = "w1070";
  EImageVariant2["w800"] = "w800";
  EImageVariant2["w1200"] = "w1200";
  EImageVariant2["w2400"] = "w2400";
  EImageVariant2["original"] = "original";
  return EImageVariant2;
}({});
var MediaCdnUrlsSchema = z136.record(z136.nativeEnum(EImageVariant), z136.string());
var MediaFileBaseSchema = z136.object({
  id: z136.string().uuid(),
  userId: z136.string().max(36),
  originalName: z136.string().max(255),
  cdnUrls: MediaCdnUrlsSchema,
  mimeType: z136.string().max(100),
  sizeBytes: coerce68.number().int(),
  altText: z136.string().max(500).nullable().optional(),
  status: z136.nativeEnum(EMediaFileStatus).default("active"),
  isSystem: z136.boolean().default(false),
  createdAt: z136.date().or(z136.string()),
  updatedAt: z136.date().or(z136.string()),
  deletedAt: z136.date().or(z136.string()).nullable().optional()
});
var CreateMediaFileSchema = z136.object({
  originalName: z136.string().min(1).max(255),
  cdnUrls: MediaCdnUrlsSchema,
  mimeType: z136.string().min(1).max(100),
  sizeBytes: z136.number().int().positive(),
  altText: z136.string().max(500).nullable().optional(),
  isSystem: z136.boolean().optional().default(false)
});
var UpdateMediaFileSchema = z136.object({
  altText: z136.string().max(500).nullable().optional(),
  status: z136.nativeEnum(EMediaFileStatus).optional()
});
var MediaFileFiltersSchema = z136.object({
  mimeType: z136.string().optional(),
  status: z136.nativeEnum(EMediaFileStatus).optional(),
  isSystem: CoerceBoolean.optional(),
  page: coerce68.number().int().min(1).optional().default(1),
  limit: coerce68.number().int().min(1).max(100).optional().default(24)
});
var MediaFilePageSchema = z136.object({
  data: z136.array(MediaFileBaseSchema),
  total: z136.number().int(),
  page: z136.number().int(),
  limit: z136.number().int()
});
var MediaMonthlyStatSchema = z136.object({
  month: z136.string(),
  count: z136.number().int(),
  totalBytes: z136.number()
});
var MediaUserStatsSchema = z136.object({
  totalCount: z136.number().int(),
  totalBytes: z136.number(),
  monthly: z136.array(MediaMonthlyStatSchema)
});

// src/upload/index.ts
var PresignedUploadResultSchema = z137.object({
  uploadUrl: z137.string(),
  publicUrl: z137.string().nullable()
});
var UploadedFileSchema = z137.object({
  key: z137.string(),
  publicUrl: z137.string().nullable(),
  /** All available size variant URLs. Undefined for files uploaded before multi-size support. */
  cdnUrls: z137.record(z137.nativeEnum(EImageVariant), z137.string()).optional(),
  filename: z137.string(),
  size: z137.number(),
  lastModified: z137.date().or(z137.string()),
  mimeType: z137.string()
});

// src/addon/content/be-schema.ts
import { coerce as coerce69, object as object93, string as string73, z as z138 } from "zod";
var AddonCreateContentSchemaBEBase = object93({
  app: AppNameEnumObj,
  id: string73().optional(),
  name: string73().min(3, "name is required"),
  category: AddonCategoryEnumObj,
  type: ContentTypeEnumObj,
  status: StatusEnumObj,
  equipments: object93({
    id: coerce69.number().min(1, "id is required")
  }).array().min(1, "Please select at least one equipment"),
  instructor: object93({
    id: coerce69.string().min(1, "Please select instructor")
  }),
  video: VimeoVideo.extend({
    duration: coerce69.number().min(1, "duration is required")
  }),
  isAllowComment: coerce69.boolean().default(false),
  publishedDate: z138.string().or(CustomLuxonDateSchema).optional().nullable(),
  favorite: CoerceBoolean.optional().default(false)
});
var AddonCreateContentSchemaBE = AddonCreateContentSchemaBEBase.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var AddonUpdateContentSchemaBE = AddonCreateContentSchemaBEBase.partial();

// src/addon/content/fe-schema.ts
import { coerce as coerce70, lazy as lazy12, object as object94, z as z139 } from "zod";
var AddonContent = Content.extend({
  category: AddonCategoryEnumObj
});
var AddonAllStatusContentSchema = AllStatusContentSchema.extend({
  category: AddonCategoryEnumObj
});
var AddonTrashContentSchema = TrashContentSchema.extend({
  category: AddonCategoryEnumObj
});
var AddonContentAndTrashContentUnion = z139.union([
  AddonContent,
  AddonTrashContentSchema
]);
var AddonContentWithRatingFlagSchema = ContentWithRatingFlagSchema.extend({
  category: AddonCategoryEnumObj
});
var AddonContentFindAllResponseSchema = object94({
  items: AddonContentWithRatingFlagSchema.array(),
  meta: object94({
    page: coerce70.number(),
    perPage: coerce70.number(),
    total: coerce70.number(),
    totalPages: coerce70.number()
  })
});
var AddonDashboardCreateContentSchemaFEWithoutValidation = CreateContentSchemaFEWithoutValidation.extend({
  category: lazy12(() => CategoryEnumObj.or(AddonCategoryEnumObj))
});
var AddonDashboardCreateContentSchemaFE = AddonDashboardCreateContentSchemaFEWithoutValidation.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var AddonDashboardUpdateContentSchemaFE = AddonDashboardCreateContentSchemaFEWithoutValidation.partial();
var DashboardCreateContentSchemaFE = AddonDashboardCreateContentSchemaFE;
var DashboardCreateContentSchemaFEWithoutValidation = AddonDashboardCreateContentSchemaFEWithoutValidation;
var DashboardUpdateContentSchemaFE = AddonDashboardUpdateContentSchemaFE;

// src/addon/program/base.ts
var Program = Series;
var SingleProgram = SingleSeries;
var ProgramResponseSchema = SeriesResponseSchema;

// src/addon/program/fe-schema.ts
var CreateProgramSchemaFE = CreateSeriesSchemaFE;
var defaultProgramSchemaValues = defaultSeriesSchemaValues;

// src/addon/program/be-schema.ts
var CreateProgramSchemaBE = CreateSeriesSchemaBE;
var CreateProgramRequestSchemaBE = CreateSeriesRequestSchemaBE;
var UpdateAddonProgramRequestSchemaFE = UpdateAddonSeriesRequestSchemaFE;
export {
  AUTH_PROVIDER_HEADER,
  AcceptSpaceTermsSchema,
  AccessConfigEntrySchema,
  AccessConfigRoleSchema,
  AccessGroupBaseSchema,
  AccessGroupItemSchema,
  AccessGroupMemberBaseSchema,
  AccessGroupStatus,
  AccessGroupStatusSchema,
  AddMemberSchema,
  AddPermissionToRoleSchema,
  AddonAllStatusContentSchema,
  AddonCategoryEnum,
  AddonCategoryEnumObj,
  AddonCategoryEnumValues,
  AddonContent,
  AddonContentAndTrashContentUnion,
  AddonContentBaseSchema,
  AddonContentFindAllResponseSchema,
  AddonContentTypeObject,
  AddonContentWithRatingFlagSchema,
  AddonCreateContentSchemaBE,
  AddonDashboardCreateContentSchemaFE,
  AddonDashboardCreateContentSchemaFEWithoutValidation,
  AddonDashboardUpdateContentSchemaFE,
  AddonTrashContentSchema,
  AddonUpdateContentSchemaBE,
  AddonUserTotalWatchedByCategory,
  AdminCommentRowSchema,
  AdminReplyDtoSchema,
  AdminSetPasswordSchema,
  AfterPurchaseRequestDtoBe,
  AllStatusContentSchema,
  AppKeySchema,
  AppNameEnumObj,
  AppNameValues,
  AppSpaceNameEnumObj,
  AppSpaceNameValues,
  ArticleStatusEnumObj,
  ArticleStatusValues,
  AttachmentSchema,
  AttemptStatus,
  AttemptStatusSchema,
  AuthExceptionEnumObj,
  AuthExceptionValues,
  AuthProviderEnum,
  AuthProviderEnumObj,
  AuthorInfoSchema,
  BadgeMetaSchemaBE,
  BadgeNameEnum,
  BadgeSchema,
  BadgeTypeArray,
  BadgeTypeEnumObject,
  BadgeTypeNameSchema,
  BadgeWeightEnum,
  BadgesResponseSchema,
  BareContent,
  BaseAddonUserProgressSchema,
  BaseCommentSchema,
  BaseEventSchema,
  BaseFitChallengeContentSchema,
  BaseFitChallengeSchema,
  BaseFitOnboardingSchema,
  BaseFitUserProgressSchema,
  BaseHelpCenterArticleSchema,
  BaseJournalSchema,
  BaseJourneySchema,
  BaseOnboardingSchema,
  BaseRYCContentSchema,
  BaseRYCContentWitMetaInformation,
  BaseRuleConditionSchema,
  BaseSettingSchema,
  BaseSlideshowSchema,
  BaseSlideshowSchemaWithoutUnion,
  BaseStepContentSchema,
  BaseStepContentSchemaWithContentInfo,
  BaseStepDaySchema,
  BaseStepDayWithContentsSchema,
  BaseStepSchema,
  BaseStepSchemaWithBonusVideos,
  BaseStepSchemaWithContents,
  BaseTaxonomySchema,
  BaseTopicTaxonomySchema,
  BaseUserProgressSchema,
  BaseUserSchema,
  BasicRuleSchema,
  BillingSubscriptionSchema,
  BonusSchemaWithContent,
  BulkNotificationBatchStatusSchema,
  CODPayloadItem,
  COMMUNITY_UPDATES_MAX_ITEMS,
  CalendarStateResponse,
  CategoryEnum,
  CategoryEnumObj,
  CategoryEnumValues,
  ChCommentReactionConditionSchema,
  ChCommentReplyConditionSchema,
  ChMentionConditionSchema,
  ChNewPostConditionSchema,
  ChPostCommentConditionSchema,
  ChPostReactionConditionSchema,
  ChallengeBadgeNameArray,
  ChallengeBadgeNameEnumObject,
  ChallengeBadgeSchema,
  ChallengeBannerSettingSchema,
  ChallengeCompletionStatusSchema,
  ChallengePageSettingSchema,
  ChangePasswordApiSchema,
  ChangePasswordSchema,
  CheckInSchema,
  ClassOfTheDayTheme,
  ClassOfTheDayThemeSchemaFE,
  CoerceBoolean,
  CommentAttachmentSchema,
  CommentBaseSchema,
  CommentSchema,
  CommentStatus,
  CommentStatusSchema,
  CommentWithAuthorBaseSchema,
  CommentWithAuthorSchema,
  CommentWithRepliesSchema,
  CommentsResponseSchema,
  CommonContentFields,
  CommonCustomDateSchema,
  CommunityActivityResponseSchema,
  CommunityActivitySchema,
  CommunityActivityTypeEnum,
  CommunityUpdatesEventPattern,
  CommunityUpdatesNamespace,
  CompleteContentActionEnumObject,
  CompleteContentRequestSchema,
  Constants,
  ConsumeOttSchema,
  ContactFormSettingSchema,
  ContactFormSettingSchemaBE,
  ContactFormSettingSchemaFE,
  Content,
  ContentAndTrashContentUnion,
  ContentBlockBaseSchema,
  ContentBlockContentCategory,
  ContentBlockContentCategorySchema,
  ContentBlockResourceType,
  ContentBlockResourceTypeSchema,
  ContentBlockType,
  ContentBlockTypeSchema,
  ContentByDate,
  ContentByDateResponseSchema,
  ContentFilterTypeEnum,
  ContentFilterTypeObj,
  ContentFilterTypeValues,
  ContentFindAllResponseSchema,
  ContentFindByIdsResponseSchema,
  ContentRating,
  ContentRatingResponse,
  ContentRequestBESchema,
  ContentRequestSchema,
  ContentResponseSchema,
  ContentScheduleItem,
  ContentScheduleItemWithContent,
  ContentScheduleResponseSchema,
  ContentTypeEnum,
  ContentTypeEnumObj,
  ContentTypeEnumValues,
  ContentWithRatingFlagSchema,
  ContentWithWatchedDate,
  ConversationBaseSchema,
  ConversationType,
  ConversationTypeSchema,
  CreateAccessGroupSchema,
  CreateArticleSchemaBE,
  CreateBadgeSchema,
  CreateBulkNotificationResponseSchema,
  CreateBulkNotificationSchema,
  CreateCODThemeSchemaBE,
  CreateChallengeBadgeSchema,
  CreateCommentDtoSchema,
  CreateCommentSchema,
  CreateContentBasicSchemaFE,
  CreateContentBlockSchema,
  CreateContentSchemaBE,
  CreateContentSchemaFE,
  CreateContentSchemaFEWithoutValidation,
  CreateContentVideoSchemaFE,
  CreateConversationSchema,
  CreateEventSchemaBE,
  CreateEventSchemaFE,
  CreateFeatureSeriesContentSchemaBE,
  CreateFeatureSeriesContentSchemaFE,
  CreateFeatureSeriesSchemaBE,
  CreateFeatureSeriesSchemaFE,
  CreateFitChallengeSchemaBE,
  CreateFitChallengeSchemaFE,
  CreateFitOnboardingSchemaBE,
  CreateFitOnboardingStepSchemaBE,
  CreateFormOptionSchema,
  CreateFormQuestionGroupSchema,
  CreateFormQuestionSchema,
  CreateFormSchema,
  CreateHelpCenterArticleSchemaBE,
  CreateHelpCenterCategoryTaxonomySchemaBE,
  CreateHelpCenterTopicTaxonomySchemaBE,
  CreateInstructionSchema,
  CreateJournalSchemaBE,
  CreateLessonCategorySchema,
  CreateLessonSchema,
  CreateMediaFileSchema,
  CreateMilestoneBadgeSchema,
  CreateNotificationRuleSchemaBE,
  CreateOnboardingSchemaBE,
  CreateOnboardingStepSchemaBE,
  CreateOnboardingVideoSchemaBE,
  CreateOptionSchema,
  CreatePermissionSchema,
  CreatePlanRequestSchemaBE,
  CreatePlanSchemaBE,
  CreatePlanSchemaFE,
  CreatePlaylistBeRequestSchema,
  CreatePlaylistRequestSchema,
  CreatePlaylistSchema,
  CreatePostSchema,
  CreateProductSchema,
  CreateProgramRequestSchemaBE,
  CreateProgramSchemaBE,
  CreateProgramSchemaFE,
  CreatePurchaseLogSchemaBE,
  CreateQuestionSchema,
  CreateQuizSchema,
  CreateRYCContentRequestWithMetaSchema,
  CreateRYCContentSchemaBE,
  CreateRYCContentSchemaFE,
  CreateRYCContentWithMetaSchemaBE,
  CreateReportSchema,
  CreateRoleSchema,
  CreateSeriesRequestSchemaBE,
  CreateSeriesSchemaBE,
  CreateSeriesSchemaFE,
  CreateSlideshowSchemaFE,
  CreateSpaceSchema,
  CreateStepSchemaFE,
  CreateSubSpaceSchema,
  CreateTemplateSchema,
  CreateTermsSchema,
  CreateUserLogSchemaBE,
  CreateUserSchema,
  CreateWatchHistoryBeSchema,
  CronNotificationEventTypeValues,
  CurrentJourneyFiltersSchema,
  CustomDateTimeSchema,
  CustomLuxonDateSchema,
  CustomNotificationConditionSchema,
  DEFAULT_AUTH_PROVIDER,
  DashboardCreateContentSchemaFE,
  DashboardCreateContentSchemaFEWithoutValidation,
  DashboardUpdateContentSchemaFE,
  DateRangeQuerySchema,
  DeleteContentFromPlaylistBeRequestSchema,
  DeleteContentFromPlaylistRequestSchema,
  DeleteWatchHistoryBeSchema,
  DownloadPdfRequestBESchema,
  EAddonContentType,
  EAppNameEnum,
  EAppSpaceNameEnum,
  EArticleStatus,
  EAuthExceptionEnum,
  EAuthType,
  EBadgeType,
  EChallengeBadgeName,
  ECompleteContentAction,
  EEmailSentReason,
  EEmailSentStatus,
  EEventTypeEnum,
  EFitChallengeContentType,
  EFitOnboardingStep,
  EFormType,
  EHelpCenterAppNameEnum,
  EImageVariant,
  EImmediateAfterPurchaseSchema,
  EMediaFileStatus,
  EMilestoneBadgeName,
  ENotificationChannel,
  ENotificationRuleStatus,
  ENotificationRulesType,
  ENotificationStatus,
  ENotificationType,
  ENovuEmailTemplateNameEnum,
  ENovuTenantIdentifierEnum,
  ENovuWorkflowsEnum,
  EOnboardingStep,
  EProfileFieldKind,
  EPurchaseStatusEnum,
  EQuestionInputType,
  EQuipmentEnum,
  EQuipmentObj,
  ERYCContentMetaSeries,
  ERYCContentMetaType,
  ERYCContentPath,
  ERYCContentType,
  ERealtimeNotificationMessageType,
  ERolesEnum,
  ESlideBadgeImagePositionEnum,
  ESlideshowAppEnum,
  ESlideshowTypeEnum,
  EStagesEnum,
  EStepTypeEnum,
  EStepsEnum,
  ETargetApp,
  ETiersEnum,
  EUserActivityTypeEnum,
  EUserLogActionEnum,
  EUserOnlinePubSub,
  EUserOnlineTopicEnum,
  EmailLoginSchema,
  EmailMetaSchema,
  EmailResponse,
  EmailReturnResponse,
  EmailSendReasonObj,
  EmailSentReasonValues,
  EmailSentStatusObj,
  EmailSentStatusValues,
  EnumRuleConditionJsonColumnObject,
  Equipment,
  EquipmentsValues,
  ErrorSchema,
  EventContentSchema,
  EventMessagePayloadSchema,
  EventMessageSchema,
  EventMessageSchemaWithReplies,
  EventMessageUserInfoSchema,
  EventReactionSchema,
  EventStatusEnum,
  EventStatusEnumObj,
  EventStatusEnumValues,
  EventTypeObj,
  EventTypeValues,
  ExportAdminCommentsDtoSchema,
  FEATURE_FLAGS_STORAGE_KEY,
  FITBareContent,
  FITCommonContentFields,
  FITContent,
  FITContentAndTrashContentUnion,
  FITContentByDate,
  FITContentByDateResponseSchema,
  FITContentFindAllResponseSchema,
  FITContentResponseSchema,
  FITContentWithRatingFlagSchema,
  FITContentWithWatchedDate,
  FITDashboardCreateContentSchemaFE,
  FITDashboardCreateContentSchemaFEWithoutValidation,
  FITDashboardUpdateContentSchemaFE,
  FITDateRangeQuerySchema,
  FITTrashContentSchema,
  FITUserContentRatingResponse,
  FITWatchedFilterEnum,
  FITWatchedStatusEnumObj,
  FITWatchedStatusEnumValues,
  FeaturedSeriesSettingSchema,
  FeedSpaceItemSchema,
  FindAllByContentIdBeSchema,
  FindAllWatchHistoryBeSchema,
  FindOneUserLogSchemaBe,
  FindOneWatchHistoryBeSchema,
  FindUserLogSchemaBe,
  FindVideoTagsRequestSchema,
  FitChallengeContentTypeEnumObject,
  FitChallengeContentTypeValues,
  FitChallengeMaintainedBySchema,
  FitCommentLikeConditionSchema,
  FitCommentMentionConditionSchema,
  FitInstructorCommentConditionSchema,
  FitOnboardingStepEnumObject,
  FitOnboardingStepSchema,
  FitOnboardingStepValues,
  FitVideoCommentConditionSchema,
  FitWelcomeConditionSchema,
  ForgotPasswordSchema,
  FormAnalyticsSchema,
  FormAnalyticsSubmissionByDateSchema,
  FormAnalyticsUserSchema,
  FormBaseSchema,
  FormQuestionGroupSchema,
  FormStatus,
  FormStatusSchema,
  FormTypeSchema,
  FromToDateORSchema,
  GCS_MEDIA_TYPE_PRESETS,
  GcsAllowedMediaType,
  GcsAllowedMediaTypeSchema,
  GcsUploadReportRowSchema,
  GcsUploadRowSchema,
  GcsUploadStatus,
  GcsUploadStatusSchema,
  GenerateOttSchema,
  GenerateOttUserSchema,
  GenerateSubscriberIdWithTenantSchema,
  GetActivityDatesByMonthBeSchema,
  GetAdminCommentsDtoSchema,
  GetAssignedInstructorsWidthUserIdsBESchema,
  GetBadgesQuerySchema,
  GetCommentsDtoSchema,
  GetContentRatingsSchema,
  GetContentsByCommentsDateRangeSchema,
  GetEventAttendeesSchemaBe,
  GetFavoriteContentBeRequestSchema,
  GetNotificationLogsRequestSchema,
  GetNotificationLogsResponseSchema,
  GetNotificationUsersRequestBESchema,
  GetOrdersSchema,
  GetPlaylistsBeRequestSchema,
  GetPlaylistsRequestSchema,
  GetSinglePlaylistBeRequestSchema,
  GetSinglePlaylistRequestSchema,
  GetSubscribedUsersRequestBESchema,
  GetUserBadgesParamsSchema,
  GetUserIdsBESchema,
  GetUsersRequestBESchema,
  GlobalCacheKeyEnum,
  GlobalSearchRequestSchema,
  GlobalSearchResultSchema,
  GlobalSettingBEResponseSchema,
  GlobalSettingsSchema,
  GlobalSettingsTypeEnum,
  GlobalSettingsTypeEnumObj,
  GlobalSettingsTypeEnumValues,
  GlobalSettingsValue,
  GrantReason,
  GrantReasonSchema,
  HeartbeatResponseSchema,
  HelpCenterAppNameEnumObj,
  HelpCenterAppNameValues,
  HelpCenterArticle,
  HelpCenterArticleCategory,
  HelpCenterArticleCreationPayloadSchema,
  HelpCenterArticleDetails,
  HelpCenterArticleSearchResponse,
  HelpCenterArticleTopic,
  HelpCenterArticleTopicWithCategory,
  HelpCenterArticlesFiltersSchema,
  InactivityRuleConditionJsonSchemaBE,
  IndicateorsEnumValues,
  IndicatorEnum,
  IndicatorsEnumObj,
  InsertContentInPlaylistBeRequestSchema,
  InsertContentInPlaylistRequestSchema,
  Instructor,
  InstructorProfilePictureSchema,
  InstructorRequestSchema,
  InstructorTypeEnum,
  InstructorTypeEnumObj,
  InstructorTypeEnumValues,
  InstructorsByIdsRequestSchema,
  JournalEntryDatesRequestSchema,
  JourneyAlreadyClaimedBonusValues,
  JourneyFiltersSchema,
  JourneyUserActivitiesSchema,
  JourniesUserActivitiesSchema,
  JwtExceptionEnumObj,
  LC_SSO_CONTEXT_QUERY,
  LC_SSO_CONTEXT_VALUE,
  LeaderBoardRequestSchema,
  LeaderBoardSchema,
  LeaderBoardTypeEnum,
  LeaderBoardTypeEnumObj,
  LeaderBoardTypeEnumValues,
  LessonBaseSchema,
  LessonCategoryBaseSchema,
  LessonColorScheme,
  LessonColorSchemeSchema,
  LessonProgressBaseSchema,
  LessonProgressStatus,
  LessonProgressStatusSchema,
  LessonRefSchema,
  LessonStatus,
  LessonStatusSchema,
  LikeResponseSchema,
  ListTeachersQuerySchema,
  LoginSchema,
  MANAGEMENT_ROLES,
  MAPPABLE_PROFILE_FIELDS,
  MagicLinkEmailSchema,
  MagicLinkLoginConditionSchema,
  ManualCompleteContentRequestSchema,
  MarkAsReadSchema,
  MarkNotificationsAsReadSchema,
  MediaCdnUrlsSchema,
  MediaFileBaseSchema,
  MediaFileFiltersSchema,
  MediaFilePageSchema,
  MediaMonthlyStatSchema,
  MediaTypeEnum,
  MediaTypeEnumObj,
  MediaTypeEnumValues,
  MediaUserStatsSchema,
  MemberStatus,
  MemberStatusSchema,
  MembersLoginSchema,
  MentionUserCacheSchema,
  MentionUserSchema,
  MessageBaseSchema,
  MessageType,
  MessageTypeSchema,
  MetaSchema,
  MilestoneBadgeNameArray,
  MilestoneBadgeNameEnumObject,
  MilestoneBadgeSchema,
  ModuleProgressSchema,
  MovePlaylistContentRequestSchema,
  MovePlaylistContentRequestSchemaBE,
  NotificationChannelEnumObject,
  NotificationChannelValues,
  NotificationFindAllRequestQuerySchema,
  NotificationLogFindAllRequestQuerySchema,
  NotificationLogMetadataSchema,
  NotificationLogResponseSchemaBE,
  NotificationLogSchema,
  NotificationRuleResponseSchemaBE,
  NotificationRuleSchema,
  NotificationRuleSchemaBE,
  NotificationRuleStatusEnumObject,
  NotificationRulesTypeEnumObject,
  NotificationStatusEnumObject,
  NotificationTemplateSchemaBE,
  NotificationType,
  NotificationTypeEnumObject,
  NotificationTypeSchema,
  NotificationTypeValues,
  NovuEmailTemplateNameEnumObject,
  NovuEmailTemplateNameValues,
  NovuTenantIdentifierEnumObject,
  NovuTenantIdentifierValues,
  NovuWorkflowTemplateSchema,
  NovuWorkflowValues,
  NovuWorkflowsEnumObject,
  OnboardingSettingSchema,
  OnboardingSettingSchemaBE,
  OnboardingSettingSchemaFE,
  OnboardingStepEnumObject,
  OnboardingStepSchema,
  OnboardingStepValues,
  OnboardingVideoSchema,
  OnlineUserSchema,
  OnlineUsersResponseSchema,
  OrderProductSchema,
  OrderSchema,
  OrdersResponseSchema,
  PasswordChangeConditionSchema,
  PasswordResetConditionSchema,
  PaymentPlanSchema,
  PaymentPlansResponseSchema,
  PermissionBaseSchema,
  PermissionWithUsageSchema,
  Permissions,
  Plan,
  PlanItem,
  PlanItemContent,
  PlanItemReorder,
  PlanItemsRequestSchemaFE,
  PlanResponseSchema,
  PlanTypeEnum,
  PlanTypeObj,
  PlanTypeValues,
  PlansResponseSchema,
  Playlist,
  PlaylistFormSchema,
  PlaylistItem,
  PlaylistItemReorder,
  PlaylistResponseSchema,
  PlaylistSettingsSchema,
  PlaylistStatusEnum,
  PlaylistStatusEnumObj,
  PlaylistStatusEnumValues,
  PlaylistTypeEnum,
  PlaylistTypeObj,
  PlaylistTypeValues,
  PlaylistsResponseSchema,
  PostAttachmentSchema,
  PostBaseSchema,
  PostStatus,
  PostStatusSchema,
  PostType,
  PostTypeSchema,
  PostWithAuthorSchema,
  PresignedUploadResultSchema,
  ProductFiltersSchema,
  ProductSchema,
  ProfileFieldKeySchema,
  ProfileFormSchema,
  ProfileMetaSchema,
  ProfilePicture,
  ProfileSchema,
  ProfileSubscriptionSchema,
  Program,
  ProgramResponseSchema,
  PubSubEventsEnum,
  PubSubEventsEnumObj,
  PubSubEventsEnumValues,
  PurchaseRequestSchema,
  PurchaseStatusEnum,
  QuestionInputTypeSchema,
  QuestionType,
  QuestionTypeSchema,
  QuizBaseSchema,
  QuizStatus,
  QuizStatusSchema,
  REACTION_EMOJIS,
  RYCContent,
  RYCContentCategoryResponseSchema,
  RYCContentCategorySchema,
  RYCContentMeTypeEnumValues,
  RYCContentMetaInformationBaseSchema,
  RYCContentMetaInfromationSchema,
  RYCContentMetaSeriesEnumObject,
  RYCContentMetaSeriesEnumValues,
  RYCContentMetaTypeEnumObject,
  RYCContentPathEnumObject,
  RYCContentPathValues,
  RYCContentRequestBESchema,
  RYCContentTypeEnumObject,
  RYCContentTypeValues,
  RYCDashboardCreateContentSchemaFE,
  RYCDashboardCreateContentSchemaFEWithoutValidation,
  RYCDashboardUpdateContentSchemaFE,
  RYCJournalRequestBESchema,
  RateContentSchema,
  RatingIndicator,
  ReactToEventMessageSchema,
  ReactionBaseSchema,
  ReactionTargetType,
  ReactionTargetTypeSchema,
  RealTimeNotificationEventTypeValues,
  RealtimeNotificationBePayloadSchemaBE,
  RealtimeNotificationMessageTypeEnumObject,
  RealtimeNotificationMessageTypeValues,
  RefreshTokenSchema,
  RemovePlaylistBeRequestSchema,
  RemovePlaylistRequestSchema,
  ReorderPlaylistRequestSchema,
  ReorderPlaylistRequestSchemaBE,
  RepliesSchema,
  RequestMagicLinkSchema,
  RequestSchema,
  ResetPasswordSchema,
  ResetPasswordSearchParamsSchema,
  RoleBaseSchema,
  RoleValues,
  RoleWithPermissionsSchema,
  RolesEnumObj,
  RuleConditionJsonColumnObject,
  RuleConditionJsonColumnValues,
  RuleConditionJsonSchemaBE,
  RuleConditionTypeSchema,
  RuleEvaluationRequestSchema,
  RuleEvaluationResponseSchema,
  RuleMatchResultSchema,
  SSO_CONTEXT_PARAM,
  SaveFormProgressSchema,
  SearchCategoryItemSchema,
  SearchContentItemSchema,
  SearchInstructorItemSchema,
  SearchTeachersQuerySchema,
  SearchTextItemSchema,
  SelectBonusContentRequestSchema,
  SelectElectiveContentsSchema,
  SendEmailSchema,
  SendEventMessageRequestSchema,
  SendMessageSchema,
  SendPasswordResetSchema,
  SendStepAndDayCompletionSchema,
  SendTransactionalEmailSchema,
  Series,
  SeriesItemsRequestSchemaFE,
  SeriesResponseSchema,
  SeriesTypeEnum,
  SeriesTypeObj,
  SeriesTypeValues,
  ServiceResponseDescriminatedUnionSchema,
  ServiceResponseErrorSchema,
  SetPasswordWithTokenSchema,
  SetPasswordWithWpTokenSchema,
  SettingBEResponseSchema,
  SettingsSchema,
  SettingsTypeEnum,
  SettingsTypeEnumObj,
  SettingsTypeEnumValues,
  SingleContentSchedule,
  SinglePlan,
  SingleProgram,
  SingleSeries,
  SingleUserSchema,
  SkipJournalSchemaBE,
  SlideBadgeImagePositionEnumObj,
  SlideBadgeImagePositionValues,
  SlideBadgeSchema,
  SlideshowAppEnumObj,
  SlideshowAppValues,
  SlideshowFiltersSchema,
  SlideshowTypeEnumObj,
  SlideshowTypeValues,
  SocketEventTypeEnum,
  SocketEventTypeEnumObj,
  SocketEventTypeEnumValues,
  SpaceBaseSchema,
  SpaceRefSchema,
  SpaceStatus,
  SpaceStatusSchema,
  SpaceSubscriptionItem,
  SpaceType,
  SpaceTypeSchema,
  SpacesSubscription,
  Stages,
  StagesEnumObject,
  StartGcsUploadResultSchema,
  StartGcsUploadSchema,
  StatusEnum,
  StatusEnumObj,
  StatusEnumValues,
  StepType,
  StepTypeEnumObject,
  Steps,
  StepsEnumObject,
  StringToBooleanSchema,
  SubmissionStatus,
  SubmissionStatusSchema,
  SubmitAnswerSchema,
  SubmitFormAnswerSchema,
  SubmitFormSchema,
  SubmitQuizAttemptSchema,
  SubscribedUserResponseSchema,
  SubscribedUserSchema,
  Subscription,
  SubscriptionAddon,
  SubscriptionObjectSchema,
  SubscriptionsResponseSchema,
  SupabaseLoginSchema,
  SupabaseMentionableProfileRowSchema,
  SupabaseMentionableProfileSchema,
  SupabaseProfileSchema,
  SupabaseRowProfileSchema,
  TargetAppEnum,
  TeacherDirectoryListResponseSchema,
  TeacherDirectoryPaginationSchema,
  TeacherDirectoryRowSchema,
  TeacherDirectorySchema,
  TeacherPublicProfileSchema,
  TeachingFormatSchema,
  TemplateResponseSchema,
  TemplateVariables,
  TermsAcceptanceResponseSchema,
  TermsBaseSchema,
  TierValues,
  TiersEnumObject,
  TimePeriodEnum,
  TimePeriodEnumObj,
  TimePeriodEnumValues,
  TodaysWorkoutSchemaFE,
  ToggleReactionSchema,
  ToggleRejectDtoSchema,
  TrashContentSchema,
  TrashContentVimeoVideo,
  USER_ONLINE_REDIS_CHANNEL,
  USE_SUPABASE_AUTH_FLAG_KEY,
  UnsignedIDSchema,
  UpcomingLiveBannerSettingSchema,
  UpcomingLiveBannerSettingSchemaBE,
  UpcomingLiveBannerSettingSchemaFE,
  UpdateAccessGroupSchema,
  UpdateAddonProgramRequestSchemaFE,
  UpdateAddonSeriesRequestSchemaFE,
  UpdateCODThemeSchemaBE,
  UpdateCommentDtoSchema,
  UpdateCommentSchema,
  UpdateContentBlockSchema,
  UpdateContentScheduleSettingsFE,
  UpdateContentScheduleSettingsSchemaBE,
  UpdateContentSchemaBE,
  UpdateContentSchemaFE,
  UpdateEventSchemaBE,
  UpdateEventSchemaFE,
  UpdateFitOnboardingStepSchemaBE,
  UpdateFormOptionSchema,
  UpdateFormQuestionGroupSchema,
  UpdateFormQuestionSchema,
  UpdateFormSchema,
  UpdateHelpCenterArticleSchemaBE,
  UpdateHelpCenterCategoryTaxonomySchemaBE,
  UpdateHelpCenterTopicTaxonomySchemaBE,
  UpdateInstructionSchema,
  UpdateLessonCategorySchema,
  UpdateLessonSchema,
  UpdateMediaFileSchema,
  UpdateMemberRoleSchema,
  UpdateMemberStatusSchema,
  UpdateMessageSchema,
  UpdateNotificationPreferencesSchema,
  UpdateNotificationRuleSchemaBE,
  UpdateOnboardingStepVideoWatchedSchemaBE,
  UpdateOptionSchema,
  UpdatePermissionSchema,
  UpdatePlanRequestSchemaFE,
  UpdatePlaylistBeRequestSchema,
  UpdatePlaylistRequestSchema,
  UpdatePlaylistSchema,
  UpdatePostSchema,
  UpdateProfileSchema,
  UpdateProgressSchema,
  UpdateQuestionSchema,
  UpdateQuizSchema,
  UpdateRYCContentRequestWithMetaSchema,
  UpdateRYCContentSchemaBE,
  UpdateRYCContentWithMetaSchemaBE,
  UpdateReportStatusSchema,
  UpdateRoleSchema,
  UpdateSeriesRequestSchemaFE,
  UpdateSlideshowSchemaFE,
  UpdateSpaceSchema,
  UpdateStepContentSchemaBE,
  UpdateStepContentSchemaFE,
  UpdateStepContentsSchemaBE,
  UpdateStepDaySchemaBE,
  UpdateStepSchemaBE,
  UpdateStepSchemaFE,
  UpdateTeacherDirectorySchema,
  UpdateTermsSchema,
  UpdateTimezoneSchema,
  UpdateUserPrivacyBESchema,
  UpdateUserSchema,
  UpdateWatchHistoryBeSchema,
  UploadedFileSchema,
  UserAccessItemSchema,
  UserAccessMapSchema,
  UserAccessPermissionSchema,
  UserActivitiesTypeEnum,
  UserActivitiesTypeObj,
  UserActivitiesTypeValues,
  UserActivityItemSchema,
  UserActivityQuerySchema,
  UserActivitySchema,
  UserActivityTypeEnumObject,
  UserActivityTypeValues,
  UserCheckInSchemaBe,
  UserContentRatingResponse,
  UserDataSchema,
  UserDayChangeSchemaBe,
  UserJwtSchema,
  UserLastCheckInSchemaBe,
  UserLogActionEnumObj,
  UserLogBaseSchema,
  UserLogBaseSchemaWithFullContent,
  UserLogFilterDtoBe,
  UserManageItemTypeEnum,
  UserManageItemTypeObj,
  UserManageItemTypeValues,
  UserMetaSchema,
  UserOnlineLastWatchedContentSchema,
  UserOnlineNamespace,
  UserOnlinePubSubSchema,
  UserOnlinePubSubSchemaStringifiedSchema,
  UserOnlinePubSubValues,
  UserOnlineTopicEnumObject,
  UserOnlineTopicValues,
  UserPrivacyRedisSchemaBE,
  UserPrivacySchemaBE,
  UserResponseSchema,
  UserSchema,
  UserSourceEnum,
  UserTotalWatchedByCategory,
  UserWatchHistoryDates,
  UserWatchedAContentSchema,
  ValidateOttSchema,
  VersionInfoSchema,
  VideoProviderEnum,
  VideoProviderEnumObj,
  VideoProviderEnumValues,
  VimeoVideo,
  WPJwtSchema,
  WPSubscriptionArraySchema,
  WatchHistoryBaseSchema,
  WatchedFilterEnum,
  WatchedStatusEnumObj,
  WatchedStatusEnumValues,
  WelcomeNotificationPayloadSchemaBE,
  WpLoginSchema,
  WpUserSchema,
  WsUrl,
  YouMayLikeRequestFilterSchema,
  contentFilterDefaultValues,
  contentFilterEmptyDefaultValues,
  defaultBadgeMetaValuesBE,
  defaultClassOfTheDayThemeSchemaValues,
  defaultContactFormSettingValues,
  defaultContentSchemaValues,
  defaultEventSchemaValues,
  defaultFeatureSeriesContentValues,
  defaultFitChallengeValues,
  defaultHelpCenterSchemaValues,
  defaultOnboardingSettingValues,
  defaultPlanSchemaValues,
  defaultProgramSchemaValues,
  defaultRYCContentSchemaValues,
  defaultSeriesSchemaValues,
  defaultSettingsValues,
  defaultSlideshowSchemaValues,
  defaultUpcomingLiveBannerSettingValues,
  getAcceptButtonLabel,
  getAcceptCheckboxLabel,
  getDropdownOptions,
  getMappableProfileFieldsForQuestionType,
  getProfileFieldByKey,
  getQuestionAnswerShape,
  getQuestionInputType,
  instructionSchema,
  isGcsFileAllowed,
  isQuestionTypeMappableToFieldKind,
  isQuestionTypeMappableToProfileFieldKey,
  isShortAnswerValueValid,
  parseAllowedMediaTypes,
  parseGcsFilenamePrefix,
  rycContentFilterDefaultValues,
  rycJournalFilterDefaultValues,
  sanitizeAppName,
  stringifyUserOnlinePubSubSchema,
  timezoneSchema,
  transformSubscriptionArrayToObject,
  validateComment,
  validateCommentsResponse,
  validateCreateComment,
  validateGetComments,
  validateGetContentsByCommentsDateRange,
  validateLikeResponse,
  validateRuleConditions,
  validateUpdateComment
};
//# sourceMappingURL=index.mjs.map